export default {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Escrime XXI N⁰. 114",
    "shortTitle": "",
    "description": "",
    "width": 1532,
    "height": 1149,
    "currentLanguage": "ES",
    "languages": [{
            code: "EN",
            text: "English",
            href: "http://escrime-xxi.fie.org/114/en"
        },
        {
            code: "FR",
            text: "French",
            href: "http://escrime-xxi.fie.org/114/fr"
        },
        {
            code: "ES",
            text: "German",
            href: "http://escrime-xxi.fie.org/114/es"
        }
    ],
    "basePath": "/114/es",
    // "basePath": "",
    "companyLogo": "1-numeral.png",
    "publishURL": "http://escrime-xxi.fie.org/114/es/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
        "doublePage": false,
        "rightToLeft": false,
        "searchEnabled": true,
        "downloadEnabled": false,
        "downloadPath": '',
        "printEnabled": false,
        "zoomEnabled": true,
        "contentsEnabled": true,
        "languagesEnabled": true,
        "mobileSwitch": true,
        "guideEnabled": false,
        "galleryCaptions": {},
    },
    "pages": [
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 0,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg1.jpg",
            "zoom": null,
            content: `
        <img id="1-0" class="halfScale" style="top:0px;left:378px" src="/114/es/static/_content/1-numeral.png">
        
        <img id="1-1" class="halfScale" style="top:110px;left:0px" src="/114/es/static/_content/1-title.png">
        <img id="1-2" class="halfScale" style="top:275px;left:68px" src="/114/es/static/_content/1-sub-1.png">

        <img id="1-3" class="halfScale" style="top:109px;left:1075px" src="/114/es/static/_content/1-issue.png">

        <img id="1-text-1" class="halfScaleR" style="top:475px;right:125px" src="/114/es/static/_content/1-sub-2.png">

        <img id="1-4" class="halfScale pointer" style="top:988px;left:1442px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/1-arrow.png">

        `,
            script: `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim
          .fromTo(idOf("1-1"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)
          .fromTo(idOf("1-0"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},"-=0.2")
          .fromTo(idOf("1-2"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},"-=0.2")
          .fromTo(idOf("1-3"), 0.5, {y: 30, opacity:0}, {y: 0, opacity:1},"-=0.2")
          .fromTo(idOf("1-text-1"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, "-=0.2")
          .fromTo(idOf("1-4"), 0.5, {x:-60, opacity:0}, {x:0, opacity:1})
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
            searchText: "",
            mobileHtml: `
        <img src="/114/es/static/_mobile/pg1.jpg">
        `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 1,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg2.jpg",
            "zoom": null,
            "content": `
        <img class="halfScale 2-title" style="top:108px;left:81px" src="/114/es/static/_content/2-title.png">

        <img class="halfScale 2-icons" style="top:863px;left:157px" src="/114/es/static/_content/2-pop.png">
        <img class="halfScale 2-icons" style="top:864px;left:459px" src="/114/es/static/_content/2-play.png">
        <img class="halfScale 2-icons" style="top:864px;left:828px" src="/114/es/static/_content/2-soc.png">
        <img class="halfScale 2-icons" style="top:864px;left:1152px" src="/114/es/static/_content/2-no.png">

        <img class="halfScale pointer howto-desktop" style="top:125px;left:1074px;opacity:1;" onclick="switchPopHowto(true)" src="/114/es/static/_content/2-desktop-btn.png">
        <img class="halfScale pointer howto-ipad" style="top:125px;left:1275px;opacity:0" onclick="switchPopHowto(false)" src="/114/es/static/_content/2-ipad-btn.png">

        <img class="halfScale howto-desktop" style="top:266px;left:85px;" src="/114/es/static/_content/2-desktop.png">
        <img class="halfScale howto-ipad" style="top:248px;left:85px;display:none;" src="/114/es/static/_content/2-ipad.png">

        <a href="http://www.fie.org" target="_blank">
            <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
      `,
            "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax()
          pg2Anim.fromTo(cOf("2-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .staggerFromTo(cOf("2-icons"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, onComplete: addContentLinks}, 0.3, "-=0.2")
        }

        function switchPopHowto(bool){
          if(bool){
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-ipad")[0].style.opacity = 0;
              cOf("howto-ipad")[1].style.display = "none";
            }});
            cOf("howto-desktop")[0].style.opacity = 1;
            cOf("howto-desktop")[1].style.display = "block";
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
          }else{
            cOf("howto-ipad")[0].style.opacity = 1;
            cOf("howto-ipad")[1].style.display = "block";
            TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
            TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
              cOf("howto-desktop")[0].style.opacity = 0;
              cOf("howto-desktop")[1].style.display = "none";
            }});
          }
        }

        function onPageLeave() {
          pg2Anim.stop()
          removeContentLinks()
        }
      `,
            "searchText": "INSTRUC CIONES DE USO  Haga clic para cambiar la vista  INSTRUCCIONES DE USO  IPAD  ESCRITORIO  Escrime XXI  La revista de esgrima utiliza la última tecnología digital. Presentamos algunas características de uso para disfrutar de la publicación.  ESGRIMISTAS  NICK  ITKIN  Navegación  «  Para ver la revista, utilice las flechas del teclado para desplazarse a la izquierda y a la derecha por toda la publicación.  EXPLORAR Utilice las flechas del teclado para desplazarse horizontalmente por la revista  ESTOY EMPEZANDO A AMAR EL DEPORTE CADA VEZ MÁS  »  EXPLORADOR DE INTERNET Para obtener los mejores resultados, recomendamos el uso de Safari o Google Chrome.  EXPLORAR  r… Zonas interactivas en el interio  1 2 3 ELEMENTOS EMERGENTES  BOTÓN DE REPRODUCCIÓN  REDES SOCIALES  NÚMEROS  Pulse para mostrar u ocultar retazos de información.  En esta revista encontrará vídeos fantásticos. Pulse este botón para disfrutar de ellos.  Pulse los iconos de las redes sociales que encontrará por toda la revista.  Pulse los botones para mostrar más contenidos apasionantes.  W W W.FIE .ORG"
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 2,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg3.jpg",
            "zoom": null,
            "content": ``,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/pg3.jpg">
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 3,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg4.jpg",
            "zoom": null,
            "content": `

        <a href="http://www.fie.org" target="_blank">
            <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <div class="addContentLink" style="top: 191px; left:80px;width:145px; height: 35px;">
          <a href="http://www.fie.org" target="_blank"></a></div>

        <div class="addContentLink" style="top: 82px; right:627px;width:44px; height: 43px;">
          <a href="https://www.facebook.com/fie.org" target="_blank"></a></div>

        <div class="addContentLink" style="top:131px; right:626px;width:45px; height: 43px;">
          <a href="https://twitter.com/FIE_fencing" target="_blank"></a></div>

        <img id="4-title" class="halfScale" style="top:61px;left:86px" src="/114/es/static/_content/4-title.png">

        <img id="fourIpad" class="cont-item-0-link halfScale" style="top:386px;left:591px" src="/114/es/static/_content/4-ipad.png">
        <img class="cont-item cont-item-1-btn halfScale" style="top:327.7px;left:574px;opacity:0" src="/114/es/static/_content/4-editorial.png">
        <img class="cont-item cont-item-2-btn halfScale" style="top:266px;left:574px;opacity:0" src="/114/es/static/_content/4-fie.png">
        <img class="cont-item cont-item-3-btn halfScale" style="top:266px;left:574px;opacity:0" src="/114/es/static/_content/4-fencers.png">
        <img class="cont-item cont-item-4-btn halfScale" style="top:266.5px;left:574px;opacity:0" src="/114/es/static/_content/4-comp-1.png">
        <img class="cont-item cont-item-8-btn halfScale" style="top:251px;left:574px;opacity:0" src="/114/es/static/_content/4-comp-2.png">
        <img class="cont-item cont-item-5-btn halfScale" style="top:266px;left:574px;opacity:0" src="/114/es/static/_content/4-fie-news.png">
        <img class="cont-item cont-item-6-btn halfScale" style="top:328px;left:574px;opacity:0" src="/114/es/static/_content/4-news.png">
        <img class="cont-item cont-item-7-btn halfScale" style="top:328px;left:574px;opacity:0" src="/114/es/static/_content/4-obituaries.png">

        <img class="halfScale pointer 4-pages-1" style="top:1003px;left:850px;opacity:0;" src="/114/es/static/_content/4-comp-btn-1.png">
        <img class="halfScale pointer 4-pages-2" style="top:1003px;left:1035px;opacity:0" src="/114/es/static/_content/4-comp-btn-2.png">

        <img id="4-next" class="halfScale pointer" style="top:940px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/4-arrow.png">

        <div class="addContentLink" onclick="contentsBub(1);" style="top:358px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(2);" style="top:450px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(3);" style="top:543px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(4);" style="top:635px; left:84px; width: 492px; height: 60px;"></div>
        <div class="contentLink 4-click-1" onclick="contentsBub(4);" style="top:1003px; left:850px; width: 179px; height: 60px;opacity:none"></div>
        <div class="contentLink 4-click-2" onclick="contentsBub(8);" style="top:1003px; left:1034px; width: 179px; height: 60px;display:none"></div>
        <div class="addContentLink" onclick="contentsBub(5);" style="top:727px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(6);" style="top:819px; left:84px; width: 492px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(7);" style="top:911px; left:84px; width: 492px; height: 60px;"></div>

        <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)" style="top:357px;left:630px;width:587px;height:64px;display:none;"></div>

        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)" style="top:449px;left:630px;width:738px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)" style="top:541px;left:630px;width:738px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)" style="top:633px;left:630px;width:738px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)" style="top:725px;left:630px;width:738px;height:64px;display:none;"></div>

        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(9)" style="top:357px;left:630px;width:543px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(11)" style="top:449px;left:630px;width:543px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(13)" style="top:541px;left:630px;width:543px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(16)" style="top:634px;left:630px;width:543px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(17)" style="top:724px;left:630px;width:543px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(20)" style="top:818px;left:630px;width:543px;height:64px;display:none;"></div>

        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(26)" style="top:266px;left:650px;width:566px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(28)" style="top:339px;left:650px;width:566px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(30)" style="top:413px;left:650px;width:566px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(32)" style="top:486px;left:650px;width:566px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(35)" style="top:560px;left:650px;width:566px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(38)" style="top:633px;left:650px;width:566px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(41)" style="top:708px;left:650px;width:566px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(44)" style="top:783px;left:650px;width:566px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(46)" style="top:857px;left:650px;width:566px;height:64px;display:none;"></div>

        <div class="contentLink cont-item-8-link" onclick="Publish.goToPage(51)" style="top:266px;left:650px;width:601px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-8-link" onclick="Publish.goToPage(53)" style="top:339px;left:650px;width:601px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-8-link" onclick="Publish.goToPage(55)" style="top:413px;left:650px;width:601px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-8-link" onclick="Publish.goToPage(57)" style="top:486px;left:650px;width:601px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-8-link" onclick="Publish.goToPage(59)" style="top:560px;left:650px;width:601px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-8-link" onclick="Publish.goToPage(61)" style="top:633px;left:650px;width:601px;height:64px;display:none;"></div>

        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(65)" style="top:633px;left:646px;width:685px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(68)" style="top:725px;left:646px;width:685px;height:64px;display:none;"></div>

        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(70)" style="top:726px;left:630px;width:726px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(70)" style="top:817px;left:630px;width:726px;height:64px;display:none;"></div>

        <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(72)" style="top:910px;left:576px;width:776px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(72)" style="top:818px;left:576px;width:776px;height:64px;display:none;"></div>
      `,
            "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          
          pg4Anim.fromTo(idOf("4-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)
          .fromTo(idOf("4-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
        }
    
    
        function contentsBub(index){
        
          console.log("contentsBub", index)
          for(var i=0; i <= 8; i++){
            if(i == index){
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                console.log(c)
                c.style.display = "";
              },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:1, onComplete:function(){
                
                classc("cont-item-"+index+"-link")[0].style.display = ""
                if(classc("cont-item-"+index+"-link")[1]){
                  classc("cont-item-"+index+"-link")[1].style.display = "" 
                }
              }});
              if(i == 4){
                cOf("4-pages-1")[0].style.opacity = 1;
                cOf("4-pages-2")[0].style.opacity = 0;
                cOf("4-click-1")[0].style.display = "";
                cOf("4-click-2")[0].style.display = "";
              } else if (i == 8){
                cOf("4-pages-1")[0].style.opacity = 0;
                cOf("4-pages-2")[0].style.opacity = 1;
              } else {
                cOf("4-pages-1")[0].style.opacity = 0;
                cOf("4-pages-2")[0].style.opacity = 0;
                cOf("4-click-1")[0].style.display = "none";
                cOf("4-click-2")[0].style.display = "none";
              }
            }else{
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.display = "none";
                },0);
              TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:0});

            }
          }
        }
    
        function onPageLeave() {
          pg4Anim.stop()
          removeContentLinks();
          contentsBub(0);
          TweenMax.to(idOf('fourIpad'), 0.1, {opacity:1});
        }
      `,
            "searchText": "ÍNDICE  EN ESTE NÚMERO WWW.FIE.ORG  Le damos la bienvenida a la última edición de Escrime XXI, que llega repleta de las mejores imágenes, vídeos y artículos del mundo de la esgrima, y presenta una imagen totalmente fresca y renovada.  EDITORIAL  FIE  Pulse los botones para revelar el contenido  ESGRIMISTAS  DEPORTE NOTICIAS DE LA FIE Y DE LAS FEDERACIÓNES NACIONALES  NOTICIAS  NECROLÓGICAS  W W W.FIE .ORG"
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 4,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg5.jpg",
            "zoom": null,
            "content": `
        <img class="halfScale pointer 5-arrow" style="top:854px;left:1386px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/5-arrow.png">

        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1012px;left:54px" src="/114/es/static/_content/white-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1012px;left:123px" src="/114/es/static/_content/white-facebook.png">
        </a>
        <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:1012px;left:193px" src="/114/es/static/_content/white-yt.png">
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        
        <a href="mailto:info@fie.ch">
          <div class="contentLinkNone" style="bottom:241px;right:692px;width:154px; height:25px;"></div>
        </a>
        <a href="http://www.touchline.com" target="_blank">
          <div class="contentLinkNone" style="bottom:178px;right:307px;width:309px; height:30px;"></div>
        </a>
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:212px;right:746px;width:98px; height:25px;"></div>
        </a>
        `,
            "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax()
          pg5Anim
            .fromTo(cOf("5-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg5Anim.stop()
        }
      `,
            "searchText": "C OMITÉ E JECUTIVO DE L A FIE  Presidente: Alisher Usmanov (RUS) Secretario general: Emmanuel Katsiadakis (M.H.) (GRE) Secretaria tesorera: Ferial Nadira Salhi (ALG)  OFICINA CENTRAL DE LA FIE  Vicepresidentes: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Miembros:  Administración  Directora general Nathalie Rodriguez M.-H. (FRA)  Directora administrativa: Elena Murdaca (ITA) Gestora de contabilidad: Sandra Baroni (SUI) Asistente de dirección: Gabrielle Meylan (BRA) Asistente administrativa: Ylenia Murdaca (ITA) Jefe de operaciones: Elena Huot (RUS)  Erika Aze (LAT) Jacek Bierkowski (POL) Ana Irene Delgado Guerra (PAN) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX)  Deporte  Director técnico y deportivo: Evgeny Tsoukhlo (RUS)  Manager de la tecnología y de la administración del deporte: Natalia Bodrova (RUS) Manager de operaciones del deporte: Sophie Treyvaud (SUI)  Aldo Montano Presidente de la Comisión de Atletas de la FIE (ITA)  Comunicación, Marketing, TV  Presidente de la Confederación Africana de Esgrima: Mbagnick Ndiaye (SEN) Presidente de la Confederación Panamericana de Esgrima: Vitaly Logvin (MEX) Presidente de la Confederación Asiática de Esgrima: Celso L. Dayrit (M.H.) (PHI) Presidente de la Confederación Europea de Esgrima: Stanislav Pozdnyakov (RUS) Presidente de la Confederación Oceánica de Esgrima: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Jefe del gabinete del presidente: Nina Lalovic (SRB)  Manager digital y de comunicaciones: Maria Ntanou (GRE)  Jefe de producción TV de la FIE: Barna Heder (HUN)  Asistente de producción TV de la FIE: Svetlana Krasnokoutskaya (RUS) Encargado de prensa: Serge Timacheff (USA) Fotógrafo: Augusto Bizzi (ITA) Diseño Touchline (www.touchline.com)  W W W.FIE .ORG",
            "mobileHtml": `
        <p>
        <b>President</b>:<br> Alisher Usmanov (RUS)<br>
        <b>Secretary General</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>
        <b>Secretary Treasurer</b>:<br> Ferial Nadira Salhi (ALG)</p>
        <p>
        <b>Vice Presidents</b>:<br>
        Ana Pascu (M.H.) (ROU)<br>
        Donald Anthony (USA)<br>
        Yuki Ota (JPN)<br></p>
        <p>
        <b>Members</b>:<br>
        Erika Aze (LAT)<br>
        Jacek Bierkowski (POL)<br>
        Velichka Hristeva (BUL)<br>
        Isabelle Lamour (FRA)<br>
        Novak Perovic (RSA)<br>
        Oleg Peskov (KAZ)<br>
        Giorgio Scarso (ITA)<br>
        Bence Szabo (HUN)<br>
        Pascal Tesch (LUX)<br>
        Wei WANG (CHN)<br>
        Aldo Montano President of the FIE athletes commission (ITA)<br></p>

        <p>
          <b>President, African Fencing Confederation</b>: <br>Mbagnick Ndiaye (SEN) <br>
          <b>President, Pan-American Fencing Confederation</b>: <br>Vitaly Logvin (MEX) <br>
          <b>President, Asian Fencing Confederation</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>
          <b>President, European Fencing Confederation</b>: <br>Stanislav Pozdnyakov (RUS)<br>
          <b>President, Oceanian Fencing Confederation</b>: <br>Helen Smith (M.H.) (AUS)<br>
        </p>
        
        <h2>FIE Head Office</h2>
        <p>
        <b>Chief Executive Officer</b><br>
        Nathalie Rodriguez M.-H. (FRA)
        </p>

        <h2>Administration</h2>
        <p>
        <b>Administration Director</b>:<br> Elena Murdaca (ITA)<br>
        <b>Accounting Manager</b>:<br> Sandra Baroni (BUL) <br>
        <b>Assistant to the Director</b>:<br> Gabrielle Meylan (BRA)<br>
        <b>Administrative Assistant</b>:<br> Ylenia Murdaca (ITA)<br>
        <b>Head of Operations</b>:<br> Elena Huot (RUS)<br>
        </p>

        <h2>Sport</h2>
        <p>
        <b>Sport and Technical Director</b>:<br> Evgeny Tsoukhlo (RUS)<br>
        <b>Sport Technology and Administration Manager</b>:<br> Natalia Bodrova (RUS)<br>
        <b>Sport Operation Manager</b>:<br>Sophie Treyvaud (SUI) <br>
        </p>
        <h2>Communication, Marketing, TV</h2>
        <p>
        <b>Head of FIE President's Cabinet</b>:<br> Nina Lalovic (SRB)<br>
        <b>Digital Communications Manager</b>:<br> Maria Ntanou (GRE)<br>
        <b>Head of FIE TV Production</b>:<br> Barna Heder (HUN) <br>
        <b>FIE TV Production Assistant</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>
        <b>Press Officer</b>:<br> Serge Timacheff (USA)<br>
        <b>Photographer</b>:<br> Augusto Bizzi (ITA)<br>
        </p>

        <h2>Design</h2>
        <p>
        Touchline </b><br>
        (<a href="http://www.touchline.com" target="blank">www.touchline.com</a>)
        </p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 5,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg6.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.fie.org" target="_blank">
            <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

          <img id="6-img" class="halfScale 6-text-1 6-text" style="top:223px;left:473px" src="/114/es/static/_content/6-img.jpg">
          <img id="6-title" class="halfScale 6-text-1 6-text" style="top:753px;left:77px" src="/114/es/static/_content/6-title.png">

          <img id="6-text-1" class="halfScale 6-text-1 6-text" style="top:217px;left:784px" src="/114/es/static/_content/6-text-1.png">
          <img id="6-text-2" class="halfScale 6-text-2 6-text" style="top:214px;left:201px; opacity:0;" src="/114/es/static/_content/6-text-2.png">

          <img id="6-cta-1" class="halfScale pointer 6-btn" style="top:845px;left:785px" onclick="toggleText6(false);" src="/114/es/static/_content/6-cta-1.png">
          <img id="6-cta-2" class="halfScale pointer 6-btn" style="top:845px;left:1061px;opacity:0" onclick="toggleText6(true);" src="/114/es/static/_content/6-cta-2.png">

          <img id="6-next" class="halfScale pointer" style="top:938px;left:1387px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/6-arrow.png">
        `,
            "script": `
        function onPageEnter(){
          pg6Anim = new TimelineMax();
          pg6Anim.fromTo(idOf("6-img"), 0.5,{opacity:0}, {opacity:1},0.5)
              .fromTo(idOf("6-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},"-=0.2")
              .fromTo(idOf("6-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},"+=0.3")
        }

        function toggleText6(bool){
          var text1 = idOf("6-text-1");
          var text2 = idOf("6-text-2");
          
          if(!bool && text1.style.opacity == "0"){
            pg6Anim.play();
            TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:0}, {opacity:1});
          }else if(bool && text2.style.opacity == "0"){
            pg6Anim.pause();
            TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:0}, {opacity:1});
            TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:1}, {opacity:0});
            TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:1}, {opacity:0});
          }
        }
  
        function onPageLeave(){
          if(idOf("6-text-1").style.opacity == "0"){
            toggleText6(false);
          }
          pg6Anim.stop();
          removeContentLinks()
        }
      `,
            "searchText": "PRÓLO GO  Estimados miembros de la familia de esgrima: Bienvenidos a la última edición de nuestra revista oficial de la FIE.  PONIENDO PRIMERO A LA FAMILIA DE ESGRIMA  Empezamos este año olímpico con grandes esperanzas y expectativas. Desafortunadamente, nos hemos encontrado con una de las mayores amenazas a las que se ha enfrentado el mundo durante décadas. Estamos viendo a nivel mundial el efecto devastador de este asesino invisible, la pandemia global del COVID-19. Estamos viviendo un momento donde el peligro es real. Con los Juegos Olímpicos de Tokio 2020 pospuestos hasta el próximo año, debemos trabajar duro para asegurar primero que nuestra familia de esgrima esté lo más segura y saludable posible. Puedo asegurarles que seguiremos trabajando con nuestras federaciones miembros y haremos todo lo posible para ayudarles y  PÁGINA 1  PÁGINA 2  W W W.FIE .ORG",
            "mobileHtml": `
          <h2>PONIENDO PRIMERO A LA FAMILIA DE ESGRIMA</h2>
          <img src="/114/es/static/_mobile/6-img.jpg">
          <p><b>Estimados miembros de la familia de esgrima: </b></p>
          <p>Bienvenidos a la última edición de nuestra revista oficial de la FIE.</p>
          <p>Empezamos este año olímpico con grandes esperanzas y expectativas. Desafortunadamente, nos hemos encontrado con una de las mayores amenazas a las que se ha enfrentado el mundo durante décadas. Estamos viendo a nivel mundial el efecto devastador de este asesino invisible, la pandemia global del COVID-19. Estamos viviendo un momento donde el peligro es real.  Con los Juegos Olímpicos de Tokio 2020 pospuestos hasta el próximo año, debemos trabajar duro para asegurar primero que nuestra familia de esgrima esté lo más segura y saludable posible. Puedo asegurarles que seguiremos trabajando con nuestras federaciones miembros y haremos todo lo posible para ayudarles y asistir tanto a ellos como a nuestros atletas, árbitros y oficiales en los muchos desafíos que les afectan en esta difícil situación.</p>
          <p>Puede contar con nosotros. Puedes contar conmigo.</p>
          <p>Hemos tomado medidas inmediatas para proteger la vida y la salud de los miembros de nuestra familia de esgrima. Por precaución excepcional para todos nosotros, la FIE tomó la difícil pero esencial decisión de aplazar varios acontecimientos importantes, mientras planificaba activamente el futuro. Junto con las federaciones y los comités organizadores locales, encontraremos respuestas a los principales desafíos, como la reprogramación de los eventos, la garantía de la participación en ferias y, mediante la evaluación diaria de la situación, nos comprometemos a mantenerlos informados sobre otros avances esenciales.</p>
          <p>Esperamos reanudar las competiciones cuando la situación sea segura y nuestras vidas vuelvan a su ritmo normal.</p>
          <p>La esgrima ha superado con éxito muchos obstáculos y, como en el pasado, una vez más nuestros valores, la solidaridad, la unidad y el juego limpio nos llevarán juntos hacia adelante.</p>
          <p>
          Quiero asegurarles personalmente a cada uno de ustedes que el Comité Ejecutivo de la FIE y yo, junto con los que trabajan para la FIE, estamos profundamente comprometidos a hacer todo lo posible para garantizar la seguridad, el bienestar y el éxito de cada esgrimista y de cada federación. Estamos aquí para apoyarlos en los desafíos que todos enfrentamos y en todo lo que quieran lograr en la esgrima. Cuídense y cuiden de su familia, manténgase a salvo. Juntos somos fuertes y juntos ganaremos la batalla.</p>
          <br>
          <p>Alisher Usmanov</p>
          <p><strong>Presidente</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 6,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg7.jpg",
            "zoom": null,
            "content": `
        
        <a href="http://www.absolutefencinggear.com" target="_blank">
          <div class="contentLink" style="top:962px;left:769px;width:719px; height:54px;"></div>
        </a>
        
        `,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "",
            "mobileHtml": `
      
      <a href="http://www.absolutefencinggear.com" target="_blank">
        <img src="/114/es/static/_mobile/pg7.jpg">
      </a>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 7,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg8.jpg",
            "zoom": null,
            "content": `

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <div class="addContentLink" onclick="showOverlay('8-pop-1')" style="bottom:727px;right:1259px;width:130px; height:30px;"></div>
        <div class="addContentLink" onclick="showOverlay('8-pop-2')" style="bottom:528px;right:1023px;width:130px; height:30px;"></div>

        <img id="8-title" class="halfScale" style="top:75px;left:84px" src="/114/es/static/_content/8-title.png">

        <img id="8-next" class="halfScale pointer" style="top:938px;left:1174px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/8-arrow.png">

        <a href="https://video.eurosport.com/fencing/sports-explainer-the-classic-fencing-weapon-the-foil_vid1294133/video.shtml" target="_blank">
          <svg class="abs pulse animatedpulse pointer" style="bottom:558px;left:728px;" width="81.4px" height="81.4px" viewBox="0 0 69.4 67.4">
            <path fill="#000000" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>

        <a href="https://www.youtube.com/watch?v=88mBQ2u2Wb0" target="_blank">
          <svg class="abs pulse animatedpulse pointer" style="bottom:164px;left:390px;" width="64.4px" height="64.4px" viewBox="0 0 69.4 67.4">
            <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>
        

        <div id="8-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img id="" class="halfScale" style="top:0px;left:0px" src="/114/es/static/_content/8-pop-1.jpg">
          <img id="8-text-1" class="halfScale 8-text" style="top:230px;left:172px;opacity:1" src="/114/es/static/_content/8-pop-1-text-1.png">
          <img id="8-text-2" class="halfScale 8-text" style="top:230px;left:172px;opacity:0" src="/114/es/static/_content/8-pop-1-text-2.png">

          <img id="8-cta-1" class="halfScale pointer 8-btn" style="top:911px;left:785px;opacity:1" onclick="pg8Toggle('8-text-1', '8-cta-1');" src="/114/es/static/_content/8-pop-1-cta-1.png">
          <img id="8-cta-2" class="halfScale pointer 8-btn" style="top:911px;left:1062px;opacity:0" onclick="pg8Toggle('8-text-2', '8-cta-2');" src="/114/es/static/_content/8-pop-1-cta-2.png">

          <div class="addContentLink" style="top: 50px; left: 1359px; width: 135px; height: 49px;opacity:0" onclick="hideOverlay('8-pop-1');"></div>
        </div>
        <div id="8-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img id="" class="halfScale" style="top:0px;left:0px" src="/114/es/static/_content/8-pop-2.jpg">
          <a href="https://admin.fie.org/uploads/24/122518-FIE%20Academy%20SA.pdf" target="_blank">
            <div class="contentLinkNone" style="top:460px;left:1036px;width:54px; height:28px;"></div>
          </a>
          <div class="addContentLink" style="top: 50px; left: 1359px; width: 135px; height: 49px;opacity:0" onclick="hideOverlay('8-pop-2');"></div>
        </div>

      `,
            "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
            pg8Anim.fromTo(idOf("8-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)
            .fromTo(idOf("8-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},"+=0.3")
        }

        function pg8Toggle(id, btn) {
          var ele = idOf(id)
          var but = idOf(btn)
          TweenMax.to(cOf("8-text"), 0.1, {opacity: 0});
          TweenMax.to(cOf("8-btn"), 0.1, {opacity: 0});
          TweenMax.to(ele, 0.1, {opacity: 1});
          TweenMax.to(but, 0.1, {opacity: 1});
        }

        function onPageLeave() {
          pg8Anim.stop()
          hideOverlay('8-pop-1');
          hideOverlay('8-pop-2');
            removeContentLinks();
        }
      `,
            "searchText": "FIE  DENTRO DE LA ESGRIMA Entender el deporte  El texto de la fundación de Pierre de Coubertin en el Museo Olímpico  La clásica arma de la esgrima, el «florete»  Ver más aquí.  La Academia de Esgrima de la FIE en Sudáfrica progresa Ver más aquí.  Ver vídeo.  Entender el deporte El preciso arte de la espada  W W W.FIE .ORG",
            "mobileHtml": `
        <h2>DENTRO DE LA ESGRIMA</h2>
        <img src="/114/es/static/_mobile/inside-1.png">
        <h4>El texto de la fundación de Pierre de Coubertin en el Museo Olímpico 
        Ver más aquí.</h4>

        <p>La Academia de Esgrima de la FIE en Sudáfrica progresa 
        Ver más aquí.</p>
        <p>Entender el deporte
        El preciso arte de la espada</p>
        <p>Entender el deporte
        La clásica arma de la esgrima, el «florete»</p>
        <h4>1. El texto histórico de Pierre de Coubertin en el Museo Olímpico</h4>
        <p>El donante se manifiesta como Alisher Usmanov, Presidente de la Federación Internacional de Esgrima.</p>

        <p>El manuscrito de 14 páginas contiene el discurso en el que Coubertin presentó por primera vez su idea visionaria de volver a vivir los Juegos Olímpicos en el mundo moderno. Se entregó el 25 de noviembre de 1892 en la antigua Sorbona, en París, durante la celebración del quinto aniversario de la Unión de Sociedades Francesas de Deportes Atléticos, cuando Pierre de Coubertin tenía tan solo 29 años. Dos años después, en el mismo auditorio, se formalizó la decisión de restablecer los Juegos Olímpicos. </p>

        <p>
        El presidente del Comité Olímpico Internacional (COI), Thomas Bach, dijo: «Hoy somos testigos de la historia. En un nivel, somos testigos de este documento histórico, el manuscrito del discurso que estableció los fundamentos filosóficos del Movimiento Olímpico. En otro nivel, estamos siendo testigos de un momento histórico, con este manuscrito volviendo a su hogar olímpico, al lugar al que pertenece.»</p>

        <p>En agradecimiento a Alisher Usmanov por esta donación, Bach añadió: «Esta donación de hoy va mucho más allá de una simple entrega de un manuscrito al Museo Olímpico. Su generosidad está haciendo posible este momento único, un momento que nos recuerda tan claramente la misión de los Juegos Olímpicos de unir al mundo en una competición pacífica. Gracias a su generosidad podemos reflexionar sobre nuestra historia hoy y celebrar este vínculo directo con nuestro padre fundador.»</p>

        <p>Usmanov dijo: «Este manuscrito es el manifiesto de los Juegos Olímpicos modernos. Pierre de Coubertin tenía una visión de un mundo unido por las actividades deportivas y no dividido por enfrentamientos y guerras. Creo que el Museo Olímpico es el lugar más apropiado para guardar este valioso manuscrito.»</p>

        <p>El manuscrito francés se escribió elegantemente en tinta sepia, en 14 hojas de papel tejido en el reverso de formularios de registro en blanco para el Congreso Internacional de Educación Física de 1889, coorganizado por Coubertin durante la Feria Mundial de París. Las páginas originales del manifiesto, que muestran intrigantes revisiones, se exhibirán ahora en el Museo Olímpico, la primera vez que se han mostrado al público. El documento completo se pondrá eventualmente en exhibición permanente.</p>

        <p>Alexandra de Navacelle de Coubertin, Presidenta de la Asociación Familiar Pierre de Coubertin, comentó: «Para nuestra familia, es extraordinario y una fuente de gran orgullo ver por escrito la previsión que tuvo mi tío abuelo. Hace más de cien años, comprendió claramente cómo el deporte puede cambiar el mundo, y qué enorme poder para bien podrían tener los Juegos Olímpicos, en su época y en el futuro. Es tan tranquilizador y un gran momento emocional ver el Manifiesto Olímpico de Pierre de Coubertin de nuevo en manos del Movimiento Olímpico en el Museo Olímpico, donde los millones de aficionados de todo el mundo pueden apreciarlo. Conmigo, la familia de Pierre de Coubertin cree que solo el COI puede preservar y continuar el trabajo de nuestros antepasados, y confiamos en ellos para hacerlo.»</p>
        
        <p>Consulte el comunicado de prensa en <a href="http://olympic.orh" target="_blank">olympic.org</a></p>

        <h4>2.
        La Academia de Esgrima de la FIE en Sudáfrica progresa</h4>
        <p>En su esfuerzo por ampliar y reforzar la esgrima en todo el mundo, la Federación Internacional de Esgrima está haciendo grandes progresos desde el lanzamiento de la Academia FIE SA, sin ánimo de lucro, en Johannesburgo (Sudáfrica) en 2017.</p>
        <p>El programa, que se presenta en inglés (la FIE también tiene un programa francófono con sede en Argelia), abarca cuatro trimestres a lo largo de 10 meses y las disciplinas de entrenamiento en las tres armas, así como la ciencia del entrenamiento deportivo y la gestión. Los conferenciantes locales e internacionales en temas que van desde la pedagogía de la esgrima hasta la medicina deportiva contribuyen a una educación completa y enriquecedora para los estudiantes africanos que desean obtener el «Diploma de Entrenador de Esgrima» reconocido por las escuelas de todo el mundo. Hasta la fecha, dos generaciones (2018 y 2019) han preparado 15 entrenadores de ocho países africanos de habla inglesa. </p>
        <p>
        Con 32 de los 54 países de África actualmente activos como miembros de la FIE, existe una creciente necesidad de desarrollar un entrenamiento cualificado de esgrima en este continente, y el programa académico universitario de la Federación, reconocido internacionalmente, está ayudando a satisfacer esa necesidad y a reforzar la esgrima en toda la región y fuera de ella.</p>
        <p>El PDF adjunto, haga <a href="" target="_blank">clic aquí</a>, contiene un informe completo y una descripción del programa, que comienza su tercer año de formación en entrenamiento en febrero de 2020.</p>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 8,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg9.jpg",
            "zoom": null,
            "content": `
        <img id="9-title-1" class="halfScale" style="top:115px;left:1050px" src="/114/es/static/_content/9-title-1.png">
        <img id="9-title-2" class="halfScale" style="top:179px;left:931px" src="/114/es/static/_content/9-title-2.png">
        <img id="9-quote" class="halfScale" style="top:607px;left:1008px" src="/114/es/static/_content/9-quote.png">
        <img id="9-arrow" class="halfScale pointer" style="top:844px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/9-arrow.png">
      `,
            "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
            pg9Anim.fromTo(idOf("9-title-1"), 0.3,{y:100,opacity:0}, {y:0,opacity:1}, 0.5)
            .fromTo(idOf("9-title-2"), 0.3,{y:100,opacity:0}, {y:0,opacity:1}, 0.75)
            .fromTo(idOf("9-quote"), 0.5,{opacity:0}, {opacity:1},1)
            .fromTo(idOf("9-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1.25)
        }

        function onPageLeave() {
          pg9Anim.stop()
            removeContentLinks();
        }
      `,
            "searchText": "ESGRIMISTAS  NICK  ITKIN « ESTOY EMPEZANDO A AMAR EL DEPORTE CADA VEZ MÁS  »",
            "mobileHtml": `
        <h2>Nick Itkin</h2>
        <img src="/114/es/static/_mobile/fencer-1.png">
        <h4>« Estoy empezando a amar el deporte cada vez más »</h4>
        
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 9,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg10.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <a href="https://www.instagram.com/nick_itkin/feed/" target="_blank">
          <div class="contentLinkNone" style="bottom:988px;right:288px;width:48px; height:40px;"></div>
        </a>
        
        <img id="10-no-1" class="halfScale 10-questions" style="top:250px;left:806px"; src="/114/es/static/_content/10-1.png">
        <img id="10-no-2" class="halfScale 10-questions" style="top:250px;left:811px;  display: none;" src="/114/es/static/_content/10-2.png">
        <img id="10-no-3" class="halfScale 10-questions" style="top:250px;left:812px; display: none; " src="/114/es/static/_content/10-3.png">
        <img id="10-no-4" class="halfScale 10-questions" style="top:250px;left:811px; display: none;" src="/114/es/static/_content/10-4.png">
        <img id="10-no-5" class="halfScale 10-questions" style="top:250px;left:811px; display: none;" src="/114/es/static/_content/10-5.png">
      
        
        <div class="addContentLink" style="top: 914px; left: 806px; width: 76px; height: 75px;" onclick="swapQuestion10('10-no-1', '10-img-1')"></div>
        <div class="addContentLink" style="top: 914px; left: 901px; width: 76px; height: 75px;" onclick="swapQuestion10('10-no-2', '10-img-2')"></div>
        <div class="addContentLink" style="top: 914px; left: 996px; width: 76px; height: 75px;" onclick="swapQuestion10('10-no-3', '10-img-3')"></div>
        <div class="addContentLink" style="top: 914px; left: 1092px; width: 76px; height: 75px;" onclick="swapQuestion10('10-no-4', '10-img-4')"></div>
        <div class="addContentLink" style="top: 914px; left: 1186px; width: 76px; height: 75px;" onclick="swapQuestion10('10-no-5', '10-img-5')"></div>

        <img id="10-next" class="halfScale pointer" style="top:844px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/10-arrow.png">
      `,
            script: `
        function onPageEnter() {
          pg10Anim = new TimelineMax()
          pg10Anim.fromTo(idOf("10-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }
  
        function swapQuestion10(ele, img) {
          var x = cOf("10-questions");
          for (i = 0; i < x.length; i++) {
            x[i].style.display = 'none';
          }
          idOf(ele).style.display = ""
          idOf(img).style.display = ""
        }
  
        function onPageLeave() {
          pg10Anim.stop()
          removeContentLinks()
        }
      `,
            "searchText": "Sigue a Nick Itkin AQUÍ  El año olímpico comenzó estupendamente para Nick Itkin cuando el esgrimista de florete de California consiguió su primera medalla de oro en la Copa del Mundo en el Desafío Internacional de París («CIP»). Antes de su regreso a Europa para los Grandes Premios de Turín, el joven de 20 años explicó a la FIE por qué ya está percibiendo los beneficios de tomar un año de estudios. Mi objetivo más inmediato son los próximos torneos. Por esta razón, estoy muy feliz de haber tomado este año como sabático en lo referente a mis estudios en la Universidad de Notre Dame. Puedo concentrarme completamente en la esgrima y el entrenamiento, y trabajar mi cuerpo como un atleta profesional.  1  2  3  4  5  PULSE AQUÍ PARA LEER MÁS  W W W.FIE .ORG",
            "mobileHtml": `
        <p><b>El año olímpico comenzó estupendamente para Nick Itkin cuando el esgrimista de florete de California consiguió su primera medalla de oro en la Copa del Mundo en el Desafío Internacional de París («CIP»). </b></p>
        <p>Antes de su regreso a Europa para los Grandes Premios de Turín, el joven de 20 años explicó a la FIE por qué ya está percibiendo los beneficios de tomar un año de estudios.</p>
        <p>
        Mi objetivo más inmediato son los próximos torneos. Por esta razón, estoy muy feliz de haber tomado este año como sabático en lo referente a mis estudios en la Universidad de Notre Dame. Puedo concentrarme completamente en la esgrima y el entrenamiento, y trabajar mi cuerpo como un atleta profesional. </p>
        <p><b>Año sabático</b></p>
        <p>En Notre Dame, me estoy especializando en ciencias políticas y tengo una especialidad en economía empresarial. Al principio fue difícil adaptarme a no estudiar. Allí estaba con todos mis compañeros, trabajando con todas las prácticas que teníamos. 
        Me llevó tiempo adaptarme, pero fue definitivamente la decisión correcta. Realmente aprecio el tiempo 
        que tengo para concentrarme en mi esgrima y no distraerme o estar nervioso o con el estrés de las tareas académicas. ¡El clima es mucho más agradable aquí en Los Ángeles también!</p>
        <p>En el Centro Internacional de Esgrima de Los Ángeles, hay esgrimistas más jóvenes con los que entreno unas cuantas veces a la semana, pero principalmente dedico el tiempo acudiendo a las clases y con mi entrenador de acondicionamiento, Taras Shelestyuk. Me concentro en ciertas acciones y trato de desarrollar mi esgrima. </p>
        <p>
        Una cosa que he hecho es el análisis de vídeo para examinar mi esgrima y a otros esgrimistas también, y ya me siento mucho más fuerte. El hecho de poder probar cosas nuevas ha mejorado mi juego y estoy comenzando a amar este deporte cada vez más. </p>
        <p><b>Lazos familiares</b></p>
        <p>Mis entrenadores aquí en Los Ángeles son mi padre, Michael, e Igor Zapozdaev. Soy muy afortunado de tener esta relación con mi padre, quien es mi entrenador y, a la vez, mi padre. Él ama tanto este deporte como yo. En el lado de la pista, su emoción es tan fuerte que me ayuda y me anima, y me aporta energía.</p>
        <p>
        Empecé a trabajar con él cuando tenía siete años y ha estado conmigo desde entonces. Es originario de Ucrania y hablamos ruso juntos. Es muy gracioso, ya que siempre me entrena en ruso, a menos que mi adversario sea ruso, ¡entonces me entrena en inglés!</p>
        <p>Este año para mí se trata de hacer todo lo posible para mejorar físicamente y tratar de hacer mi esgrima más y más compleja a nivel senior. Por lo tanto, fue definitivamente un gran momento el ganar la medalla de oro en París, especialmente en el CIP, que es personalmente uno de mis torneos favoritos, ya que tiene una gran historia y muchos aficionados. </p>
        <p>Siempre he querido ganar una Copa del Mundo o los Grandes Premios y finalmente lo logré; me siento muy seguro de mí mismo para pasar al siguiente torneo porque me gustó mucho la manera en que combatí en París. </p>
        <p><b>Una lección aprendida</b></p>
        <p>Combatí a un nivel muy alto en París, especialmente en mi semifinal y luego en el match final contra Daniele Garozzo, el campeón olímpico. Había perdido contra Garozzo en la última Copa del Mundo y pasé mucho tiempo analizando ese match, así que llegué a la final sabiendo exactamente cómo quería combatir contra él.</p>
        <p>Era importante para mí haber sido capaz de analizar nuestro match anterior en Tokio y luego hacer modificaciones. En París, llegué al match con un plan diferente y estaba muy seguro de mí mismo y concentrado.</p>
        <p>Definitivamente ha sido una inyección de confianza y, en la esgrima, la confianza es realmente importante; puede influir en tu fuerza y a nivel de valentía. Así que el último torneo me ayudará a seguir progresando.</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 10,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg11.jpg",
            "zoom": null,
            "content": `
        <img id="11-title-1" class="halfScale" style="top:721px;left:611px" src="/114/es/static/_content/11-title-1.png">
        <img id="11-title-2" class="halfScale" style="top:783px;left:442px" src="/114/es/static/_content/11-title-2.png">
        <img id="11-quote" class="halfScale" style="top:355px;left:290px" src="/114/es/static/_content/11-quote.png">
        <img id="11-arrow" class="halfScale pointer" style="top:844px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/11-arrow.png">
      `,
            "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
            pg11Anim.fromTo(idOf("11-title-1"), 0.3,{y:100,opacity:0}, {y:0,opacity:1}, 0.5)
            .fromTo(idOf("11-title-2"), 0.3,{y:100,opacity:0}, {y:0,opacity:1}, 0.75)
            .fromTo(idOf("11-quote"), 0.5,{opacity:0}, {opacity:1},1)
            .fromTo(idOf("11-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1.25)
        }

        function onPageLeave() {
          pg11Anim.stop()
            removeContentLinks();
        }
      `,
            "searchText": "ESGRIMISTAS  « SOY UNA NIÑA QUE SOÑÓ, QUE TRABAJÓ POR SU SUEÑO, Y QUE LO LOGRÓ  »  ANA MARIA  POPESCU",
            "mobileHtml": `
        <h2>Ana Maria Popescu</h2>
        <img src="/114/es/static/_mobile/fencer-2.png">
        <h4>« Soy una niña que soñó, que trabajó por su sueño, y que lo logró »</h4>
        
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 11,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg12.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <a href="https://www.instagram.com/anamariabranza/?hl=en" target="_blank">
          <div class="contentLinkNone" style="bottom:988px;right:288px;width:48px; height:40px;"></div>
        </a>
        
        <img id="12-no-1" class="halfScale 12-questions" style="top:250px;left:806px"; src="/114/es/static/_content/12-1.png">
        <img id="12-no-2" class="halfScale 12-questions" style="top:250px;left:811px;  display: none;" src="/114/es/static/_content/12-2.png">
        <img id="12-no-3" class="halfScale 12-questions" style="top:250px;left:812px; display: none; " src="/114/es/static/_content/12-3.png">
        <img id="12-no-4" class="halfScale 12-questions" style="top:250px;left:811px; display: none;" src="/114/es/static/_content/12-4.png">
        <img id="12-no-5" class="halfScale 12-questions" style="top:250px;left:811px; display: none;" src="/114/es/static/_content/12-5.png">
        <img id="12-no-6" class="halfScale 12-questions" style="top:250px;left:811px; display: none;" src="/114/es/static/_content/12-6.png">
        
      
        
        <div class="addContentLink" style="top: 914px; left: 806px; width: 76px; height: 75px;" onclick="swapQuestion12('12-no-1', '12-img-1')"></div>
        <div class="addContentLink" style="top: 914px; left: 901px; width: 76px; height: 75px;" onclick="swapQuestion12('12-no-2', '12-img-2')"></div>
        <div class="addContentLink" style="top: 914px; left: 996px; width: 76px; height: 75px;" onclick="swapQuestion12('12-no-3', '12-img-3')"></div>
        <div class="addContentLink" style="top: 914px; left: 1092px; width: 76px; height: 75px;" onclick="swapQuestion12('12-no-4', '12-img-4')"></div>
        <div class="addContentLink" style="top: 914px; left: 1186px; width: 76px; height: 75px;" onclick="swapQuestion12('12-no-5', '12-img-5')"></div>
        <div class="addContentLink" style="top: 914px; left: 1274px; width: 76px; height: 75px;" onclick="swapQuestion12('12-no-6', '12-img-6')"></div>
      

        <img id="12-next" class="halfScale pointer" style="top:844px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/10-arrow.png">
      `,
            script: `
        function onPageEnter() {
          pg12Anim = new TimelineMax()
          pg12Anim.fromTo(idOf("12-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }
  
        function swapQuestion12(ele, img) {
          var x = cOf("12-questions");
          var i;
          for (i = 0; i < x.length; i++) {
            x[i].style.display = 'none';
          }
          idOf(ele).style.display = ""
          idOf(img).style.display = ""
        }
  
        function onPageLeave() {
          pg12Anim.stop()
          removeContentLinks()
        }
      `,
            "searchText": "Sigue a Ana Maria AQUÍ  La rumana, Ana Maria Popescu, medallista olímpica de plata en espada femenina en 2008 y medallista de oro por equipos en Río de Janeiro en 2016, aspira a alcanzar mayores éxitos. A continuación, reflexiona sobre las aventuras olímpicas del pasado que la inspiraron a escribir un libro; y explica por qué, a los 35 años, se siente más fuerte y en forma que nunca. Soy una niña que soñó, que trabajó por su sueño, y que lo logró. Si lo conseguí, estoy segura de que otros niños pueden hacerlo y por eso escribí un libro sobre mi carrera, con el objetivo de intentar ser una inspiración para los futuros campeones. Se llama En Garde: The Little Girl with the Tricolour Mask (la niña con la careta tricolor) y trata de una niña, Branzica, que va a las Olimpiadas. Escribir el libro fue un viaje a través de mis recuerdos. Disfruté cada parte de él, desde la primera palabra hasta verlo en la librería y luego en las manos de los niños.  1  2  3  4  5  6  PULSE AQUÍ PARA LEER MÁS  W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>
      La rumana, Ana Maria Popescu, medallista olímpica de plata en espada femenina en 2008 y medallista de oro por equipos en Río de Janeiro en 2016, aspira a alcanzar mayores éxitos.</b></p>
        <p>A continuación, reflexiona sobre las aventuras olímpicas del pasado que la inspiraron a escribir un libro; y explica por qué, a los 35 años, se siente más fuerte y en forma que nunca.</p>
        <p>Soy una niña que soñó, que trabajó por su sueño, y que lo logró. Si lo conseguí, estoy segura de que otros niños pueden hacerlo y por eso escribí un libro sobre mi carrera, con el objetivo de intentar ser una inspiración para los futuros campeones. Se llama En Garde: The Little Girl with the Tricolour Mask (la niña con la careta tricolor) y trata de una niña, Branzica, que va a las Olimpiadas. Escribir el libro fue un viaje a través de mis recuerdos. Disfruté cada parte de él, desde la primera palabra hasta verlo en la librería y luego en las manos de los niños. </p>
        <p><b>Creciendo rápidamente</b></p>
        <p>Recordando mi carrera, todavía era una niña en mis primeras Olimpiadas en Atenas. Tenía apenas 19 años y estaba fascinada caminando por la Villa Olímpica y pasando junto a todos estos atletas que solo había visto en la televisión. Cuatro años más tarde, en Pekín, gané la medalla de plata individual y eso se debió a la locura de la juventud porque estaba dispuesta a correr riesgos. Ya han pasado casi 12 años y supongo que eso significa que ¡me estoy haciendo mayor! He crecido mucho desde entonces y tengo mucha más experiencia. Ahora estoy mucho más equilibrada, pero la alegría del deporte es la misma para mí.</p>
        <p>En realidad no recuerdo mucho de Pekín. Estuve allí casi un mes, pero estaba muy concentrada en la prueba. Lo que sí recuerdo es mi último toque ganador en la semifinal contra Ildiko Mincza-Nebald, mi adversaria de Hungría. La emoción fue tremenda. Estábamos en un empate por 14-14 y, aunque no era la primera vez que jugaba un toque, eran las Olimpiadas, donde todo se siente completamente diferente.</p>
        
        <p><b>Regresar más fuerte</b></p>
        <p>A propósito de las emociones, no puedo olvidar mi fracaso en Londres 2012, tanto en las pruebas individuales como por equipos. Donde aprendí la lección de no rendirme nunca. Justo después de Londres, vi una foto mía llorando y me sirvió de gran motivación porque pensé: «Esa no soy yo».</p>
        <p>Algunas de mis compañeras de equipo renunciaron durante cierto tiempo justo después de Londres, pero luego nos reunimos y dijimos: «Veamos, esto no ha terminado para nosotras; intentémoslo una vez más», y terminamos con el oro en la prueba por equipos en Río de Janeiro. Estoy muy contenta de haber podido vivir todas estas emociones en las Olimpiadas. </p>

        <p><b>Volver en buen camino</b></p>
        <p>Aunque actualmente soy la N.º 1 del mundo en espada femenina, esa clasificación tampoco importa tanto, lo importante es obtener buenos resultados. Ahora mismo me encuentro viajando con mi nuevo entrenador, Mihai Popa, que está lleno de alegría y le apasiona la esgrima. Me está ayudando mucho en la pista. También me siento en mejor forma que antes, ya que este año me he centrado más en mi entrenamiento físico, trabajando con un entrenador llamado Gabriel Ghita. Él sabe lo que necesito, hacemos un buen equipo y se pueden ver los resultados; me siento más fuerte y con más confianza aunque, igualmente, sé que la temporada es larga y que aún quedan muchas pruebas por delante.</p>
        <p>También tengo que dar mi agradecimiento a mi entrenador de toda la vida, Dan Podeanu. Tuve grandes problemas en 2017 con un esguince grave en el tobillo izquierdo y, durante varios meses, me pregunté si podría volver al circuito. Dan me convenció de que podía, y que todavía podía ganar también medallas. Estoy muy agradecida por todo lo que dijo. Me dijo, «En realidad, creo que puedes estar en el podio una vez más». Estaba un poco asustada cuando regresé. Me preocupaba volver a lesionarme el tobillo, pero todo ha ido bien. ¡Tenemos un acuerdo para el próximo año y tenemos que cumplirlo!</p>
        <p>Como atleta, necesitas rodearte de gente buena y también tengo la ayuda de mi esposo, Pavel Popescu, que juega a waterpolo en el Steaua de Bucarest. Él entiende mi trabajo, nos apoyamos mutuamente y, cuando estamos en casa, tratamos de hablar lo menos posible sobre el deporte. ¡Pero no lo conseguimos! Debido a nuestros compromisos, no pasamos muchos fines de semana juntos, en cambio tratamos de pasar tiempo juntos durante la semana. A mi edad, 35 años, necesito tener más cuidado con la recuperación y si siento que mi cuerpo necesita un descanso, llamo a mi entrenador y le digo que me ausentaré durante un par de días. Sin embargo, cuando vuelvo, doy más del cien por ciento porque en la pista, todo depende de mí. No hay nadie que pueda ayudarme allí: soy yo y mi espada.</p>
        <p>
        Un día dejaré mi espada y, cuando eso suceda, escribiré otro libro. A veces pienso que París 2024 no está muy lejos. Recuerdo que los húngaros Ildiko Mincza-Nebald y Geza Imre ganaron medallas olímpicas a los 39 y 41 años. Demostraron que se puede hacer; si lo quieres y trabajas por ello, es posible.</p>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 12,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg13.jpg",
            "zoom": null,
            "content": `
        <img id="13-title-1" class="halfScale" style="top:236px;left:1148px" src="/114/es/static/_content/13-title-1.png">
        <img id="13-title-2" class="halfScale" style="top:300px;left:1026px" src="/114/es/static/_content/13-title-2.png">
        <img id="13-quote" class="halfScale" style="top:698px;left:89px" src="/114/es/static/_content/13-quote.png">
        <img id="13-arrow" class="halfScale pointer" style="top:844px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/10-arrow.png">
        `,
            "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
            pg11Anim.fromTo(idOf("13-title-1"), 0.3,{y:100,opacity:0}, {y:0,opacity:1}, 0.5)
            .fromTo(idOf("13-title-2"), 0.3,{y:100,opacity:0}, {y:0,opacity:1}, 0.75)
            .fromTo(idOf("13-quote"), 0.5,{opacity:0}, {opacity:1},1)
            .fromTo(idOf("13-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1.25)
        }

        function onPageLeave() {
          pg11Anim.stop()
            removeContentLinks();
        }
      `,
            "searchText": "ESGRIMISTAS  LEONIE  EBERT « LAS MUJERES QUE MÁS ME INSPIRAN SON MIEMBROS DE MI FAMILIA  »",
            "mobileHtml": `
      <h2>Leonie Ebert</h2>
      <h4>«Las mujeres que más me inspiran son miembros de mi familia»</h4>
      <img src="/114/es/static/_mobile/fencer-3.png">
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 13,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg14.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <a href="https://www.instagram.com/leonieeebert/?hl=en" target="_blank">
          <div class="contentLinkNone" style="bottom:988px;right:318px;width:48px; height:40px;"></div>
        </a>
        
        <img id="14-no-1" class="halfScale 14-questions" style="top:250px;left:806px"; src="/114/es/static/_content/14-1.png">
        <img id="14-no-2" class="halfScale 14-questions" style="top:250px;left:804px;  display: none;" src="/114/es/static/_content/14-2.png">
        <img id="14-no-3" class="halfScale 14-questions" style="top:250px;left:804px; display: none; " src="/114/es/static/_content/14-3.png">
        <img id="14-no-4" class="halfScale 14-questions" style="top:250px;left:804px; display: none;" src="/114/es/static/_content/14-4.png">
        <img id="14-no-5" class="halfScale 14-questions" style="top:250px;left:804px; display: none;" src="/114/es/static/_content/14-5.png">
        
      
        
        <div class="addContentLink" style="top: 914px; left: 806px; width: 76px; height: 75px;" onclick="swapQuestion14('14-no-1', '14-img-1')"></div>
        <div class="addContentLink" style="top: 914px; left: 901px; width: 76px; height: 75px;" onclick="swapQuestion14('14-no-2', '14-img-2')"></div>
        <div class="addContentLink" style="top: 914px; left: 996px; width: 76px; height: 75px;" onclick="swapQuestion14('14-no-3', '14-img-3')"></div>
        <div class="addContentLink" style="top: 914px; left: 1092px; width: 76px; height: 75px;" onclick="swapQuestion14('14-no-4', '14-img-4')"></div>
        <div class="addContentLink" style="top: 914px; left: 1186px; width: 76px; height: 75px;" onclick="swapQuestion14('14-no-5', '14-img-5')"></div>
      

        <img id="14-next" class="halfScale pointer" style="top:844px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/10-arrow.png">
      `,
            script: `
        function onPageEnter() {
          pg14Anim = new TimelineMax()
          pg14Anim.fromTo(idOf("14-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }
  
        function swapQuestion14(ele, img) {
          var x = cOf("14-questions");
          var i;
          for (i = 0; i < x.length; i++) {
            x[i].style.display = 'none';
          }
          idOf(ele).style.display = ""
          idOf(img).style.display = ""
        }
  
        function onPageLeave() {
          pg14Anim.stop()
          removeContentLinks()
        }
      `,
            "searchText": "Sigue a Leonie Ebert AQUÍ  En una temporada llena de promesas, la esgrimista alemana Leonie Ebert habló con la FIE sobre las personas que la han inspirado y ayudado a hacer realidad sus sueños. La joven de 20 años revela lo que se necesita para subir en las clasificaciones y desafiar al más alto nivel de su deporte. Los inicios Empecé a practicar esgrima después de ver los entrenamientos de mi amigo y me fascinó al instante. Así que empecé a entrenar y a las pocas semanas conseguí mi primera competencia. La esgrima siempre fue mucho más que un hobby para mí y se convirtió en lo más importante de mi vida. Tuve que compaginar mi vida escolar, personal y la carrera de esgrima durante varios años. Una vez, incluso tuve que volar directamente desde el Gran Premio de Shanghái para realizar mis exámenes de nivel A.  1  2  3  4  5  PULSE AQUÍ PARA LEER MÁS  W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>En una temporada llena de promesas, la esgrimista alemana Leonie Ebert habló con la FIE sobre las personas que la han inspirado y ayudado a hacer realidad sus sueños. </b></p>
      <p>La joven de 20 años revela lo que se necesita para subir en las clasificaciones y desafiar al más alto nivel de su deporte.
      </p>
      <p><b>Los inicios</b></p>
      <p>Empecé a practicar esgrima después de ver los entrenamientos de mi amigo y me fascinó al instante. Así que empecé a entrenar y a las pocas semanas conseguí mi primera competencia. La esgrima siempre fue mucho más que un hobby para mí y se convirtió en lo más importante de mi vida.</p>
      <p>Tuve que compaginar mi vida escolar, personal y la carrera de esgrima durante varios años. Una vez, incluso tuve que volar directamente desde el Gran Premio de Shanghái para realizar mis exámenes de nivel A.</p>
      <p>Aunque era un equilibrio difícil de mantener, todo el trabajo duro ha dado sus frutos hasta ahora y hace dos años gané mi primera medalla en el Gran Premio de Anaheim.</p>

      <p><b>Superación de un inicio difícil</b></p>
      <p>El inicio de esta temporada ha sido difícil ya que no me fue tan bien en las competencias individuales como en la temporada pasada. Me enfrenté a algunos oponentes muy desafiantes que, al final, no pude vencer.</p>
      <p>Lo importante para mí ahora es seguir siendo positiva y trabajar duro. A veces, la esgrima puede ser un deporte frustrante, ya que el entrenamiento y la dedicación no garantizan necesariamente una victoria fácil. A pesar de esto, sé que independientemente de mis resultados, tengo que seguir luchando si quiero llegar a los niveles más altos de mi deporte.</p>
      <p>En ocasiones, puede ser difícil no pensar demasiado en lo que estás haciendo y no perder la perspectiva. Es fácil olvidar que todavía tienes una temporada que completar. En la medida de lo posible, trato de concentrarme en cada competencia a medida que se acerca, para poder empezar a sentirme libre y competir por diversión. Cuando sientes que algo es muy importante para ti, lo mejor que puedes hacer es mantener la calma.</p>
      
      <p><b>
      Sangre deportiva</b></p>
      <p>La familia ha sido definitivamente un factor clave para llegar tan lejos en la esgrima. Mis hermanos Amelie y Constantin están en las selecciones nacionales alemanas de natación sincronizada y baloncesto respectivamente, así que siempre he estado rodeado de deportistas inspiradores que me animan y ya han conseguido lo que espero algún día conseguir yo también.</p>
      <p>Habiendo visto a mis hermanos triunfar en el mundo del deporte, me pareció muy natural tratar de seguir sus pasos y dedicar mi vida al deporte. </p>
      <p>Fue genial que todos termináramos haciendo diferentes deportes para que no hubiera rivalidad entre nosotros y pudiéramos seguir ayudándonos mutuamente en la medida de lo posible. Tienen mucha experiencia deportiva y me dan brindado todo su apoyo y pasión. Eso es clave en un deporte con mucha rivalidad.</p>

      <p><b>Día Internacional de la Mujer</b></p>
      <p>Al acercarse el Día Internacional de la Mujer, he estado pensando en las muchas mujeres que han seguido inspirándome a lo largo de mi vida. En el mundo de la esgrima, Anja Fichtel, compitió con mucha fuerza a una edad muy temprana y llegó a ser una de las mejores esgrimistas alemanas de todos los tiempos. Su pasión siempre me ha ayudado a confiar en mis propias habilidades y sigue siendo una de mis mayores heroínas en el mundo deportivo.</p>
      <p>
      Sin embargo, las mujeres que más me inspiran son miembros de mi familia. Mi hermana, por ejemplo, logró compaginar el hecho de ser una atleta en un escenario internacional y la obtención del título de medicina en la universidad, y aunque le costó mucho trabajo y dedicación, hizo que pareciera fácil. Mi madre, mientras tanto, crió tres hijos por su cuenta mientras dirigía su trabajo como directora nacional de las Olimpiadas Especiales, y también ha hecho todo lo posible para ayudarnos a lo largo de nuestras carreras deportivas. Es su desinterés y su voluntad de hacer cualquier cosa por nosotros lo que realmente me ha inspirado a lo largo de mi vida.</p>
      <p>Cada vez más personas están empezando a entender que las mujeres pueden competir al más alto nivel en los deportes y deben ser libres de hacer lo que quieran. Desafortunadamente, no es el caso en todos los países. Espero que más mujeres se den cuenta de que son capaces de hacer cualquier cosa con sus vidas y que no deben 
      sentirse limitadas por las restricciones que otros intenten ponerles. Las mujeres que me han inspirado a lo largo de mi vida me han mostrado lo que las mujeres pueden lograr realmente y son ciertamente mis mayores ídolos.</p>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 14,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg15.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.pbtfencing.com" target="_blank">
          <div class="contentLinkNone" style="top:1083px;left:344px;width:242px; height:38px;"></div>
        </a>

        <a href="mailto:sales@pbtfencing.com" target="_blank">
          <div class="contentLinkNone" style="top:1083px;left:614px;width:255px; height:38px;"></div>
        </a>

        <a href="https://www.instagram.com/pbt_fencing/" target="_blank">
          <div class="contentLinkNone" style="top:1083px;left:889px;width:298px; height:38px;"></div>
        </a>
      `,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "www.pbtfencing.com  @sales@pbtfencing.com  @instagram.com/pbt_fencing",
            "mobileHtml": `
      <a href="http://www.uhlmann-fencing.com" target="_blank">
        <img src="/114/es/static/_mobile/pg15.jpg">
      </a>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 15,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg16.jpg",
            "zoom": null,
            "content": `

        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>


        <img id="16-title" class="halfScale" style="top:75px;left:79px" src="/114/es/static/_content/16-title.png">

        <img id="16-next" class="halfScale pointer" style="top:938px;left:1174px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/16-arrow.png">

        <a href="https://video.eurosport.com/fencing/like-winning-on-a-slot-machine-daniele-garozzo-on-that-winning-olympic-feeling_vid1291717/video.shtml " target="_blank">
          <svg class="abs pulse animatedpulse pointer" style="bottom:444px;left:762px;" width="84.4px" height="84.4px" viewBox="0 0 69.4 67.4">
            <path fill="#000000" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>

        <a href="https://video.eurosport.com/fencing/marcus-mepstead-talks-through-his-hard-journey-to-world-silver-medallist_vid1285450/video.shtml" target="_blank">
          <svg class="abs pulse animatedpulse pointer" style="bottom:518px;left:1059px;" width="65.4px" height="65.4px" viewBox="0 0 69.4 67.4">
            <path fill="#9e00ff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
          </svg>
        </a>
      `,
            "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
            pg16Anim.fromTo(idOf("16-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)
            .fromTo(idOf("16-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},"+=0.3")
        }

        function onPageLeave() {
          pg16Anim.stop()
            removeContentLinks();
        }
      `,
            "searchText": "FENCERS  THE ATHLETES Daniele Garozzo on that winning Olympic feeling  Marcus Mepstead talks through his hard journey to world silver medallist  Tap to play  W W W.FIE .ORG",
            "mobileHtml": `
      <p>Daniele Garozzo sobre ese sentimiento olímpico ganador<a href="" target="_blank">Tap to Play</a></p>
      <p>Marcus Mepstead habla del su duro viaje hasta conseguir ser medallista de plata del mundo - <a href="" target="_blank">Tap to Play</a></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 16,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg17.jpg",
            "zoom": null,
            "content": `
        <img id="17-title-1" class="halfScale" style="top:134px;left:83px" src="/114/es/static/_content/17-title-1.png">
        <img id="17-title-2" class="halfScale" style="top:240px;left:83px" src="/114/es/static/_content/17-title-2.png">
        <img id="10-arrow" class="halfScale pointer" style="top:844px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/10-arrow.png">
      `,
            "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
            pg17Anim.fromTo(idOf("17-title-1"), 0.3,{x:100,opacity:0}, {x:0,opacity:1}, 0.5)
            .fromTo(idOf("17-title-2"), 0.3,{x:100,opacity:0}, {x:0,opacity:1}, 0.75)
            .fromTo(idOf("10-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg17Anim.stop()
            removeContentLinks();
        }
      `,
            "searchText": "ESGRIMISTAS  MES EN REVISIÓN: ENERO",
            "mobileHtml": `
      <h2>MES EN REVISIÓN: 
      ENERO</h2>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 17,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg18.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/purple-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/purple-facebook.png">
        </a>

        <img id="18-arrow" class="halfScale pointer" style="top:844px;left:1419px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/18-arrow.png">
      `,
            "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
            pg18Anim.fromTo(idOf("18-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg18Anim.stop()
            removeContentLinks();
        }
      `,
            "searchText": "RECAPITULACIÓN DE LA ESGRIMA 2/3  Mientras se celebraban varios eventos de la Copa del Mundo y el Gran Premio, Canadá, Cuba y toda Europa tuvieron un fin de semana intenso de competencias Kharlan y los 16.º Grandes Premios Olga Kharlan (UKR), la esgrimista de sable femenino mejor clasificada del mundo, con el oro de los 16.º Grandes Premios, ganó el Gran Premio de sable de Montreal. El cuatro veces campeón del mundo se enfrentó a distintos desafíos en los grandes eventos anteriores. En octavos de final ganó a Mariel Zagunis (EE. UU.).   Apithy se hace con la victoria Boladé Apithy (FRA) se impuso en la final de sable masculino individual en el Gran Premio de Montreal para ganar su segundo oro en el Gran Premio. El esgrimista de 34 años se hizo con la victoria, por un solo punto, contra el ex campeón del mundo coreano, Junghwan Kim, en cuartos de final. En 2016, no participó en los Juegos Olímpicos y en su lugar fue a Río para entrenar a su hermano Yemi, ya que este último compitió por Benín. Empezó el 2020 con una medalla de oro. Trabajo arduo para Itkin Los estudiantes tendrán años sabáticos en 2019/20 por diversos motivos y, en el caso de Nick Itkin (EE. UU.), su año de estudios en Notre Dame se centra en la preparación para Tokio 2020. También se llevó el oro del Gran Premio de la manera contundente, venciendo al actual campeón del mundo Enzo Lefort (por 15-12) en la semifinal antes de superar al Campeón Olímpico italiano Daniele Garozzo por 15-9 en la final. W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>Mientras se celebraban varios eventos de la Copa del Mundo y el Gran Premio, Canadá, Cuba y toda Europa tuvieron un fin de semana intenso de competencias.</b></p>
      <h4>Kharlan y los 16.º Grandes Premios</h4>
      <p>Olga Kharlan (UKR), la esgrimista de sable femenino mejor clasificada del mundo, con el oro de los 16.º Grandes Premios, ganó el Gran Premio de sable de Montreal. El cuatro veces campeón del mundo se enfrentó a distintos desafíos en los grandes eventos anteriores. En octavos de final ganó a Mariel Zagunis (EE. UU.).</p>
      <h4>Apithy se hace con la victoria</h4>
      <p>Boladé Apithy (FRA) se impuso en la final de sable masculino individual en el Gran Premio de Montreal para ganar su segundo oro en el Gran Premio. El esgrimista de 34 años se hizo con la victoria, por un solo punto, contra el ex campeón del mundo coreano, Junghwan Kim, en cuartos de final. En 2016, no participó en los Juegos Olímpicos y en su lugar fue a Río para entrenar a su hermano Yemi, ya que este último compitió por Benín. Empezó el 2020 con una medalla de oro.</p>
      <h4>
      Trabajo arduo para Itkin</h4>
      <p>Los estudiantes tendrán años sabáticos en 2019/20 por diversos motivos y, en el caso de Nick Itkin (EE. UU.), su año de estudios en Notre Dame se centra en la preparación para Tokio 2020. También se llevó el oro del Gran Premio de la manera contundente, venciendo al actual campeón del mundo Enzo Lefort (por 15-12) en la semifinal antes de superar al Campeón Olímpico italiano Daniele Garozzo por 15-9 en la final. </p>
      <h4>Doble oro para Gergely</h4>
      <p>Hubo un doble oro para Gergely Siklósi y el equipo húngaro en la Copa del Mundo de espada masculina de Heidenheim. La final del equipo fue dramática –una victoria por 45-43 sobre Francia– pero el campeón del mundo Siklósi obtuvo su primer oro en la Copa del Mundo al derrotar al Campeón Olímpico, Sangyoung Park (KOR), por un solo toque, por 15-14.</p>
      <h4>Triple triunfo para Deriglazova</h4>
      <p>Inna Deriglazova (RUS) consiguió su 13.ª medalla de oro en la Copa del Mundo de florete femenino de Katowice al triunfar en la ciudad polaca por tercer año consecutivo. En 2019, Katowice le otorgó el primer éxito de un año en el que se llevó el oro del Campeonato del Mundo y es la actual Campeona Olímpica, de 29 años.</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 18,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg19.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/purple-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/purple-facebook.png">
        </a>

        <img id="19-arrow" class="halfScale pointer" style="top:844px;left:1389px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/19-arrow.png">
      `,
            "script": `
        function onPageEnter() {
          pg19Anim = new TimelineMax();
            pg19Anim.fromTo(idOf("19-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }

        function onPageLeave() {
          pg19Anim.stop()
            removeContentLinks();
        }
      `,
            "searchText": "RECAPITULACIÓN DE LA ESGRIMA 3/3  Doble oro para Gergely Hubo un doble oro para Gergely Siklósi y el equipo húngaro en la Copa del Mundo de espada masculina de Heidenheim. La final del equipo fue dramática –una victoria por 45-43 sobre Francia– pero el campeón del mundo Siklósi obtuvo su primer oro en la Copa del Mundo al derrotar al Campeón Olímpico, Sangyoung Park (KOR), por un solo toque, por 15-14. Triple triunfo para Deriglazova Inna Deriglazova (RUS) consiguió su 13.ª medalla de oro en la Copa del Mundo de florete femenino de Katowice al triunfar en la ciudad polaca por tercer año consecutivo. En 2019, Katowice le otorgó el primer éxito de un año en  el que se llevó el oro del Campeonato del Mundo y es la actual Campeona Olímpica, de 29 años. Zamachowska, la reina de La Habana  En la Copa del Mundo de espada femenina de La Habana, hubo una medalla de oro para Italia en la prueba por equipos, pero la gran historia de la capital cubana fue el oro individual que ganó la polaca Aleksandra Zamachowska, su primera victoria individual en una Copa del Mundo desde 2017. La joven de 24 años de Cracovia superó a la número uno del mundo, Ana Maria Popescu (ROU), por 15-8 en la final. Su compatriota y adversaria en la semifinal, Renata Knapik-Miazga, consiguió la medalla de bronce.  W W W.FIE .ORG",
            "mobiltHtml": `
      
      <h4>Zamachowska, la reina de La Habana </h4>
      <p>En la Copa del Mundo de espada femenina de La Habana, hubo una medalla de oro para 
      Italia en la prueba por equipos, pero la gran historia de la capital cubana fue el oro individual que ganó la polaca Aleksandra Zamachowska, su primera victoria individual en una Copa del Mundo desde 2017. La joven de 24 años de Cracovia superó a la número uno del mundo, Ana Maria Popescu (ROU), por 15-8 en la final. Su compatriota y adversaria en la semifinal, Renata Knapik-Miazga, consiguió la medalla de bronce.</p>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 19,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg20.jpg",
            "zoom": null,
            "content": `
        <img id="20-title-1" class="halfScale" style="top:128px;left:83px" src="/114/es/static/_content/20-title-1.png">
        <img id="20-title-2" class="halfScale" style="top:232px;left:83px" src="/114/es/static/_content/20-title-2.png">
        <img id="20-arrow" class="halfScale pointer" style="top:844px;left:1409px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/10-arrow.png">
        `,
            "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
            pg20Anim.fromTo(idOf("20-title-1"), 0.3,{x:100,opacity:0}, {x:0,opacity:1}, 0.5)
            .fromTo(idOf("20-title-2"), 0.3,{x:100,opacity:0}, {x:0,opacity:1}, 0.75)
            .fromTo(idOf("20-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }
        function onPageLeave() {
          pg20Anim.stop()
            removeContentLinks();
        }
      `,
            "searchText": "ESGRIMISTAS  MES EN REVISIÓN: FEBRERO",
            "mobileHtml": `
      <h2>MES EN REVISIÓN: FEBRERO</h2>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 20,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg21.jpg",
            "zoom": null,
            "content": `
            <a href="http://www.fie.org" target="_blank">
              <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
            </a>
            <a href="https://twitter.com/FIE_fencing" target="_blank">
              <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/purple-twitter.png">
            </a>
            <a href="https://www.facebook.com/fie.org" target="_blank">
              <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/purple-facebook.png">
            </a>
            <img id="21-arrow" class="halfScale pointer" style="top:844px;left:1419px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/19-arrow.png">
            `,
            "script": `
            function onPageEnter() {
              pg21Anim = new TimelineMax();
                pg21Anim.fromTo(idOf("21-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            }
            function onPageLeave() {
              pg21Anim.stop()
                removeContentLinks();
            }
      `,
            "searchText": "MES EN REVISIÓN FEBRERO 2/5  Nuestro último resumen de las competiciones en todo el mundo, desde Budapest hasta Barcelona. Budapest, 6-8 de marzo: Louis-Marieb y Masada realizan un gran avance El antiguo refrán «El que la sigue...» me vino a la mente en el Gran Premio de espada de Budapest, cuando Alexandra Louis-Marie de Francia y Masara Yamada de Japón se llevaron las respectivas medallas de oro en categoría femenina y masculina, respectivamente. Era la primera vez que uno de los dos esgrimistas subía al podio en una prueba senior de la FIE, después de los recientes cuasi accidentes de ambos. En el caso de Louis-Marie, el joven de 24 años había sido subcampeón de la Copa del Mundo de espada en Barcelona un mes antes, pero ahora había llegado mucho más lejos al derrotar a la coreana, Sera Song, por 15-13 en la final, tras haber vencido a la estonia, Irina Embrich, y a la campeona del mundo de 2017, Tatiana Gudkova. Mientras tanto, el éxito de Yamada continuó con la medalla de bronce en Catar en el mes de enero, donde el joven de 25 años derrotó al francés, Yannick Borel, campeón del mundo de 2018, por 15-11 en la final tras el éxito en semifinales contra el ucraniano Igor Reizlin.  Atenas, 6-8 de marzo: Zagunis en buena forma Para Mariel Zagunis, debe haber algo especial en el aire de Atenas. Fue en la capital griega en 2004 cuando la entonces sablista de 19 años se convirtió en la primera esgrimista estadounidense en ganar el oro olímpico en 100 años. También fue en Atenas, en enero de 2016, donde ganó su 15.ª medalla de oro en la Copa del Mundo. De vuelta en la ciudad de la Acrópolis para la Copa del Mundo de sable femenino, la dos veces campeona olímpica y del mundo, de 35 años, ganó su primera Copa del Mundo desde entonces, gracias a una victoria final contra la húngara, Liza Pusztai, por 15-6. En su semifinal, Zagunis ganó por 15-8 a la japonesa Misaki Emura, la conquistadora de los cuartos de final de la campeona del mundo de 2018, la rusa, Sofia Pozdniakova. Mientras tanto, Pusztai, terminó con la carrera de la candidata local Theodora Gkountoura en las semifinales (por 15-9); para la esgrimista era su segunda medalla de bronce de la serie. En la competencia por equipos, Rusia venció a Italia 45-35 en la final. Hungría, por su parte, venció a los coreanos por 45-42 en los cuartos de final, con el objetivo de conseguir la medalla de bronce ganada a costa de Polonia (por 45-36)  W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>Nuestro último resumen de las competiciones en todo el mundo, desde Budapest hasta Barcelona.</b></p>
      <h4>Budapest, 6-8 de marzo: Louis-Marieb y Masada realizan un gran avance</h4>
      <p>El antiguo refrán «El que la sigue...» me vino a la mente en el Gran Premio de espada de Budapest, cuando Alexandra Louis-Marie de Francia y Masara Yamada de Japón se llevaron las respectivas medallas de oro en categoría femenina y masculina, respectivamente. Era la primera vez que uno de los dos esgrimistas subía al podio en una prueba senior de la FIE, después de los recientes cuasi accidentes de ambos. En el caso de Louis-Marie, el joven de 24 años había sido subcampeón de la Copa del Mundo de espada en Barcelona un mes antes, pero ahora había llegado mucho más lejos al derrotar a la coreana, Sera Song, por 15-13 en la final, tras haber vencido a la estonia, Irina Embrich, y a la campeona del mundo de 2017, Tatiana Gudkova. Mientras tanto, el éxito de Yamada continuó con la medalla de bronce en Catar en el mes de enero, donde el joven de 25 años derrotó al francés, Yannick Borel, campeón del mundo de 2018, por 15-11 en la final tras el éxito en semifinales contra el ucraniano Igor Reizlin. </p>
      <h4>Atenas, 6-8 de marzo: Zagunis en buena forma</h4>
      <p>Para Mariel Zagunis, debe haber algo especial en el aire de Atenas. Fue en la capital griega en 2004 cuando la entonces sablista de 19 años se convirtió en la primera esgrimista estadounidense en ganar el oro olímpico en 100 años. También fue en Atenas, en enero de 2016, donde ganó su 15.ª medalla de oro en la Copa del Mundo. De vuelta en la ciudad de la Acrópolis para la Copa del Mundo de sable femenino, la dos veces campeona olímpica y del mundo, de 35 años, ganó su primera Copa del Mundo desde entonces, gracias a una victoria final contra la húngara, Liza Pusztai, por 15-6. En su semifinal, Zagunis ganó por 15-8 a la japonesa Misaki Emura, la conquistadora de los cuartos de final de la campeona del mundo de 2018, la rusa, Sofia Pozdniakova. Mientras tanto, Pusztai, terminó con la carrera de la candidata local Theodora Gkountoura en las semifinales (por 15-9); para la esgrimista era su segunda medalla de bronce de la serie.</p>
      <p>En la competencia por equipos, Rusia venció a Italia 45-35 en la final. Hungría, por su parte, venció a los coreanos por 45-42 en los cuartos de final, con el objetivo de conseguir la medalla de bronce ganada a costa de Polonia (por 45-36)</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 21,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg22.jpg",
            "zoom": null,
            "content": `
      <a href="http://www.fie.org" target="_blank">
        <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/purple-twitter.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/purple-facebook.png">
      </a>
      <img id="22-arrow" class="halfScale pointer" style="top:844px;left:1419px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/19-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg22Anim = new TimelineMax();
          pg22Anim.fromTo(idOf("22-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }
      function onPageLeave() {
        pg22Anim.stop()
          removeContentLinks();
      }
      `,
            "searchText": "MES EN REVISIÓN FEBRERO 3/5  Luxemburgo, 6-8 de marzo: Doble por Szilagyi Después de seis años de espera por el oro de la Copa del Mundo en Varsovia, el mes anterior, el húngaro, Aron Szilagyi, consiguió dos victorias consecutivas al triunfar en la Copa del Mundo de sable masculino de Luxemburgo. El dos veces olímpico de oro venció al campeón del mundo de 2013, Veniamin Reshetnikov, por 15-9 en semifinales, antes de una victoria final por 1512 contra el surcoreano, Bongil Gu, en el centro nacional de esgrima y el complejo deportivo del Lycée de Garçons de Luxemburgo. Gu había derrotado a su compatriota y actual campeón del mundo, Sanguk Oh, en las últimas cuatro rondas de un evento con una fuerte presencia coreana dado que había una medalla de oro para los esgrimistas de la nación en la competencia por equipos, después de una victoria por 45-32 contra Italia. Los coreanos habían derrotado previamente a Alemania, por 45-37, en la semifinal, mientras que Italia ganó, por 45-42 a un equipo de Hungría y luego fue derrotada por un escaso margen en la lucha por la medalla de bronce contra Alemania (por 44-45). El Cairo, 21-23 de febrero: El cuarteto de Hong Kong hace historia. El Cairo fue testigo de un gran momento para el español Carlos Llavador en la prueba individual  de florete masculino. Llavador derrotó al estadounidense, Alexander Massialas, por 15-3 en semifinales y luego venció al italiano, Andrea Cassara, por 15-6 en la final, cambiando la situación de un oponente que le había ganado por 15-10 en la primera Copa del Mundo de la temporada en Bonn. «Estoy muy contento de haber logrado llegar al nivel que he estado tratando de alcanzar con esfuerzo», dijo el joven de 27 años después de logar su primera medalla de la Copa del Mundo, independientemente del color. Mientras tanto, en la prueba por equipos, EE. UU. terminó en el podio, venciendo a Rusia en la final por 45-36. En la semifinal, EE. UU. se impuso a Hong Kong por otro sólido margen de 45-37. Hong Kong logró el bronce, tras vencer a Francia por 4544 en un emocionante concurso, representado por el cuarteto de Cheung Ka-long, Cheung Siulun, Lawrence Ng Lok-wang y Ryan Choi Chun-yin. Anteriormente habían derrotado a Corea del Sur por 45-35 en cuartos de final. Kazán, 21-23 de febrero: Doblete italiano Los esgrimistas italianos ocuparon dos de los lugares del podio en la competencia individual de florete, con Elisa Di Francisca y Alice Volpi ganando las medallas de oro y bronce respectivamente También fue un fin de semana productivo para W W W.FIE .ORG",
            "mobileHtml": `
      <h4>Luxemburgo, 6-8 de marzo: Doble por Szilagyi</h4>
      <p>Después de seis años de espera por el oro de la Copa del Mundo en Varsovia, el mes anterior, el húngaro, Aron Szilagyi, consiguió dos victorias consecutivas al triunfar en la Copa del Mundo de sable masculino de Luxemburgo. El dos veces olímpico de oro venció al campeón del mundo de 2013, Veniamin Reshetnikov, por 15-9 en semifinales, antes de una victoria final por 15-12 contra el surcoreano, Bongil Gu, en el centro nacional de esgrima y el complejo deportivo del Lycée de Garçons de Luxemburgo. Gu había derrotado a su compatriota y actual campeón del mundo, Sanguk Oh, en las últimas cuatro rondas de un evento con una fuerte presencia coreana dado que había una medalla de oro para los esgrimistas de la nación en la competencia por equipos, después de una victoria por 45-32 contra Italia. Los coreanos habían derrotado previamente a Alemania, por 45-37, en la semifinal, mientras que Italia ganó, por 45-42 a un equipo de Hungría y luego fue derrotada por un escaso margen en la lucha por la medalla de bronce contra Alemania (por 44-45).</p>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 22,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg23.jpg",
            "zoom": null,
            "content": `
            <a href="http://www.fie.org" target="_blank">
              <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
            </a>
            <a href="https://twitter.com/FIE_fencing" target="_blank">
              <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/purple-twitter.png">
            </a>
            <a href="https://www.facebook.com/fie.org" target="_blank">
              <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/purple-facebook.png">
            </a>
            <img id="23-arrow" class="halfScale pointer" style="top:844px;left:1419px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/19-arrow.png">
            `,
            "script": `
            function onPageEnter() {
              pg23Anim = new TimelineMax();
                pg23Anim.fromTo(idOf("23-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
            }
            function onPageLeave() {
              pg23Anim.stop()
                removeContentLinks();
            }
      `,
            "searchText": "MES EN REVISIÓN FEBRERO 4/5  la china Shi Yue, que logró su medalla de plata en El Cairo en noviembre, llegando a la final con victorias consecutivas contra dos esgrimistas rusas, superando primero a la actual campeona olímpica y del mundo, Inna Deriglazova (por 1512) y luego a Adelina Zagidullina (por 15-10) en la semifinal. Di Francisca, la campeona olímpica de 2012, consiguió su primer oro en la Copa del Mundo desde 2018, gracias a una estrecha victoria por 9-8 en la final. En la prueba por equipos, Italia salió victoriosa en la final, superando a EE. UU. por 45-27. Llegaron a la final al vencer a Francia (por 45-28), mientras que, el triunfo de Estados Unidos en cuartos de final, por 45-37 contra Japón, fue seguido por una victoria por 45-36 contra Polonia. Varsovia, 21-22 de febrero: Oro por Szilagyi El dos veces campeón olímpico de Hungría, Aron Szilagyi, ganó el oro en la Copa del Mundo de sable masculino de Varsovia, venciendo al estadounidense, Eli Derschwitz, por 15-9 en la final. Fue el primer oro de la Copa del Mundo en seis años para Szilagyi, que había llegado antes a una semifinal contra Luca Curatoli en la que el italiano tuvo que retirarse por una lesión. Derschwitz no había ganado una medalla de la Copa del Mundo desde su triunfo en la capital polaca 12 meses antes, pero llegó a la final gracias a la victoria  contra Sanguk Oh, el actual campeón del mundo de Corea del Sur. Para el equipo masculino de sable de Corea del Sur, que ocupa el primer puesto en la clasificación, hubo un estrecho margen de derrota en la final contra Francia (por 43-45). Los esfuerzos de Francia por conseguir la medalla de oro, incluyendo una victoria en la semifinal, por 45-41 contra Italia, han vuelto a encarrilar su temporada Turín, 7-9 de febrero: Un cuento americano En el Gran Premio de esgrima de Turín hubo un triplete americano, ya que el trío formado por Gerek Meinhardt, Alexander Massialas y Race Imboden arrasó en el podio a favor de Estados Unidos en la competencia masculina. El único éxito previo de Meinhardt fue en un Gran Premio seis años antes, pero venció a Imboden, por 15-11 en la semifinal y luego derrotó a Massialas, su compañero de entrenamiento, en la final (por 15-8). EE. UU; habría conseguido otro oro si no fuera por los esfuerzos de la francesa, Ysaoura Thibus, en la final femenina. La estadounidense Thibus derrotó a Lee Kiefer por un solo toque (por 15-14) para obtener su primer medalla de oro en un Gran Premio. Mientras que Kiefer venció a la italiana, Alice Volpi, por 15-14 en una semifinal igualmente emocionante, Thibus se enfrentó desafiantes misiones contra la dos veces campeona del mundo, Arianna Errigo, (por 15-13 W W W.FIE .ORG",
            "mobileHtml": `
      <h4>El Cairo, 21-23 de febrero: El cuarteto de Hong Kong hace historia. </h4>
      <p>
      El Cairo fue testigo de un gran momento para el español Carlos Llavador en la prueba individual de florete masculino. Llavador derrotó al estadounidense, Alexander Massialas, por 15-3 en semifinales y luego venció al italiano, Andrea Cassara, por 15-6 en la final, cambiando la situación de un oponente que le había ganado por 15-10 en la primera Copa del Mundo de la temporada en Bonn. «Estoy muy contento de haber logrado llegar al nivel que he estado tratando de alcanzar con esfuerzo», dijo el joven de 27 años después de logar su primera medalla de la Copa del Mundo, independientemente del color.</p>
      <p>Mientras tanto, en la prueba por equipos, EE. UU. terminó en el podio, venciendo a Rusia en la final por 45-36. En la semifinal, EE. UU. se impuso a Hong Kong por otro sólido margen de 45-37.  Hong Kong logró el bronce, tras vencer a Francia por 45-44 en un emocionante concurso, representado por el cuarteto de Cheung Ka-long, Cheung Siu-lun, Lawrence Ng Lok-wang y Ryan Choi Chun-yin. Anteriormente habían derrotado a Corea del Sur por 45-35 en cuartos de final.</p>
      <h4>Kazán, 21-23 de febrero: Doblete italiano</h4>
      <p>
      Los esgrimistas italianos ocuparon dos de los lugares del podio en la competencia individual de florete, con Elisa Di Francisca y Alice Volpi ganando las medallas de oro y bronce respectivamente También fue un fin de semana productivo para la china Shi Yue, que logró su medalla de plata en El Cairo en noviembre, llegando a la final con victorias consecutivas contra dos esgrimistas rusas, superando primero a la actual campeona olímpica y del mundo, Inna Deriglazova (por 15-12) y luego a Adelina Zagidullina (por 15-10) en la semifinal. Di Francisca, la campeona olímpica de 2012, consiguió su primer oro en la Copa del Mundo desde 2018, gracias a una estrecha victoria por 9-8 en la final.
      En la prueba por equipos, Italia salió victoriosa en la final, superando a EE. UU. por 45-27. Llegaron a la final al vencer a Francia (por 45-28), mientras que, el triunfo de Estados Unidos en cuartos de final, por 45-37 contra Japón, fue seguido por una victoria por 45-36 contra Polonia.</p>
    
      <h4>Varsovia, 21-22 de febrero: Oro por Szilagyi</h4>
      <p>El dos veces campeón olímpico de Hungría, Aron Szilagyi, ganó el oro en la Copa del Mundo de sable masculino de Varsovia, venciendo al estadounidense, Eli Derschwitz, por 15-9 en la final. Fue el primer oro de la Copa del Mundo en seis años para Szilagyi, que había llegado antes a una semifinal contra Luca Curatoli en la que el italiano tuvo que retirarse por una lesión. Derschwitz no había ganado una medalla de la Copa del Mundo desde su triunfo en la capital polaca 12 meses antes, pero llegó a la final gracias a la victoria contra Sanguk Oh, el actual campeón del mundo de Corea del Sur. Para el equipo masculino de sable de Corea del Sur, que ocupa el primer puesto en la clasificación, hubo un estrecho margen de derrota en la final contra Francia (por 43-45). Los esfuerzos de Francia por conseguir la medalla de oro, incluyendo una victoria en la semifinal, por 45-41 contra Italia, han vuelto a encarrilar su temporada</p>
      <h4>Turín, 7-9 de febrero: Un cuento americano</h4>
      <p>En el Gran Premio de esgrima de Turín hubo un triplete americano, ya que el trío formado por Gerek Meinhardt, Alexander Massialas y Race Imboden arrasó en el podio a favor de Estados Unidos en la competencia masculina. El único éxito previo de Meinhardt fue en un Gran Premio seis años antes, pero venció a Imboden, por 15-11 en la semifinal y luego derrotó a Massialas, su compañero de entrenamiento, en la final (por 15-8). EE. UU; habría conseguido otro oro si no fuera por los esfuerzos de la francesa, Ysaoura Thibus, en la final femenina. La estadounidense Thibus derrotó a Lee Kiefer por un solo toque (por 15-14) para obtener su primer medalla de oro en un Gran Premio. Mientras que Kiefer venció a la italiana, Alice Volpi, por 15-14 en una semifinal igualmente emocionante, Thibus se enfrentó desafiantes misiones contra la dos veces campeona del mundo, Arianna Errigo, (por 15-13 en cuartos de final) y la actual campeona olímpica Inna Deriglazova (por 15-10 en semifinales). ¿Cuál fue la reacción de Thribus? «No tengo las palabras», escribió la chica de 28 años en su página de Instagram.</p>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 23,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg24.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.fie.org" target="_blank">
          <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/purple-twitter.png">
        </a>
        <a href="https://www.facebook.com/fie.org" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/purple-facebook.png">
        </a>
        <img id="24-arrow" class="halfScale pointer" style="top:844px;left:1388px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/19-arrow.png">
        `,
            "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax();
            pg24Anim.fromTo(idOf("24-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
        }
        function onPageLeave() {
          pg24Anim.stop()
            removeContentLinks();
        }
      `,
            "searchText": "MES EN REVISIÓN FEBRERO 5/5  en cuartos de final) y la actual campeona olímpica Inna Deriglazova (por 15-10 en semifinales). ¿Cuál fue la reacción de Thribus? «No tengo las palabras», escribió la chica de 28 años en su página de Instagram.  a octavos de final en Heidenheim el mes pasado, ya que se llevó el oro con un triunfo final de 39-24 contra Italia. Los coreanos habían ganado antes una apretada semifinal por 36-35 contra un equipo japonés que venció a Francia por el bronce.  Vancouver, 7-9 de febrero: Verwijlen de vuelta «El trabajo duro vale la pena» es un viejo lema del esgrimista holandés Bas Verwijlen, y ciertamente le valió la pena en la Copa del Mundo de espada masculina de Vancouver donde obtuvo el oro. Este hombre de 36 años ganó por primera vez una Copa del Mundo en Teherán en 2005, y ya habían pasado cinco años desde su último triunfo en este escenario, pero retrocedió en el tiempo con una victoria final de 15-9 contra el número 1 del mundo, el ruso, Sergey Bida. Verwijlen ha tenido sus dificultades con las lesiones a lo largo de una larga carrera, sin embargo, fue capaz de profundizar en sus reservas de talento y coraje, en particular al superar al actual campeón olímpico, Sangyoung Park, por un solo toque en octavos de final. En cuanto a Bida, entre sus víctimas en el camino hacia su segunda medalla de la Copa del Mundo de 2020 se encontraba Yannick Borel, el campeón del mundo de 2018, a quien venció por 15-13 en un disputado cuarto de final. La prueba por equipos terminó con una notable victoria para Corea del Sur, que dejó atrás su fracaso para llegar  Barcelona, 7-9 de febrero: Primer oro por Lehis Entre los aspectos más destacados de la Copa del Mundo de espada masculina de Barcelona se encuentra el regreso a la competición de Nathalie Moellhausen, la campeona del mundo brasileña, que se clasificó novena en su regreso tras una lesión en la mano. Mientras tanto, Man Wai Vivian Kong, derrotó a la ex campeona del mundo estonia Julia Beljajeva, por 15-10 en su lucha por el quinto puesto. Sin embargo, fue otra estonia, Katrina Lehis, la que se llevó todo el protagonismo cuando la joven de 25 años logró la medalla de oro, la primera de perteneciente a una prueba de la Copa del Mundo. En el camino derrotó a dos ex campeonas del mundo, la italiana, Mara Navarria, (por 15-11) y la rusa, Tatiana Gudkova, (por 11-10) en cuartos y semifinales respectivamente, antes de vencer a su compañera finalista por primera vez, Alexandra Louis-Marie, por 15-8 en la final. Mientras tanto, en la prueba por equipos, las espadistas femeninas de Corea ganaron la final por 39-34 contra China, mientras que EE. UU. se llevó el bronce con un resultado de 45-32 contra Rusia. W W W.FIE .ORG",
            "mobileHtml": `
      <h4>
      Vancouver, 7-9 de febrero: Verwijlen de vuelta </h4>
      <p>«El trabajo duro vale la pena» es un viejo lema del esgrimista holandés Bas Verwijlen, y ciertamente le valió la pena en la Copa del Mundo de espada masculina de Vancouver donde obtuvo el oro. Este hombre de 36 años ganó por primera vez una Copa del Mundo en Teherán en 2005, y ya habían pasado cinco años desde su último triunfo en este escenario, pero retrocedió en el tiempo con una victoria final de 15-9 contra el número 1 del mundo, el ruso, Sergey Bida. Verwijlen ha tenido sus dificultades con las lesiones a lo largo de una larga carrera, sin embargo, fue capaz de profundizar en sus reservas de talento y coraje, en particular al superar al actual campeón olímpico, Sangyoung Park, por un solo toque en octavos de final. En cuanto a Bida, entre sus víctimas en el camino hacia su segunda medalla de la Copa del Mundo de 2020 se encontraba Yannick Borel, el campeón del mundo de 2018, a quien venció por 15-13 en un disputado cuarto de final. La prueba por equipos terminó con una notable victoria para Corea del Sur, que dejó atrás su fracaso para llegar a octavos de final en Heidenheim el mes pasado, ya que se llevó el oro con un triunfo final de 39-24 contra Italia. Los coreanos habían ganado antes una apretada semifinal por 36-35 contra un equipo japonés que venció a Francia por el bronce.</p>

      <h4>Barcelona, 7-9 de febrero: Primer oro por Lehis</h4>
      <p>Entre los aspectos más destacados de la Copa del Mundo de espada masculina de Barcelona se encuentra el regreso a la competición de Nathalie Moellhausen, la campeona del mundo brasileña, que se clasificó novena en su regreso tras una lesión en la mano. Mientras tanto, Man Wai Vivian Kong, derrotó a la ex campeona del mundo estonia Julia Beljajeva, por 15-10 en su lucha por el quinto puesto. Sin embargo, fue otra estonia, Katrina Lehis, la que se llevó todo el protagonismo cuando la joven de 25 años logró la medalla de oro, la primera de perteneciente a una prueba de la Copa del Mundo. En el camino derrotó a dos ex campeonas del mundo, la italiana, Mara Navarria, (por 15-11) y la rusa, Tatiana Gudkova, (por 11-10) en cuartos y semifinales respectivamente, antes de vencer a su compañera finalista por primera vez, Alexandra Louis-Marie, por 15-8 en la final. Mientras tanto, en la prueba por equipos, las espadistas femeninas de Corea ganaron la final por 39-34 contra China, mientras que EE. UU. se llevó el bronce con un resultado de 45-32 contra Rusia.</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 24,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg25.jpg",
            "zoom": null,
            "content": `
        
      `,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/pg25.jpg">
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 25,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg26.jpg",
            "zoom": null,
            "content": `
        <img class="halfScale 26-title" style="top:95px;left:487px" src="/114/es/static/_content/26-title.png">
        <img class="halfScale 26-sub" style="top:277px;left:879px" src="/114/es/static/_content/26-sub.png">
        <img class="halfScale 26-line" style="top:274px;left:837px" src="/114/es/static/_content/26-line.png">

        <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
        `,
            "script": `
      function onPageEnter() {
        pg26Anim = new TimelineMax()
        pg26Anim.fromTo(cOf("26-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("26-line"), 0.6, {y:26, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("26-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg26Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE ESPADA MASCULINA HEIDENHEIM, ALEMANIA DE 9 AL 11 DE ENERO DE 2020",
            "mobileHtml": `
          <img src="/114/es/static/_mobile/heidenheim.jpg" >
          <p><strong>HEIDENHEIM, ALEMANIA<br>
          DE 9 AL 11 DE ENERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 26,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg27.jpg",
            "zoom": null,
            "content": `
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
        </a>
        <a href="https://twitter.com/FIE_fencing" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
        </a>
        <a href="https://fie.org/competitions" target="_blank">
              <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
        </a>
        <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
          <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
        </a>
        <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg27Anim = new TimelineMax()
        pg27Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg27Anim.stop()
      }
      `,
            "searchText": "COPA DEL MUNDO DE ESPADA MASCULINA DE HEIDENHEIM HEIDENHEIM, ALEMANIA 2/2  El campeón del mundo húngaro, Gergely Siklosi, ganó la medalla de oro en la 67.ª Copa del Mundo de espada masculina «Heidenheimer Pokal» en Heidenheim, y Alemania y Hungría también se llevaron la medalla de oro en las pruebas por equipos. El evento, que tuvo lugar en el «Bibris Halle», contó con la participación de 332 esgrimistas internacionales y equipos de 35 países.  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  En el último partido de la prueba de espada individual masculina, Siklosi derrotó al medallista de oro olímpico de Corea, Sangyoung Park, por un solo toque, ganando por 15-14. Park venció al polaco, Radoslaw Zawrotniak, en la ronda de semifinales por 15-9, mientras que Siklosi derrotó al ruso, Sergey Bida, por 15-8. Cabe destacar que el campeón del mundo francés, Yannick Borel, fue eliminado por Park en cuartos de final por un punto, por 15-14. En la prueba por equipos de espada masculina, Hungría se enfrentó a Francia por la medalla de oro, ganando con un resultado final de 45-43. Francia venció a Italia en semifinales, por 45-24, y Hungría derrotó a Suiza, por 45-34. Suiza  se llevó la medalla de bronce frente a Italia, por 45-36. Las clasificaciones finales de la Copa del Mundo de espada masculina individual de Heidenheim incluyeron a Gergely Siklosi (HUN, oro), Sangyoung Park (KOR, plata), Sergey Bida (RUS, bronce), Radoslaw Zawrotniak (POL, bronce), Yannick Borel (FRA), Igor Reizlin (UKR), Enrico Garozzo (ITA) y Martin Capek (CZE).  Las clasificaciones para la prueba masculina por equipos incluyeron a Hungría (oro), Francia (plata), Suiza (bronce), Italia, Ucrania, Kazajstán, Rusia y China. ■ W W W.FIE .ORG",
            "mobileHtml": `
          <p><b>El campeón del mundo húngaro, Gergely Siklosi, ganó la medalla de oro en la 67.ª Copa del Mundo de espada masculina «Heidenheimer Pokal» en Heidenheim, y Alemania y Hungría también se llevaron la medalla de oro en las pruebas por equipos.</b></p>
          <p>El evento, que tuvo lugar en el «Bibris Halle», contó con la participación de 332 esgrimistas internacionales y equipos de 35 países.</p>
          <p>En el último partido de la prueba de espada individual masculina, Siklosi derrotó al medallista de oro olímpico de Corea, Sangyoung Park, por un solo toque, ganando por 15-14. Park venció al polaco, Radoslaw Zawrotniak, en la ronda de semifinales por 15-9, mientras que Siklosi derrotó al ruso, Sergey Bida, por 15-8. Cabe destacar que el campeón del mundo francés, Yannick Borel, fue eliminado por Park en cuartos de final por un punto, por 15-14.
          </p>
          <p>En la prueba por equipos de espada masculina, Hungría se enfrentó a Francia por la medalla de oro, ganando con un resultado final de 45-43. Francia venció a Italia en semifinales, por 45-24, y Hungría derrotó a Suiza, por 45-34. Suiza se llevó la medalla de bronce frente a Italia, por 45-36.</p>
          <p>Las clasificaciones finales de la Copa del Mundo de espada masculina individual de Heidenheim incluyeron a Gergely Siklosi (HUN, oro), Sangyoung Park (KOR, plata), Sergey Bida (RUS, bronce), Radoslaw Zawrotniak (POL, bronce), Yannick Borel (FRA), Igor Reizlin (UKR), Enrico Garozzo (ITA) y Martin Capek (CZE).</p>
          <p>
          Las clasificaciones para la prueba masculina por equipos incluyeron a Hungría (oro), Francia (plata), Suiza (bronce), Italia, Ucrania, Kazajstán, Rusia y China.</p>
          <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
          <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 27,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg28.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 28-title" style="top:304px;left:870px" src="/114/es/static/_content/28-title.png">
      <img class="halfScale 28-sub" style="top:726px;left:912px" src="/114/es/static/_content/28-sub.png">
      <img class="halfScale 28-line" style="top:721px;left:867px" src="/114/es/static/_content/28-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg28Anim = new TimelineMax()
        pg28Anim.fromTo(cOf("28-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("28-line"), 0.6, {y:28, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("28-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg28Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE FLORETE FEMENINO DE KATOWICE KATOWICE, POLONIA DE 10 AL 12 DE ENERO DE 2020",
            "mobileHtml": `
      <img src="/114/es/static/_mobile/katowice.jpg" >
      <p><strong>KATOWICE, POLONIA<br>
      DE 10 AL 12 DE ENERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 28,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg29.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg29Anim = new TimelineMax()
        pg29Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg29Anim.stop()
      }
      `,
            "searchText": "COPA DEL MUNDO DE FLORETE FEMENINO DE KATOWICE KATOWICE, POLONIA 2/2  La medallista de oro olímpica y triple campeona del mundo rusa, Inna Deriglazova, se llevó la medalla de oro individual en la Copa del Mundo de florete femenino de Katowice, Polonia, y Rusia también ganó la prueba por equipos. La prueba, que se celebró en el «Spodek Hall» de Katowice, contó con la participación de 195 esgrimistas internacionales y equipos de 23 países.  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  Deriglazova se enfrentó a la italiana, Camilla Mancini, en la final de florete femenino individual, y ganó con un resultado de 15-11. Mancini derrotó a la francesa, Ysaora Thibus, en la ronda de semifinales, por 15-8, mientras que Deriglazova venció a la estadounidense Lee Kiefer, por 15-13. Cabe destacar que la italiana campeona olímpica y del mundo, Elisa Di Francisca, fue eliminada en cuartos de final por Thibus, por 15-10, y la doble campeona del mundo italiana, Arianna Errigo, perdió en la misma ronda ante Kiefer, por 15-13.  42-41, mientras que Rusia venció a EE. UU., por 45-36. La medalla de bronce fue para Italia tras derrotar a EE. UU., por 45-18.  Las clasificaciones finales de florete individual femenino incluyeron a Inna Deriglazova (RUS, oro), Camilla Mancini (ITA, plata), Lee Kiefer (USA, bronce), Ysaora Thibus (FRA, bronce), Elisa Di Francisca (ITA), Arianna Errigo (ITA), Martina Batini (ITA) y Song Oh Chae (KOR). Las clasificaciones finales por equipos incluyeron a Rusia (oro), Francia (plata), Italia (bronce), EE. UU., China, Japón, Hungría y Polonia. ■  En la prueba de florete femenino por equipos, Rusia venció a Francia para ganar la medalla de oro, por 45-42. Francia eliminó por un escaso margen a Italia en la ronda de semifinales, por W W W.FIE .ORG",
            "mobileHtml": `
          <p><b>La medallista de oro olímpica y triple campeona del mundo rusa, Inna Deriglazova, se llevó la medalla de oro individual en la Copa del Mundo de florete femenino de Katowice, Polonia, y Rusia también ganó la prueba por equipos.</b></p>
          <p>La prueba, que se celebró en el «Spodek Hall» de Katowice, contó con la participación de 
          195 esgrimistas internacionales y equipos de 23 países.</p>
          <p>Deriglazova se enfrentó a la italiana, Camilla Mancini, en la final de florete femenino individual, y ganó con un resultado de 15-11. Mancini derrotó a la francesa, Ysaora Thibus, en la ronda de semifinales, por 15-8, mientras que Deriglazova venció a la estadounidense Lee Kiefer, por 15-13. Cabe destacar que la italiana campeona olímpica y del mundo, Elisa Di Francisca, fue eliminada en cuartos de final por Thibus, por 15-10, y la doble campeona del mundo italiana, Arianna Errigo, perdió en la misma ronda ante Kiefer, por 15-13.</p>
          <p>
          En la prueba de florete femenino por equipos, Rusia venció a Francia para ganar la medalla de oro, por 45-42. Francia eliminó por un escaso margen a Italia en la ronda de semifinales, por 42-41, mientras que Rusia venció a EE. UU., por 45-36. La medalla de bronce fue para Italia tras derrotar a EE. UU., por 45-18. </p>
          <p>Las clasificaciones finales de florete individual femenino incluyeron a Inna Deriglazova (RUS, oro), Camilla Mancini (ITA, plata), Lee Kiefer (USA, bronce), Ysaora Thibus (FRA, bronce), Elisa Di Francisca (ITA), Arianna Errigo (ITA), Martina Batini (ITA) y Song Oh Chae (KOR).</p>
          <p>
          Las clasificaciones finales por equipos incluyeron a Rusia (oro), Francia (plata), Italia (bronce), EE. UU., China, Japón, Hungría y Polonia.</p>
          <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
          <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 29,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg30.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 30-title" style="top:87px;left:86px" src="/114/es/static/_content/30-title.png">
      <img class="halfScale 30-sub" style="top:267px;left:741px" src="/114/es/static/_content/30-sub.png">
      <img class="halfScale 30-line" style="top:263px;left:697px" src="/114/es/static/_content/30-line-1.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      
      `,
            "script": `
      function onPageEnter() {
        pg30Anim = new TimelineMax()
        pg30Anim.fromTo(cOf("30-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("30-line"), 0.6, {y:30, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("30-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg30Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE ESPADA FEMENINA DE LA HABANA LA HABANA, CUBA DE 10 AL 12 DE ENERO DE 2020",
            "mobileHtml": `
      <img src="/114/es/static/_mobile/havana.jpg" >
      <p><strong>LA HABANA, CUBA<br>
      DE 10 AL 12 DE ENERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 30,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg31.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg31Anim = new TimelineMax()
        pg31Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg31Anim.stop()
      }
      `,
            "searchText": "venció a Ucrania en semifinales, por 45-33, mientras que Italia derrotó por un escaso margen a Francia, por 41-40. La medalla de bronce fue para Francia, que venció a Ucrania por un solo toque, con un resultado de 45-44.   COPA DEL MUNDO DE ESPADA FEMENINA DE LA HABANA LA HABANA, CUBA 2/2  La polaca Aleksandra Zamachowska se llevó la medalla de oro en la Copa del Mundo de espada femenina de La Habana, con Italia ganando la prueba por equipos La prueba se celebró en el Coliseo de la Ciudad Deportiva de La Habana y contó con la participación de 181 competidores internacionales y equipos de 21 países.  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  En el último partido de espada femenina individual, Zamachowska se enfrentó a la rumana, Ana Maria Popescu, y ganó con un resultado de 15-8. Popescu venció a la francesa Marie-Florence Candassamy en la ronda de semifinales, por 1210, y Zamachowska derrotó a su compañera de equipo Renata Knapik-Miazga, por 15-12. Cabe destacar que la italiana campeona del mundo, Mara Navarria, fue eliminada por la china Yiwen Sun en octavos de final, por 15-11.  Las clasificaciones finales de espada individual femenina incluyeron a Aleksandra Zamachowska (POL, oro), Ana Maria Popescu (ROU, plata), Marie-Florence Candassamy (FRA, bronce), Renata Knapik-Miazga (POL, bronce), Yiwen Sun (CHN), Kelley Hurley (USA), Erika Kirpu (EST) y Amalia Tataran (ROU).  Las clasificaciones finales para la prueba de espada femenina por equipos incluyeron a Alemania (oro), Estonia (plata), Italia (bronce), China, Rusia, Polonia, EE. UU. y Francia.. ■  En la final de la prueba de espada femenina por equipos, Italia venció a Estonia, por 33-30. Estonia W W W.FIE .ORG",
            "mobileHtml": `
        <p><b>La polaca Aleksandra Zamachowska se llevó la medalla de oro en la Copa del Mundo de espada femenina de La Habana, con Italia ganando la prueba por equipos.</b></p>
        <p>La prueba se celebró en el Coliseo de la Ciudad Deportiva de La Habana y contó con la participación de 181 competidores internacionales y equipos de 21 países.
        </p>
        <p>En el último partido de espada femenina individual, Zamachowska se enfrentó a la rumana, Ana Maria Popescu, y ganó con un resultado de 15-8. Popescu venció a la francesa Marie-Florence Candassamy en la ronda de semifinales, por 12-10, y Zamachowska derrotó a su compañera de equipo Renata Knapik-Miazga, por 15-12. Cabe destacar que la italiana campeona del mundo, Mara Navarria, fue eliminada por la china Yiwen Sun en octavos de final, por 15-11.
        </p>
        <p>En la final de la prueba de espada femenina por equipos, Italia venció a Estonia, por 33-30. Estonia venció a Ucrania en semifinales, por 45-33, mientras que Italia derrotó por un escaso margen a Francia, por 41-40. La medalla de bronce fue para Francia, que venció a Ucrania por un solo toque, con un resultado de 45-44. </p>
        <p>Las clasificaciones finales de espada individual femenina incluyeron a Aleksandra Zamachowska (POL, oro), Ana Maria Popescu (ROU, plata), Marie-Florence Candassamy (FRA, bronce), Renata Knapik-Miazga (POL, bronce), Yiwen Sun (CHN), Kelley Hurley (USA), Erika Kirpu (EST) y Amalia Tataran (ROU).</p>
        <p>Las clasificaciones finales para la prueba de espada femenina por equipos incluyeron a Alemania (oro), Estonia (plata), Italia (bronce), China, Rusia, Polonia, EE. UU. y Francia.</p>
        <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
        <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 31,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg32.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 32-title" style="top:85px;left:81px" src="/114/es/static/_content/32-title.png">
      <img class="halfScale 32-sub" style="top:156px;left:649px" src="/114/es/static/_content/32-sub.png">
      <img class="halfScale 32-line" style="top:158px;left:604px" src="/114/es/static/_content/32-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg32Anim = new TimelineMax()
        pg32Anim.fromTo(cOf("32-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("32-line"), 0.6, {y:32, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("32-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg32Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE FLORETE PARÍS, FRANCIA MASCULINO DE 10 AL 12 DE ENERO DE 2020",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/paris.jpg" >
        <p><strong>PARÍS, FRANCIA<br>
        DE 10 AL 12 DE ENERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 32,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg33.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg33Anim = new TimelineMax()
        pg33Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg33Anim.stop()
      }
      `,
            "searchText": "COPA DEL MUNDO DE FLORETE MASCULINO DE PARÍS PARÍS, FRANCIA 2/2  El estadounidense Nick Itkin se llevó el oro en la Copa del Mundo de florete masculino del Challenge International de París, y Estados Unidos también ganó la prueba por equipos. En el estadio Pierre de Coubertin participaron 254 esgrimistas internacionales y equipos de 25 países. Itkin se enfrentó al campeón olímpico italiano Daniele Garozzo en la ronda final de florete masculino individual, ganando con un resultado de 15-9. Garozzo derrotó al campeón del mundo  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  de Rusia, Alexey Cheremisinov, en la ronda de semifinales por 15-11, e Itkin venció al campeón del mundo francés, Enzo Lefort, por 15-12. Cabe destacar que el campeón del mundo italiano Andrea Cassara fue derrotado en octavos de final por el francés, Erwann Le Pechoux, por 15-6, mientras que el italiano, Alessio Foconi, también campeón del mundo, perdió en la misma ronda ante el checo, Alexander Choupenitch, por 15-11. En el encuentro por la medalla de oro de la prueba de florete masculino, EE. UU. derrotó a Italia por 45-36. Italia venció a Francia por un solo punto en la semifinal, por 45-44, y EE. UU. derrotó a Hong Kong, por 45-27. La medalla de bronce fue para Francia tras derrotar a Hong Kong, por 45-38.  Las clasificaciones finales de florete masculino individual incluyeron a Nick Itkin (USA, oro), Daniele Garozzo (ITA, plata), Alexey Cheremisinov (RUS, bronce), Enzo Lefort (FRA, bronce), Erwann Le Pechoux (FRA), Maxime Pauty (FRA), Anton Borodachev (RUS) y Alexander Choupenitch (CZE).  Las clasificaciones finales de florete masculino por equipos incluyeron a EE.UU. (oro), Italia (plata), Francia (bronce), Hong Kong, Rusia, Corea, Japón y China.. ■ W W W.FIE .ORG",
            "mobileHtml": `
        <p><b>
        El estadounidense Nick Itkin se llevó el oro en la Copa del Mundo de florete masculino del Challenge International de París, y Estados Unidos también ganó la prueba por equipos.</b></p>
        <p>En el estadio Pierre de Coubertin participaron 254 esgrimistas internacionales y equipos de 
        25 países.</p>
        <p>Itkin se enfrentó al campeón olímpico italiano Daniele Garozzo en la ronda final de florete masculino individual, ganando con un resultado de 15-9. Garozzo derrotó al campeón del mundo de Rusia, Alexey Cheremisinov, en la ronda de semifinales por 15-11, e Itkin venció al campeón del mundo francés, Enzo Lefort, por 15-12. Cabe destacar que el campeón del mundo italiano Andrea Cassara fue derrotado en octavos de final por el francés, Erwann Le Pechoux, por 15-6, mientras que el italiano, Alessio Foconi, también campeón del mundo, perdió en la misma ronda ante el checo, Alexander Choupenitch, por 15-11.</p>
        <p>En el encuentro por la medalla de oro de la prueba de florete masculino, EE. UU. derrotó a Italia por 45-36. Italia venció a Francia por un solo punto en la semifinal, por 45-44, y EE. UU. derrotó a Hong Kong, por 45-27. La medalla de bronce fue para Francia tras derrotar a Hong Kong, por 45-38. </p>
        <p>Las clasificaciones finales de florete masculino individual incluyeron a Nick Itkin (USA, oro), Daniele Garozzo (ITA, plata), Alexey Cheremisinov (RUS, bronce), Enzo Lefort (FRA, bronce), Erwann Le Pechoux (FRA), Maxime Pauty (FRA), Anton Borodachev (RUS) y Alexander Choupenitch (CZE). </p>
        <p>
        Las clasificaciones finales de florete masculino por equipos incluyeron a EE.UU. (oro), Italia (plata), Francia (bronce), Hong Kong, Rusia, Corea, Japón y China.</p>
        <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
        <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 33,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg34.jpg",
            "zoom": null,
            "content": `
        <div class="contentLink" style="bottom:52px;left:136px;width:130px; height:20px;">
          <a href="http://www.uhlmann-fencing.com" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:50px;left:74px;width:25px; height:25px;">
          <a href="https://www.facebook.com/uhlmann.fencing/" target="_blank"></a>
        </div>
        <div class="contentLink" style="bottom:50px;left:104px;width:25px; height:25px;">
          <a href="http://www.instagram.com/Uhlmann.Fencing" target="_blank"></a>
        </div>
    `,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "",
            "mobileHtml": `
      
      <a href="http://www.uhlmann-fencing.com" target="_blank">
        <img src="/114/es/static/_mobile/pg34.jpg">
      </a>

      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 34,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg35.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 35-title" style="top:436px;left:85px" src="/114/es/static/_content/35-title.png">
      <img class="halfScale 35-sub" style="top:692px;left:131px" src="/114/es/static/_content/35-sub.png">
      <img class="halfScale 35-line" style="top:693px;left:87px" src="/114/es/static/_content/35-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg35Anim = new TimelineMax()
        pg35Anim.fromTo(cOf("35-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("35-line"), 0.6, {y:35, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("35-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg35Anim.stop()
      }
      `,
            "searchText": "GR AN PREMIO  EL GRAN PREMIO DE SABLE DE MONTREAL MONTREAL, QUEBEC, CANADÁ DE 10 AL 12 DE DICIEMBRE DE 2019",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/montreal.jpg" >
        <p><strong>MONTREAL, QUEBEC, CANADÁ <br>
        DE 10 AL 12 DE DICIEMBRE DE 2019</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 35,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg36.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg36Anim = new TimelineMax()
        pg36Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg36Anim.stop()
      }
      `,
            "searchText": "EL GRAN PREMIO DE SABLE DE MONTREAL MONTREAL, QUEBEC, CANADÁ 2/3  El francés Bolade Apithy y la cuatro veces campeona del mundo de Ucrania Olga Kharlan ganaron las medallas de oro individuales en el Gran Premio Sabre de Montreal de 2020. Este fue el primer Gran Premio de la serie de nueve pruebas de la temporada 2019-2020 de la FIE. Con la participación de 146 mujeres y 150 hombres de todo el mundo, el evento tuvo lugar en el estadio IGA de Montreal. En el último partido de sable individual masculino, Apithy combatió al italiano Luca Curatoli, ganando con un resultado de 15-12. Curatoli derrotó al georgiano Sandro Bazadze en la semifinal, por 15-9, mientras que Apithy  venció al italiano Luigi Samele, por 15-8. Cabe destacar que en cuartos de final, Apithy venció al campeón del mundo coreano Junghwan Kim por un solo punto, por 15-14; Samele ganó contra el húngaro dos veces ganador de la medalla de oro olímpica, Aron Szilagyi, por 1510; y Bazadze venció por un escaso margen al campeón del mundo coreano, Sanguk Oh, por un toque, por 15-14. W W W.FIE .ORG",
            "mobileHtml": `
        <p><b>El francés Bolade Apithy y la cuatro veces campeona del mundo de Ucrania Olga Kharlan ganaron las medallas de oro individuales en el Gran Premio Sabre de Montreal de 2020.</b></p>
        <p>Este fue el primer Gran Premio de la serie de nueve pruebas de la temporada 2019-2020 de la FIE. Con la participación de 146 mujeres y 150 hombres de todo el mundo, el evento tuvo lugar en el estadio IGA de Montreal.
        </p>
        <p>En el último partido de sable individual masculino, Apithy combatió al italiano Luca Curatoli, ganando con un resultado de 15-12. Curatoli derrotó al georgiano Sandro Bazadze en la semifinal, por 15-9, mientras que Apithy venció al italiano Luigi Samele, por 15-8. Cabe destacar que en cuartos de final, Apithy venció al campeón del mundo coreano Junghwan Kim por un solo punto, por 15-14; Samele ganó contra el húngaro dos veces ganador de la medalla de oro olímpica, Aron Szilagyi, por 15-10; y Bazadze venció por un escaso margen al campeón del mundo coreano, Sanguk Oh, por un toque, por 15-14.</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 36,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg37.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg37Anim = new TimelineMax()
        pg37Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg37Anim.stop()
      }
      `,
            "searchText": "EL GRAN PREMIO DE SABLE DE MONTREAL MONTREAL, QUEBEC, CANADÁ 3/3  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  Kharlan ganó contra la rusa Olga Nikitina en la final de sable individual femenino, por 157. Nikitina derrotó a la francesa, Charlotte Lembach, en la ronda de semifinales, por 156, y Kharlan venció a la china Yaqi Shao por un punto, por 15-14. Cabe destacar que la francesa Sara Balzer derrotó a la campeona del mundo rusa, Sofía Pozdniakova, en octavos de final, por 15-12, y Kharlan venció a la dos veces campeona olímpica y doble campeona del mundo de EE. UU. Mariel Zagunis, por 15-8.  Las clasificaciones para el sable individual femenino incluyeron a Olga Kharlan (UKR, oro), Olga Nikitina (RUS, plata), Charlotte Lembach (FRA, bronce), Yaqi Shao (CHN, bronce), AnneElizabeth Stone (USA), Cecilia Berder (FRA), Jisu Yoon (KOR) y Sara Balzer (FRA). ■  Las clasificaciones finales para la prueba de sable individual masculino incluyeron a Bolade Apithy (FRA, oro), Luca Curatoli (ITA, plata), Sandro Bazadze (GEO, bronce), Luigi Samele (ITA, bronce), Sanguk Oh (KOR), Aron Szilagyi (HUN), Junghwan Kim (KOR) y Daryl Homer (USA). W W W.FIE .ORG",
            "mobileHtml": `
        <p>Kharlan ganó contra la rusa Olga Nikitina en la final de sable individual femenino, por 15-7. Nikitina derrotó a la francesa, Charlotte Lembach, en la ronda de semifinales, por 15-6, y Kharlan venció a la china Yaqi Shao por un punto, por 15-14. Cabe destacar que la francesa Sara Balzer derrotó a la campeona del mundo rusa, Sofía Pozdniakova, en octavos de final, por 15-12, y Kharlan venció a la dos veces campeona olímpica y doble campeona del mundo de EE. UU. Mariel Zagunis, por 15-8.
        </p>
        <p>Las clasificaciones finales para la prueba de sable individual masculino incluyeron a Bolade Apithy (FRA, oro), Luca Curatoli (ITA, plata), Sandro Bazadze (GEO, bronce), Luigi Samele (ITA, bronce), Sanguk Oh (KOR), Aron Szilagyi (HUN), Junghwan Kim (KOR) y Daryl Homer (USA).</p>
        <p>
        Las clasificaciones para el sable individual femenino incluyeron a Olga Kharlan (UKR, oro), Olga Nikitina (RUS, plata), Charlotte Lembach (FRA, bronce), Yaqi Shao (CHN, bronce), Anne-Elizabeth Stone (USA), Cecilia Berder (FRA), Jisu Yoon (KOR) y Sara Balzer (FRA).
        </p>
        <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
        <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 37,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg38.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 38-title" style="top:127px;left:83px" src="/114/es/static/_content/38-title.png">
      <img class="halfScale 38-sub" style="top:311px;left:129px" src="/114/es/static/_content/38-sub.png">
      <img class="halfScale 38-line" style="top:306px;left:84px" src="/114/es/static/_content/38-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg38Anim = new TimelineMax()
        pg38Anim.fromTo(cOf("38-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("38-line"), 0.6, {y:38, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("38-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg38Anim.stop()
      }
      `,
            "searchText": "GR AN PREMIO  EL GRAN PREMIO DE ESPADA DE DOHA DOHA, CATAR DE 24 AL 26 DE ENERO DE 2020",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/doha.jpg" >
        <p><strong>DOHA, CATAR<br>
        DE 24 AL 26 DE ENERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 38,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg39.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg39Anim = new TimelineMax()
        pg39Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg39Anim.stop()
      }
      `,
            "searchText": "EL GRAN PREMIO DE ESPADA DE DOHA DOHA, CATAR 2/3  El ruso, Sergey Bida, y la rumana, Ana Maria Popescu, ganaron las medallas de oro en la prueba individual de espada masculina y femenina en el Gran Premio de Doha de 2020. En este segundo Gran Premio de la serie de nueve pruebas de la temporada 2019-2020 de la FIE, participaron 219 esgrimistas internacionales masculinos y 176 femeninos en el Aspire Dome de Catar.  En el último partido de la prueba individual de espada masculina, Bida se enfrentó al francés, Alexandre Bardenet, ganando con un resultado de 15-6. Bardenet venció al italiano, Andrea Santarelli, en la semifinal, por 15-10, mientras que Bida derrotó al japonés Masaru Yamada, por 15-8. Cabe destacar que el campeón olímpico coreano, Sangyoung Park, cayó en octavos de final contra el francés, Daniel Jerent, por 15-10, y el francés campeón del mundo, Yannick Borel, perdió en la misma ronda contra Yamada, por 15-9. Popescu logró la victoria en la ronda final de la prueba individual de espada femenina, venciendo a la campeona del mundo italiana, Mara Navarria, por 15-9. Navarria derrotó a la estonia, Erika Kirpu, en la semifinal, por 15-13, mientras que Popescu ganó contra la rusa, Tatyana Andryushina, por 15-5. Navarria también venció a la campeona del mundo rusa, Tatiana Gudkova, en octavos de final, por 15-10. W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>
      El ruso, Sergey Bida, y la rumana, Ana Maria Popescu, ganaron las medallas de oro en la prueba individual de espada masculina y femenina en el Gran Premio de Doha de 2020.
      </b></p>
      <p>En este segundo Gran Premio de la serie de nueve pruebas de la temporada 2019-2020 de la FIE, participaron 219 esgrimistas internacionales masculinos y 176 femeninos en el Aspire Dome de Catar.
      </p>
      <p>En el último partido de la prueba individual de espada masculina, Bida se enfrentó al francés, Alexandre Bardenet, ganando con un resultado de 15-6. Bardenet venció al italiano, Andrea Santarelli, en la semifinal, por 15-10, mientras que Bida derrotó al japonés Masaru Yamada, por 15-8. Cabe destacar que el campeón olímpico coreano, Sangyoung Park, cayó en octavos de final contra el francés, Daniel Jerent, por 15-10, y el francés campeón del mundo, Yannick Borel, perdió en la misma ronda contra Yamada, por 15-9.
      </p>
      <p>Popescu logró la victoria en la ronda final de la prueba individual de espada femenina, venciendo a la campeona del mundo italiana, Mara Navarria, por 15-9. Navarria derrotó a la estonia, Erika Kirpu, en la semifinal, por 15-13, mientras que Popescu ganó contra la rusa, Tatyana Andryushina, por 15-5. Navarria también venció a la campeona del mundo rusa, Tatiana Gudkova, en octavos de final, por 15-10.</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 39,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg40.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg40Anim = new TimelineMax()
        pg40Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg40Anim.stop()
      }
      `,
            "searchText": "EL GRAN PREMIO DE ESPADA DE DOHA DOHA, CATAR 3 OF 3  Las clasificaciones finales de espada masculina del Gran Premio de Doha incluyeron a Sergey Bida (RUS, oro), Alexandre Bardenet (FRA, plata), Andrea Santarelli (ITA, bronce), Masaru Yamada (JPN, bronce), Bas Verwijlen (NED), Gianpaolo Buzzacchino (ITA), David Nagy (HUN) y Daniel Jerent (FRA).   Las clasificaciones finales de espada individual femenina incluyeron a Ana Maria Popescu (ROU, oro), Mara Navarria (ITA, plata), Tatyana Andryushina (RUS, bronce), Erika Kirpu (EST, bronce), Injeong Choi (KOR), Katharine Holmes (USA), Auriane Mallo (FRA) y Yulia Lichagina (RUS). ■  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  W W W.FIE .ORG",
            "mobileHtml": `
        <p>Las clasificaciones finales de espada masculina del Gran Premio de Doha incluyeron a Sergey Bida (RUS, oro), Alexandre Bardenet (FRA, plata), Andrea Santarelli (ITA, bronce), Masaru Yamada (JPN, bronce), Bas Verwijlen (NED), Gianpaolo Buzzacchino (ITA), David Nagy (HUN) y Daniel Jerent (FRA)..
        </p>
        <p>Las clasificaciones finales de espada individual femenina incluyeron a Ana Maria Popescu (ROU, oro), Mara Navarria (ITA, plata), Tatyana Andryushina (RUS, bronce), Erika Kirpu (EST, bronce), Injeong Choi (KOR), Katharine Holmes (USA), Auriane Mallo (FRA) y Yulia Lichagina (RUS).
        </p>
        <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
        <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 40,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg41.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 41-title" style="top:81px;left:82px" src="/114/es/static/_content/41-title.png">
      <img class="halfScale 41-sub" style="top:259px;left:127px" src="/114/es/static/_content/41-sub.png">
      <img class="halfScale 41-line" style="top:260px;left:84px" src="/114/es/static/_content/41-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg41Anim = new TimelineMax()
        pg41Anim.fromTo(cOf("41-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("41-line"), 0.6, {y:41, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("41-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg41Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE ESGRIMA FEMENINA DE BARCELONA BARCELONA, ESPAÑA DE 7 AL 9 DE FEBRERO DE 2020",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/barcelona.jpg" >
        <p><strong>BARCELONA, ESPAÑA<br>
        DE 7 AL 9 DE FEBRERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 41,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg42.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
          function onPageEnter() {
        pg42Anim = new TimelineMax()
        pg42Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg42Anim.stop()
      }
      `,
            "searchText": "COPA DEL MUNDO DE ESGRIMA FEMENINA DE BARCELONA BARCELONA, ESPAÑA 2/2  La estonia, Katrina Lehis, se hizo con la victoria en la 44.ª Copa del Mundo de espada femenina «Ciutat de Barcelona», en la que Corea ganó la prueba por equipos femeninos. La competencia tuvo lugar en el Institut Nacional d'Educació Fisica de Catalunya (INEFC) y contó con la participación de 275 espadistas femeninas internacionales y equipos de 27 países.  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  Lehis se enfrentó a la francesa, Alexandra Louis Marie, en el partido por la medalla de oro de la prueba individual de espada femenina, ganando con un resultado de 15-8. En semifinales, Louis Marie venció a la coreana, Young Mi Kang, por 15-10, mientras que Lehis derrotó a la campeona del mundo rusa, Tatiana Gudkova, por un punto, por 11-10. La campeona del mundo italiana, Mara Navarria, cayó en cuartos de final ante Lehis, y en octavos de final Gudkova venció a la campeona del mundo brasileña, Nathalie Moellhausen, por 15-9, y, Man Wai Vivian Kong, de Hong Kong venció a la campeona del mundo estonia, Julia Beljajeva, por 15-10.  39-34. China venció a Rusia en la semifinal, por 45-30, mientras que EE. UU. cayó frente a Corea, por 45-32. EE. UU. se llevó la medalla de bronce frente a Rusia, por 45-27.   Las clasificaciones finales de la Copa del Mundo de esgrima individual de espada femenina de Barcelona incluyeron a Katrina Lehis (EST, oro), Alexandra Louis Marie (FRA, plata), Tatiana Gudkova (RUS, bronce), Young Mi Kang (KOR, bronce), Man Wai Vivian Kong (HKG), Injeong Choi (KOR), Mara Navarria (ITA) y Leonora Mackinnon (CAN). Las clasificaciones por equipos de espada femenina incluyeron a Corea (oro), China (plata), EE. UU. (bronce), Rusia, Hungría, Polonia, Francia y Hong Kong. . ■  En la prueba por equipos de espada femenina, Corea venció a China por la medalla de oro, por W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>La estonia, Katrina Lehis, se hizo con la victoria en la 44.ª Copa del Mundo de espada femenina «Ciutat de Barcelona», en la que Corea ganó la prueba por equipos femeninos.
      </b></p>
      <p>La competencia tuvo lugar en el Institut Nacional d'Educació Fisica de Catalunya (INEFC) y contó con la participación de 275 espadistas femeninas internacionales y equipos de 27 países.
      </p>
      <p>Lehis se enfrentó a la francesa, Alexandra Louis Marie, en el partido por la medalla de oro de la prueba individual de espada femenina, ganando con un resultado de 15-8. En semifinales, Louis Marie venció a la coreana, Young Mi Kang, por 15-10, mientras que Lehis derrotó a la campeona del mundo rusa, Tatiana Gudkova, por un punto, por 11-10. La campeona del mundo italiana, Mara Navarria, cayó en cuartos de final ante Lehis, y en octavos de final Gudkova venció a la campeona del mundo brasileña, Nathalie Moellhausen, por 15-9, y, Man Wai Vivian Kong, de Hong Kong venció a la campeona del mundo estonia, Julia Beljajeva, por 15-10.
      </p>
      <p>En la prueba por equipos de espada femenina, Corea venció a China por la medalla de oro, por 39-34. China venció a Rusia en la semifinal, por 45-30, mientras que EE. UU. cayó frente a Corea, por 45-32. EE. UU. se llevó la medalla de bronce frente a Rusia, por 45-27.</p>
      <p>Las clasificaciones finales de la Copa del Mundo de esgrima individual de espada femenina de Barcelona incluyeron a Katrina Lehis (EST, oro), Alexandra Louis Marie (FRA, plata), Tatiana Gudkova (RUS, bronce), Young Mi Kang (KOR, bronce), Man Wai Vivian Kong (HKG), Injeong Choi (KOR), Mara Navarria (ITA) y Leonora Mackinnon (CAN). 
      </p>
      <p>Las clasificaciones por equipos de espada femenina incluyeron a Corea (oro), China (plata), EE. UU. (bronce), Rusia, Hungría, Polonia, Francia y Hong Kong.
      </p>
      <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
      <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 42,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg43.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.blue-gauntlet.com" target="_blank">
            <div class="contentLinkNone" style="top:910px;left:344px;width:223px; height:28px;"></div>
          </a>
          
          <a href="mailto:service@blue-gauntletservice.com">
            <div class="contentLinkNone" style="top:865px;left:344px;width:293px; height:28px;"></div>
          </a>
          `,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "",
            "mobileHtml": `  
        <a href="http://www.blue-gauntlet.com" target="_blank">
        <img src="/114/es/static/_mobile/pg43.jpg">
        </a>
      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 43,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg44.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 44-title" style="top:86px;left:616px" src="/114/es/static/_content/44-title.png">
      <img class="halfScale 44-sub" style="top:342px;left:943px" src="/114/es/static/_content/44-sub.png">
      <img class="halfScale 44-line" style="top:344px;left:900px" src="/114/es/static/_content/44-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg44Anim = new TimelineMax()
        pg44Anim.fromTo(cOf("44-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("44-line"), 0.6, {y:44, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("44-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg44Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE ESGRIMA DE ESPADA MASCULINA VANCOUVER, CANADÁ DE 7 AL 9 DE FEBRERO DE 2020",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/vancouver.jpg" >
        <p><strong>VANCOUVER, CANADÁ<br>
        DE 7 AL 9 DE FEBRERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 44,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg45.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg45Anim = new TimelineMax()
        pg45Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg45Anim.stop()
      }
      `,
            "searchText": "al ucraniano Bogdan Nikishin, por 15-11. Cabe destacar que Bida venció al campeón del mundo francés, Yannick Borel, en cuartos de final, por 1513, mientras que en octavos de final, el campeón olímpico coreano, Sangyoung Park, perdió ante Verwijlen por un toque, por 15-14, y Limardo Gascón derrotó al campeón del mundo húngaro, Gergely Siklosi, por 15-8.  COPA DEL MUNDO DE ESGRIMA DE ESPADA MASCULINA DE VANCOUVER VANCOUVER, CANADÁ 2/2  El holandés, Bas Verwijlen, ganó la medalla de oro en la Copa del Mundo de espada masculina Peter Bakonyi 2020 en Vancouver, mientras que Corea ganó la prueba por equipos. PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  En la competencia, que tuvo lugar en el Óvalo Olímpico de Richmond participaron 200 espadistas y equipos internacionales masculinos de 24 países. Verwijlen se enfrentó al ruso, Sergey Bida, en la final, ganando con un resultado de 15-9 por la medalla de oro. Bida venció al campeón olímpico venezolano, Rubén Limardo Gascón, en la ronda de semifinales, por 15-10, y Verwijlen derrotó  En la prueba por equipos de espada masculina, Corea se hizo con la victoria frente a Italia en el último partido, por 39-24. En la ronda de semifinales, Italia venció a Francia, por 45-39, y Corea ganó por un escaso margen a Japón, por 36-35. La medalla de bronce fue para Japón tras derrotar a Francia, por 45-34.  Las clasificaciones finales de la Copa del Mundo de esgrima de espada masculina de Vancouver incluyeron a Bas Verwijlen (NED, oro), Sergey Bida (RUS, plata), Rubén Limardo Gascón (VEN, bronce), Bogdan Nikishin (UKR, bronce), Yannick Borel (FRA), Andras Redli (HUN), Max Heinzer (SUI) y Gabriele Cimini (ITA).  Las clasificaciones por equipos para la prueba de espada incluyeron a Corea (oro), Italia (plata), Japón (bronce), Francia, Rusia, Ucrania, EE. UU. y España. ■ W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>El holandés, Bas Verwijlen, ganó la medalla de oro en la Copa del Mundo de espada masculina Peter Bakonyi 2020 en Vancouver, mientras que Corea ganó la prueba por equipos.
      </b></p>
      <p>En la competencia, que tuvo lugar en el Óvalo Olímpico de Richmond participaron 200 espadistas y equipos internacionales masculinos de 24 países.
      </p>
      <p>Verwijlen se enfrentó al ruso, Sergey Bida, en la final, ganando con un resultado de 15-9 por la medalla de oro. Bida venció al campeón olímpico venezolano, Rubén Limardo Gascón, en la ronda de semifinales, por 15-10, y Verwijlen derrotó al ucraniano Bogdan Nikishin, por 15-11. Cabe destacar que Bida venció al campeón del mundo francés, Yannick Borel, en cuartos de final, por 15-13, mientras que en octavos de final, el campeón olímpico coreano, Sangyoung Park, perdió ante Verwijlen por un toque, por 15-14, y Limardo Gascón derrotó al campeón del mundo húngaro, Gergely Siklosi, por 15-8.
      </p>
      <p>En la prueba por equipos de espada masculina, Corea se hizo con la victoria frente a Italia en el último partido, por 39-24. En la ronda de semifinales, Italia venció a Francia, por 45-39, y Corea ganó por un escaso margen a Japón, por 36-35. La medalla de bronce fue para Japón tras derrotar a Francia, por 45-34. 
      </p>
      <p>Las clasificaciones finales de la Copa del Mundo de esgrima de espada masculina de Vancouver incluyeron a Bas Verwijlen (NED, oro), Sergey Bida (RUS, plata), Rubén Limardo Gascón (VEN, bronce), Bogdan Nikishin (UKR, bronce), Yannick Borel (FRA), Andras Redli (HUN), Max Heinzer (SUI) y Gabriele Cimini (ITA). 
      </p>
      <p>Las clasificaciones por equipos para la prueba de espada incluyeron a Corea (oro), Italia (plata), Japón (bronce), Francia, Rusia, Ucrania, EE. UU. y España.
      </p>
      <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
      <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 45,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg46.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 46-title" style="top:122px;left:121px" src="/114/es/static/_content/46-title.png">
      <img class="halfScale 46-sub" style="top:383px;left:166px" src="/114/es/static/_content/46-sub.png">
      <img class="halfScale 46-line" style="top:385px;left:124px" src="/114/es/static/_content/46-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg46Anim = new TimelineMax()
        pg46Anim.fromTo(cOf("46-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("46-line"), 0.6, {y:46, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("46-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg46Anim.stop()
      }
      `,
            "searchText": "GR AN PREMIO  GRAN PREMIO DE ESGRIMA DE TURÍN TURÍN, ITALIA DE 7 AL 9 DE FEBRERO DE 2020",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/turin.jpg" >
        <p><strong>TURÍN, ITALIA<br>
        DE 7 AL 9 DE FEBRERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 46,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg47.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg47Anim = new TimelineMax()
        pg47Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg47Anim.stop()
      }
      `,
            "searchText": "GRAN PREMIO DE ESGRIMA DE TURÍN TURÍN, ITALIA 2/3  El estadounidense Gerek Meinhardt y la francesa Ysaora Thibus ganaron las medallas de oro individuales en el Gran Premio de Esgrima de Turín. En este tercer Gran Premio de la serie de nueve pruebas de la temporada 2019-2020 de la FIE, participaron 226 esgrimistas internacionales masculinos y 177 femeninos que compitieron en el Pala Alpitour de Turín. En el último partido de florete individual masculino, Meinhardt derrotó a su compañero de equipo, Alexander Massialas, por 15-8 para ganar la prueba. Massialas venció al francés, Roger Wallerand, en la ronda de semifinales, por 15-2, mientras que Meinhardt venció a  su compañero de equipo Race Imboden en la misma ronda, por 15-11. Cabe destacar que el campeón del mundo italiano, Alessio Foconi, fue derrotado en cuartos de final por Massialas, por 15-9, y Meinhardt ganó contra el campeón del mundo ruso, Alexey Cheremisinov, en octavos de final, por 15-12. Thibus se enfrentó a la estadounidense Lee Kiefer por la medalla de oro en florete individual femenino, ganando por un solo toque, por 1514. Kiefer obtuvo una reñida victoria contra la W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>El estadounidense Gerek Meinhardt y la francesa Ysaora Thibus ganaron las medallas de oro individuales en el Gran Premio de Esgrima de Turín.
      </b></p>
      <p>En este tercer Gran Premio de la serie de nueve pruebas de la temporada 2019-2020 de la FIE, participaron 226 esgrimistas internacionales masculinos y 177 femeninos que compitieron en el Pala Alpitour de Turín.
      </p>
      <p>En el último partido de florete individual masculino, Meinhardt derrotó a su compañero de equipo, Alexander Massialas, por 15-8 para ganar la prueba. Massialas venció al francés, Roger Wallerand, en la ronda de semifinales, por 15-2, mientras que Meinhardt venció a su compañero de equipo Race Imboden en la misma ronda, por 15-11. Cabe destacar que el campeón del mundo italiano, Alessio Foconi, fue derrotado en cuartos de final por Massialas, por 15-9, y Meinhardt ganó contra el campeón del mundo ruso, Alexey Cheremisinov, en octavos de final, por 15-12.
      </p>
      
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 47,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg48.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg48Anim = new TimelineMax()
        pg48Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg48Anim.stop()
      }
      `,
            "searchText": "Roger Wallerand (FRA, bronce), Alessio Foconi (ITA), Erwann Le Pechoux (FRA), Kwanghyun Lee (KOR) y Kirill Borodachev (RUS).   GRAN PREMIO DE ESGRIMA DE TURÍN TURÍN, ITALIA 3/3  Las clasificaciones de florete femeninas incluyeron a Ysaora Thibus (FRA, oro), Lee Kiefer (USA, plata), Inna Deriglazova (RUS, bronce), Alice Volpi (ITA, bronce), Elisa Di Francisca (ITA), Arianna Errigo (ITA), Anastasiia Ivanova (RUS) y Yuka Ueno (JPN). . ■  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  campeona del mundo italiana, Alice Volpi, en la semifinal, por 15-14, y Thibus venció a la campeona olímpica rusa y tricampeona del mundo, Inna Deriglazova, por 15-10. En cuartos de final, Thibus obtuvo otra ajustada victoria frente a la bicampeona del mundo italiana Arianna Errigo, por 15-13, y Kiefer obtuvo una victoria contra la italiana campeona olímpica y del mundo Elisa Di Francisca, por 15-6.  Las clasificaciones finales masculinas del Gran Premio de florete de Turín incluyeron a Gerek Meinhardt (USA, oro), Alexander Massialas (USA, plata), Race Imboden (USA, bronce), W W W.FIE .ORG",
            "mobileHtml": `
      <p>Thibus se enfrentó a la estadounidense Lee Kiefer por la medalla de oro en florete individual femenino, ganando por un solo toque, por 15-14. Kiefer obtuvo una reñida victoria contra la campeona del mundo italiana, Alice Volpi, en la semifinal, por 15-14, y Thibus venció a la campeona olímpica rusa y tricampeona del mundo, Inna Deriglazova, por 15-10. En cuartos de final, Thibus obtuvo otra ajustada victoria frente a la bicampeona del mundo italiana Arianna Errigo, por 15-13, y Kiefer obtuvo una victoria contra la italiana campeona olímpica y del mundo Elisa Di Francisca, por 15-6.
      </p>
      <p>Las clasificaciones finales masculinas del Gran Premio de florete de Turín incluyeron a Gerek Meinhardt (USA, oro), Alexander Massialas (USA, plata), Race Imboden (USA, bronce), Roger Wallerand (FRA, bronce), Alessio Foconi (ITA), Erwann Le Pechoux (FRA), Kwanghyun Lee (KOR) y Kirill Borodachev (RUS).  
      </p>
      <p>Las clasificaciones de florete femeninas incluyeron a Ysaora Thibus (FRA, oro), Lee Kiefer (USA, plata), Inna Deriglazova (RUS, bronce), Alice Volpi (ITA, bronce), Elisa Di Francisca (ITA), Arianna Errigo (ITA), Anastasiia Ivanova (RUS) y Yuka Ueno (JPN).
      </p>
      <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
      <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 48,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg49.jpg",
            "zoom": null,
            "content": `
        <a href="http://favero.com" target="_blank">
            <div class="contentLinkNone" style="top:769px;left:1000px;width:165px; height:55px;"></div>
          </a>
          `,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "",
            "mobileHtml": `
      
      <a href="http://favero.com" target="_blank">
        <img src="/114/es/static/_mobile/pg49.jpg">
      </a>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 49,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg50.jpg",
            "zoom": null,
            "content": `
        <a href="https://www.fencewithfun.com" target="_blank">
            <div class="contentLinkNone" style="top:769px;left:18px;width:614px; height:43px;"></div>
          </a>

          <a href="mailto:info@fencewithfun.com">
            <div class="contentLinkNone" style="top:940px;left:75px;width:219px; height:28px;"></div>
          </a>

          <a href="https://www.fencewithfun.com" target="_blank">
            <div class="contentLinkNone" style="top:942px;left:353px;width:214px; height:28px;"></div>
          </a>
          `,
            "script": ``,
            "searchText": "",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/pg50.jpg">
        `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 50,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg51.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 51-title" style="top:207px;left:866px" src="/114/es/static/_content/51-title.png">
      <img class="halfScale 51-sub" style="top:629px;left:911px" src="/114/es/static/_content/51-sub.png">
      <img class="halfScale 51-line" style="top:628px;left:868px" src="/114/es/static/_content/51-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
    
      `,
            "script": `
      function onPageEnter() {
        pg51Anim = new TimelineMax()
        pg51Anim.fromTo(cOf("51-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("51-line"), 0.6, {y:51, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("51-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg51Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE SABLE MASCULINO DE VARSOVIA VARSOVIA, HUNGRÍA DE 21 AL 23 DE FEBRERO DE 2020",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/warsaw.jpg" >
        <p><strong>VARSOVIA, POLONÍA<br>
        DE 21 AL 23 DE FEBRERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 51,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg52.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg52Anim = new TimelineMax()
        pg52Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg52Anim.stop()
      }
      `,
            "searchText": "COPA DEL MUNDO DE SABLE MASCULINO DE VARSOVIA VARSOVIA, POLONÍA 2/2  El doble campeón olímpico de Hungría, Aron Szilagyi, ganó la medalla de oro en la Copa del Mundo de sable masculino «Sable de Wolodyjowski» de Varsovia, y Francia se hizo con la victoria en la prueba de sable masculino. En la competencia, que se celebró en la Universidad de Educación Física de Varsovia, Józef Piłsudski, participaron equipos de 23 países y 208 esgrimistas individuales.  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  Szilagyi combatió al estadounidense Eli Dershwitz en el último partido, ganando con un resultado de 15-9. Dershwitz venció al campeón del mundo de Corea, Sanguk Oh, en la semifinal, por 15-11, mientras que el italiano, Luca Curatoli, se retiró en la misma ronda contra Szilagyi debido a una lesión. Cabe destacar que Curatoli derrotó al campeón del mundo coreano, Junghwan Kim, en octavos de final, por 15-9, y el campeón del mundo húngaro, Andras Szatmari, perdió en la ronda 32 contra el ruso Dmitriy Danilenko, por 15-13.  34, mientras que Polonia venció a Italia, por 4541. La medalla de bronce fue para Alemania tras derrotar a Italia, por 45-38.  Las clasificaciones finales de la Copa del Mundo de sable masculino individual de Varsovia incluyeron a Aron Szilagyi (HUN, oro), Eli Dershwitz (USA, plata), Luca Curatoli (ITA, bronce), Sanguk Oh (KOR, bronce), Max Hartung (GER), Bolade Apithy (FRA), Sandro Bazadze (GEO) y Luigi Samele (ITA).  Las clasificaciones por equipos incluyeron a Francia (oro), Corea (plata), Alemania (bronce), Italia, Irán, Hungría, Rusia y China. ■  En la prueba por equipos de sable masculino, Francia obtuvo una ajustada victoria contra Hungría en la ronda final, por 45-43. Corea venció a Alemania en la ronda de semifinales por 45W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>El doble campeón olímpico de Hungría, Aron Szilagyi, ganó la medalla de oro en la Copa del Mundo de sable masculino «Sable de Wolodyjowski» de Varsovia, y Francia se hizo con la victoria en la prueba de sable masculino.</b></p>
      <p>En la competencia, que se celebró en la Universidad de Educación Física de Varsovia, Józef Piłsudski, participaron equipos de 23 países y 208 esgrimistas individuales. 
      </p>
      <p>Szilagyi combatió al estadounidense Eli Dershwitz en el último partido, ganando con un resultado de 15-9. Dershwitz venció al campeón del mundo de Corea, Sanguk Oh, en la semifinal, por 15-11, mientras que el italiano, Luca Curatoli, se retiró en la misma ronda contra Szilagyi debido a una lesión. Cabe destacar que Curatoli derrotó al campeón del mundo coreano, Junghwan Kim, en octavos de final, por 15-9, y el campeón del mundo húngaro, Andras Szatmari, perdió en la ronda 32 contra el ruso Dmitriy Danilenko, por 15-13.
      </p>
      <p>En la prueba por equipos de sable masculino, Francia obtuvo una ajustada victoria contra Hungría en la ronda final, por 45-43. Corea venció a Alemania en la ronda de semifinales por 45-34, mientras que Polonia venció a Italia, por 45-41. La medalla de bronce fue para Alemania tras derrotar a Italia, por 45-38. 
      </p>
      <p>Las clasificaciones finales de la Copa del Mundo de sable masculino individual de Varsovia incluyeron a Aron Szilagyi (HUN, oro), Eli Dershwitz (USA, plata), Luca Curatoli (ITA, bronce), Sanguk Oh (KOR, bronce), Max Hartung (GER), Bolade Apithy (FRA), Sandro Bazadze (GEO) y Luigi Samele (ITA). 
      </p>
      <p>Las clasificaciones por equipos incluyeron a Francia (oro), Corea (plata), Alemania (bronce), Italia, Irán, Hungría, Rusia y China.
      </p>
      <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
      <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 52,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg53.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 53-title" style="top:132px;left:203px" src="/114/es/static/_content/53-title.png">
      <img class="halfScale 53-sub" style="top:315px;left:247px" src="/114/es/static/_content/53-sub.png">
      <img class="halfScale 53-line" style="top:312px;left:203px" src="/114/es/static/_content/53-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg53Anim = new TimelineMax()
        pg53Anim.fromTo(cOf("53-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("53-line"), 0.6, {y:53, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("53-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg53Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE FLORETE MASCULINO DE EL CAIRO EL CAIRO, EGIPTO DE 21 AL 23 DE FEBRERO DE 2020",
            "mobileHtml": `
        <img src="/114/es/static/_mobile/cairo.jpg" >
        <p><strong>EL CAIRO, EGIPTO<br>
        DE 21 AL 23 DE FEBRERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 53,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg54.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg54Anim = new TimelineMax()
        pg54Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg54Anim.stop()
      }
      `,
            "searchText": "En la prueba de espada masculina por equipos, EE. UU. venció a Rusia en la ronda final, por 4536, para llevarse el oro. Rusia venció a Francia en la ronda de semifinales, por 45-38, mientras que EE. UU. derrotó a Hong Kong, por 45-37. Hong Kong se llevó la medalla de bronce contra Francia por un solo toque, por 45-44.   COPA DEL MUNDO DE FLORETE MASCULINO DE EL CAIRO EL CAIRO, EGIPTO 2/2  El español, Carlos Llavador, ganó el oro individual en la Copa del Mundo de florete masculino de El Cairo, y Estados Unidos ganó la prueba por equipos masculinos. En el pabellón Cairo Stadium Indoor Halls Complex participaron 180 competidores internacionales y equipos de 19 países. PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  Llavador se enfrentó al campeón del mundo italiano, Andrea Cassara, en el último partido y ganó con un resultado de 15-6. Cassara venció a su compañero de equipo y campeón del mundo, Alessio Foconi, en la semifinal por 15-11, mientras que Llavador venció al estadounidense, Alexander Massialas, por 15-3. Cabe destacar que los campeones del mundo Enzo Lefort (FRA), Alexey Cheremisinov (RUS) y Dmitry Zherebchenko (RUS) perdieron en octavos de final.   Las clasificaciones finales de la Copa del Mundo de florete masculino individual de El Cairo incluyeron a Carlos Llavador (ESP, oro), Andrea Cassara (ITA, plata), Alessio Foconi (ITA, bronce), Alexander Massialas (USA, bronce), Gerek Meinhardt (USA), Kwanghyun Lee (KOR), Chun Yin Ryan Choi (HKG) y Toshiya Saito (JPN).  Las clasificaciones para la prueba por equipos de florete masculino incluyeron a EE. UU. (oro), Rusia (plata), Hong Kong (bronce), Francia, Japón, Egipto, Italia y Corea. ■  W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>El español, Carlos Llavador, ganó el oro individual en la Copa del Mundo de florete masculino de El Cairo, y Estados Unidos ganó la prueba por equipos masculinos.</b></p>
      <p>En el pabellón Cairo Stadium Indoor Halls Complex participaron 180 competidores internacionales y equipos de 19 países..
      </p>
      <p>Llavador se enfrentó al campeón del mundo italiano, Andrea Cassara, en el último partido y ganó con un resultado de 15-6. Cassara venció a su compañero de equipo y campeón del mundo, Alessio Foconi, en la semifinal por 15-11, mientras que Llavador venció al estadounidense, Alexander Massialas, por 15-3. Cabe destacar que los campeones del mundo Enzo Lefort (FRA), Alexey Cheremisinov (RUS) y Dmitry Zherebchenko (RUS) perdieron en octavos de final.
      </p>
      <p>En la prueba de espada masculina por equipos, EE. UU. venció a Rusia en la ronda final, por 45-36, para llevarse el oro. Rusia venció a Francia en la ronda de semifinales, por 45-38, mientras que EE. UU. derrotó a Hong Kong, por 45-37. Hong Kong se llevó la medalla de bronce contra Francia por un solo toque, por 45-44. 
      </p>
      <p>Las clasificaciones finales de la Copa del Mundo de florete masculino individual de El Cairo incluyeron a Carlos Llavador (ESP, oro), Andrea Cassara (ITA, plata), Alessio Foconi (ITA, bronce), Alexander Massialas (USA, bronce), Gerek Meinhardt (USA), Kwanghyun Lee (KOR), Chun Yin Ryan Choi (HKG) y Toshiya Saito (JPN). 
      </p>
      <p>Las clasificaciones para la prueba por equipos de florete masculino incluyeron a EE. UU. (oro), Rusia (plata), Hong Kong (bronce), Francia, Japón, Egipto, Italia y Corea.
      </p>
      <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
      <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 54,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg55.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 55-title" style="top:138px;left:865px" src="/114/es/static/_content/55-title.png">
      <img class="halfScale 55-sub" style="top:563px;left:911px" src="/114/es/static/_content/55-sub.png">
      <img class="halfScale 55-line" style="top:565px;left:867px" src="/114/es/static/_content/55-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg55Anim = new TimelineMax()
        pg55Anim.fromTo(cOf("55-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("55-line"), 0.6, {y:26, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("55-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg55Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE FLORETE FEMENINO DE KAZÁN KAZÁN, RUSIA DE 21 AL 23 DE FEBRERO DE 2020",
            "mobileHtml": `
      <img src="/114/es/static/_mobile/kazan.jpg" >
      <p><strong>KAZÁN, RUSIA<br>
      DE 21 AL 23 DE FEBRERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 55,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg56.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg56Anim = new TimelineMax()
        pg56Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg56Anim.stop()
      }
      `,
            "searchText": "COPA DEL MUNDO DE FLORETE FEMENINO DE KAZÁN KAZÁN, RUSIA 2/2  La italiana campeona olímpica y del mundo, Elisa Di Francisca, obtuvo la medalla de oro individual en la Copa del Mundo de florete femenino de Kazán, e Italia también se hizo con la victoria en la prueba por equipos de florete femenino. La competencia, celebrada en el Centro de Gimnasia de Kazán, atrajo a 152 floretistas femeninas internacionales y equipos de 18 países.  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  Di Francisca ganó por un escaso margen en el último partido contra la china Yue Shi, por 9-8. Shi venció a la rusa, Adelina Zagidullina, en la ronda de semifinales, por 15-10, y Di Francisca derrotó a su compañera de equipo y campeona del mundo, Alice Volpi, por 15-7. Cabe destacar que la campeona olímpica rusa y tricampeona del mundo, Inna Deriglazova, perdió contra Shi en cuartos de final, por 15-12, y la italiana dos veces campeona del mundo, Arianna Errigo, cayó en la ronda 32 contra la japonesa Rio Azuma, por 15-13. En la prueba por equipos de sable femenino, Francia venció a Hungría en el último partido, por 45-27. EE. UU. venció a Polonia en la semifinal, por 45-36, mientras que Italia derrotó a Francia,  por 45-28. La medalla de bronce fue para Francia tras derrotar a Polonia, por 45-41.  Las mejores clasificaciones en la Copa del Mundo de florete femenino individual de Kazán incluyeron a Elisa Di Francisca (ITA, oro), Yue Shi (CHN, plata), Alice Volpi (ITA, bronce), Adelina Zagidullina (RUS, bronce), Inna Deriglazova (RUS), Aida Mohamed (HUN), Fanni Kreiss (HUN) y Rio Azuma (JPN).  Los equipos mejor clasificados fueron Italia (oro), EE. UU. (plata), Francia (bronce), Polonia, Rusia, Hungría, Japón y Alemania. ■ W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>La italiana campeona olímpica y del mundo, Elisa Di Francisca, obtuvo la medalla de oro individual en la Copa del Mundo de florete femenino de Kazán, e Italia también se hizo con la victoria en la prueba por equipos de florete femenino.</b></p>
      <p>La competencia, celebrada en el Centro de Gimnasia de Kazán, atrajo a 152 floretistas femeninas internacionales y equipos de 18 países.
      </p>
      <p>Di Francisca ganó por un escaso margen en el último partido contra la china Yue Shi, por 9-8. Shi venció a la rusa, Adelina Zagidullina, en la ronda de semifinales, por 15-10, y Di Francisca derrotó a su compañera de equipo y campeona del mundo, Alice Volpi, por 15-7. Cabe destacar que la campeona olímpica rusa y tricampeona del mundo, Inna Deriglazova, perdió contra Shi en cuartos de final, por 15-12, y la italiana dos veces campeona del mundo, Arianna Errigo, cayó en la ronda 32 contra la japonesa Rio Azuma, por 15-13.
      </p>
      <p>En la prueba por equipos de sable femenino, Francia venció a Hungría en el último partido, por 45-27. EE. UU. venció a Polonia en la semifinal, por 45-36, mientras que Italia derrotó a Francia, por 45-28. La medalla de bronce fue para Francia tras derrotar a Polonia, por 45-41.
      </p>
      <p>Las mejores clasificaciones en la Copa del Mundo de florete femenino individual de Kazán incluyeron a Elisa Di Francisca (ITA, oro), Yue Shi (CHN, plata), Alice Volpi (ITA, bronce), Adelina Zagidullina (RUS, bronce), Inna Deriglazova (RUS), Aida Mohamed (HUN), Fanni Kreiss (HUN) y Rio Azuma (JPN). 
      </p>
      <p>Los equipos mejor clasificados fueron Italia (oro), EE. UU. (plata), Francia (bronce), Polonia, Rusia, Hungría, Japón y Alemania.
      </p>
      <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
      <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 56,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg58.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 58-title" style="top:165px;left:85px" src="/114/es/static/_content/58-title.png">
      <img class="halfScale 58-sub" style="top:345px;left:126px" src="/114/es/static/_content/58-sub.png">
      <img class="halfScale 58-line" style="top:345px;left:83px" src="/114/es/static/_content/58-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg58Anim = new TimelineMax()
        pg58Anim.fromTo(cOf("58-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("58-line"), 0.6, {y:26, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("58-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg58Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE SABLE FEMENINO DE ATENAS ATENAS, GRECIA DE 6 AL 8 DE MARZO DE 2020",
            "mobileHtml": `
      <img src="/114/es/static/_mobile/athens.jpg" >
      <p><strong>ATENAS, GRECIA<br>
      DE 6 AL 8 DE MARZO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 57,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg59.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg59Anim = new TimelineMax()
        pg59Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg59Anim.stop()
      }
      `,
            "searchText": "mundo rusa, Sofia Pozdniakova, en cuartos de final,  COPA DEL MUNDO DE SABLE FEMENINO DE ATENAS ATENAS, GRECIA 2/2  por 15-13, y Pozdniakova venció a su compañera de equipo y campeona olímpica, Yana Egorian, en octavos de final, por 15-12. Rusia derrotó a Italia en el último partido de la prueba de sable femenino por equipos, por 45-35. Italia venció a Polonia en la semifinal, por 45-31, y Rusia venció por un escaso margen a Hungría, por 45-44.  La estadounidense dos veces medallista de oro olímpica y doble campeona del mundo, Mariel Zagunis, ganó la Copa del Mundo de sable femenino «Coupe Acropolis 2020» de Atenas, y Rusia se llevó el oro en la prueba de sable femenino por equipos.  Suiza se llevó la medalla de bronce frente a Polonia, por 45-36. Las clasificaciones finales de la prueba individual de sable femenino incluyeron a Mariel Zagunis (USA, oro), Liza Pusztai (HUN, plata), Misaki Emura (JPN, bronce), Theodora Gkountoura (GRE, bronce), Sofia Pozdniakova (RUS), Anna Marton (HUN), Rossella Gregorio (ITA) y Dagmara Wozniak (USA).  En la competencia, que tuvo lugar en el Complejo  PULSE AQUÍ para ver los resultados  Olímpico de Atenas, participaron 200 esgrimistas de  En la prueba por equipos de sable femenino, la  sable femenino internacionales, así como equipos de  clasificación final incluyó a Rusia (oro), Italia (plata),  24 países.  Hungría (bronce), Polonia, Corea, España, Francia y China. ■  Zagunis se enfrentó a la húngara, Liza Pusztaien,en la final de la prueba individual de sable femenino, que  PULSE AQUÍ para ver la serie de YouTube de la FIE  ganó con un resultado de 15-6. Pusztai venció a la griega, Theodora Gkountoura, en la semifinal, por 159, mientras que Zagunis derrotó a la japonesa, Misaki Emura, por 15-8. Emura derrotó a la campeona del W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>La estadounidense dos veces medallista de oro olímpica y doble campeona del mundo, Mariel Zagunis, ganó la Copa del Mundo de sable femenino «Coupe Acropolis 2020» de Atenas, y Rusia se llevó el oro en la prueba de sable femenino por equipos.</b></p>
      <p>En la competencia, que tuvo lugar en el Complejo Olímpico de Atenas, participaron 200 esgrimistas de sable femenino internacionales, así como equipos de 24 países.
      </p>
      <p>Zagunis se enfrentó a la húngara, Liza Pusztaien,en la final de la prueba individual de sable femenino, que ganó con un resultado de 15-6. Pusztai venció a la griega, Theodora Gkountoura, en la semifinal, por 15-9, mientras que Zagunis derrotó a la japonesa, Misaki Emura, por 15-8. Emura derrotó a la campeona del mundo rusa, Sofia Pozdniakova, en cuartos de final, por 15-13, y Pozdniakova venció a su compañera de equipo y campeona olímpica, Yana Egorian, en octavos de final, por 15-12. 
      </p>
      <p>Rusia derrotó a Italia en el último partido de la prueba de sable femenino por equipos, por 45-35. Italia venció a Polonia en la semifinal, por 45-31, y Rusia venció por un escaso margen a Hungría, por 45-44. Suiza se llevó la medalla de bronce frente a Polonia, por 45-36.
      </p>
      <p>Las clasificaciones finales de la prueba individual de sable femenino incluyeron a Mariel Zagunis (USA, oro), Liza Pusztai (HUN, plata), Misaki Emura (JPN, bronce), Theodora Gkountoura (GRE, bronce), Sofia Pozdniakova (RUS), Anna Marton (HUN), Rossella Gregorio (ITA) y Dagmara Wozniak (USA).
      </p>
      <p>En la prueba por equipos de sable femenino, la clasificación final incluyó a Rusia (oro), Italia (plata), Hungría (bronce), Polonia, Corea, España, Francia y China.
      </p>
      <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
      <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 58,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg60.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 60-title" style="top:162px;left:75px" src="/114/es/static/_content/60-title.png">
      <img class="halfScale 60-sub" style="top:361px;left:117px" src="/114/es/static/_content/60-sub.png">
      <img class="halfScale 60-line" style="top:358px;left:73px" src="/114/es/static/_content/60-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg60Anim = new TimelineMax()
        pg60Anim.fromTo(cOf("60-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("60-line"), 0.6, {y:26, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("60-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg60Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  COPA DEL MUNDO DE SABLE MASCULINO DE LUXEMBURGO LUXEMBURGO, LUXEMBURGO DE 6 AL 8 DE MARZO DE 2020",
            "mobileHtml": `
      <img src="/114/es/static/_mobile/luxembourg.jpg" >
      <p><strong>LUXEMBURGO, LUXEMBURGO<br>
      DE 6 AL 8 DE MARZO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 59,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg61.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg61Anim = new TimelineMax()
        pg61Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg61Anim.stop()
      }
      `,
            "searchText": "En el sable por equipos, Corea derrotó a Italia en la ronda final para ganar el oro, por 45-32. Italia venció a Hungría en semifinales, por 45-42, y Hungría derrotó a Suiza, por 45-37. Por la medalla de bronce, Alemania venció a Hungría por un solo punto, por 45-44.  COPA DEL MUNDO DE SABLE MASCULINO DE LUXEMBURGO LUXEMBURGO, LUXEMBURGO 2/2  El dos veces medallista de oro olímpico de Hungría, Aron Szilagyi, se llevó la medalla de oro en la Copa del Mundo de sable masculino de Luxemburgo, y Corea ganó la prueba por equipos.  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  La competencia, que tuvo lugar en el Centro Nacional de Esgrima y en el complejo deportivo del Liceo de Garçons de Luxemburgo, atrajo a 173 competidores internacionales individuales y equipos de 24 países.  Las clasificaciones finales de la prueba individual de la Copa del Mundo de sable masculino de Luxemburgo incluyeron a Aron Szilagyi (HUN, oro), Bongil Gu (KOR, plata), Sanguk Oh (KOR, bronce), Veniamin Reshetnikov (RUS, bronce), Luca Curatoli (ITA), Eli Dershwitz (USA), Luigi Samele (ITA) y Vincent Anstett (FRA). En el caso de la prueba por equipos del sable masculino, las clasificaciones incluyeron a Corea (oro), Hungría (plata), Italia (bronce), Alemania, Francia, Rusia, Irán y Estados Unidos. ■  Szilagyi se enfrentó al coreano. Bongil Gu. en la ronda final de sable masculino individual, ganando con un resultado de 15-12. Gu venció a su compañero de equipo y campeón del mundo Sanguk Oh en la semifinal, por 15-8, y Szilagyi venció al campeón del mundo ruso, Veniamin Reshetnikov, por 15-9. W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>El dos veces medallista de oro olímpico de Hungría, Aron Szilagyi, se llevó la medalla de oro en la Copa del Mundo de sable masculino de Luxemburgo, y Corea ganó la prueba por equipos.</b></p>
      <p>La competencia, que tuvo lugar en el Centro Nacional de Esgrima y en el complejo deportivo del Liceo de Garçons de Luxemburgo, atrajo a 173 competidores internacionales individuales y equipos de 24 países.
      </p>
      <p>Szilagyi se enfrentó al coreano. Bongil Gu. en la ronda final de sable masculino individual, ganando con un resultado de 15-12. Gu venció a su compañero de equipo y campeón del mundo Sanguk Oh en la semifinal, por 15-8, y Szilagyi venció al campeón del mundo ruso, Veniamin Reshetnikov, por 15-9.
      </p>
      <p>
      En el sable por equipos, Corea derrotó a Italia en la ronda final para ganar el oro, por 45-32. Italia venció a Hungría en semifinales, por 45-42, y Hungría derrotó a Suiza, por 45-37. Por la medalla de bronce, Alemania venció a Hungría por un solo punto, por 45-44.
      </p>
      <p>Las clasificaciones finales de la prueba individual de la Copa del Mundo de sable masculino de Luxemburgo incluyeron a Aron Szilagyi (HUN, oro), Bongil Gu (KOR, plata), Sanguk Oh (KOR, bronce), Veniamin Reshetnikov (RUS, bronce), Luca Curatoli (ITA), Eli Dershwitz (USA), Luigi Samele (ITA) y Vincent Anstett (FRA).
      </p>
      <p>En el caso de la prueba por equipos del sable masculino, las clasificaciones incluyeron a Corea (oro), Hungría (plata), Italia (bronce), Alemania, Francia, Rusia, Irán y Estados Unidos.
      </p>
      <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
      <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 60,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg62.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 62-title" style="top:114px;left:89px" src="/114/es/static/_content/62-title.png">
      <img class="halfScale 62-sub" style="top:263px;left:744px" src="/114/es/static/_content/62-sub.png">
      <img class="halfScale 62-line" style="top:267px;left:701px" src="/114/es/static/_content/62-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg62Anim = new TimelineMax()
        pg62Anim.fromTo(cOf("62-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("62-line"), 0.6, {y:26, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("62-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg62Anim.stop()
      }
      `,
            "searchText": "C OPA DEL MUNDO  EL GRAN PREMIO DE ESPADA MASCULINA Y FEMENINA DE BUDAPEST, HUNGRÍA DE 6 AL 8 DE MARZO DE 2020 BUDAPEST",
            "mobileHtml": `
      <img src="/114/es/static/_mobile/budapest.jpg" >
      <p><strong>BUDAPEST, HUNGRÍA<br>
      DE 6 AL 8 DE MARZO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 61,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg63.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg63Anim = new TimelineMax()
        pg63Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg63Anim.stop()
      }
      `,
            "searchText": "EL GRAN PREMIO DE ESPADA MASCULINA Y FEMENINA DE BUDAPEST BUDAPEST, HUNGRÍA 2/3  El japonés, Masaru Yamada, ganó la medalla de oro de la prueba masculina individual en el Gran Premio de espada de Westend y la francesa, Alexandra Louis Marie, se llevó el oro en la prueba femenina. La competencia, que tuvo lugar en el Ludovika Arena de Budapest, contó con la participación de 303 hombres y 268 mujeres esgrimistas internacionales y fue el cuarto Gran Premio de la serie de nueve pruebas de la temporada 2019-2020 de la FIE.  En el último partido de la prueba de espada individual masculina, Yamada derrotó al campeón del mundo francés Yannick Borel, por 15-11. Borel venció al kazajo, Vadim Sharlaimov, en la semifinal, por 15-12, mientras que Yamada derrotó al ucraniano Igor Reizlin, por 12-11. En cuartos de final, Reizlin derrotó al medallista de oro olímpico italiano, Matteo Tagliariol, por 15-10. Louis Marie se enfrentó a la coreana, Sera Song, en la final de la prueba individual de espada femenina, y ganó con un resultado de 15-13. Song venció a la francesa, Helene Ngom, en las semifinales, por 15-13, y Louis Marie derrotó a la estonia Irina Embrich, por 15-8. Cabe destacar W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>El japonés, Masaru Yamada, ganó la medalla de oro de la prueba masculina individual en el Gran Premio de espada de Westend y la francesa, Alexandra Louis Marie, se llevó el oro en la prueba femenina.</b></p>
      <p>La competencia, que tuvo lugar en el Ludovika Arena de Budapest, contó con la participación de 303 hombres y 268 mujeres esgrimistas internacionales y fue el cuarto Gran Premio de la serie de nueve pruebas de la temporada 2019-2020 de la FIE.
      </p>
      <p>En el último partido de la prueba de espada individual masculina, Yamada derrotó al campeón del mundo francés Yannick Borel, por 15-11. Borel venció al kazajo, Vadim Sharlaimov, en la semifinal, por 15-12, mientras que Yamada derrotó al ucraniano Igor Reizlin, por 12-11. En cuartos de final, Reizlin derrotó al medallista de oro olímpico italiano, Matteo Tagliariol, por 15-10.
      </p>
      <p>Louis Marie se enfrentó a la coreana, Sera Song, en la final de la prueba individual de espada femenina, y ganó con un resultado de 15-13. Song venció a la francesa, Helene Ngom, en las semifinales, por 15-13, y Louis Marie derrotó a la estonia Irina Embrich, por 15-8. Cabe destacar que en octavos de final, Embrich ganó contra la campeona del mundo brasileña, Nathalie Moellhausen, por 15-13; Louis Marie venció a la campeona del mundo rusa, Tatiana Gudkova, por 15-12; y la italiana, Giulia Rizzi, venció a la campeona del mundo italiana, Mara Navarria, por 12-6.
      </p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 62,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg64.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/red-twitter.png">
      </a>
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/red-facebook.png">
      </a>
      <a href="https://fie.org/competitions" target="_blank">
            <img class="halfScaleC pointer halfpulse animatedpulse" style="top:705px;left:61px" src="/114/es/static/_content/red-trophy.png">
      </a>
      <a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:872px;left:49px" src="/114/es/static/_content/red-yt.png">
      </a>
      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/red-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
          function onPageEnter() {
        pg64Anim = new TimelineMax()
        pg64Anim.fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg64Anim.stop()
      }
      `,
            "searchText": "EL GRAN PREMIO DE ESPADA MASCULINA Y FEMENINA DE BUDAPEST BUDAPEST, HUNGRÍA 3/3  PULSE AQUÍ para ver los resultados  PULSE AQUÍ para ver la serie de YouTube de la FIE  que en octavos de final, Embrich ganó contra la campeona del mundo brasileña, Nathalie Moellhausen, por 15-13; Louis Marie venció a la campeona del mundo rusa, Tatiana Gudkova, por 15-12; y la italiana, Giulia Rizzi, venció a la campeona del mundo italiana, Mara Navarria, por 12-6. Las clasificaciones finales de la prueba individual de espada masculina del Gran Premio de Budapest incluyeron a Masaru Yamada (JPN, oro), Yannick Borel (FRA, plata),  Igor Reizlin (UKR, bronce), Vadim Sharlaimov (KAZ, bronce), Kazuyasu Minobe (JPN), Matteo Tagliariol (ITA), Daniel Berta (HUN) y Andras Peterdi (HUN). En el caso de la prueba individual de espada femenina, las clasificaciones finales incluyeron a Alexandra Louis Marie (FRA, oro), Sera Song (KOR, plata), Irina Embrich (EST, bronce), Helene Ngom (FRA, bronce), Injeong Choi (KOR), Giulia Rizzi (ITA), Martyna Swatowska (POL) y Josephine Jacques Andre Coquin (FRA). ■ W W W.FIE .ORG",
            "mobileHtml": `
      <p>
      Las clasificaciones finales de la prueba individual de espada masculina del Gran Premio de Budapest incluyeron a Masaru Yamada (JPN, oro), Yannick Borel (FRA, plata), Igor Reizlin (UKR, bronce), Vadim Sharlaimov (KAZ, bronce), Kazuyasu Minobe (JPN), Matteo Tagliariol (ITA), Daniel Berta (HUN) y Andras Peterdi (HUN).
      </p>
      <p>En el caso de la prueba individual de espada femenina, las clasificaciones finales incluyeron a Alexandra Louis Marie (FRA, oro), Sera Song (KOR, plata), Irina Embrich (EST, bronce), Helene Ngom (FRA, bronce), Injeong Choi (KOR), Giulia Rizzi (ITA), Martyna Swatowska (POL) y Josephine Jacques Andre Coquin (FRA).
      </p>
      <p><a href="https://fie.org/competitions" target="_blank">Tap here</a> to view the results</p>
      <p><a href="https://www.youtube.com/playlist?list=PLdNA_ybrJjflVhQBfi03xW9fEn8k8Ta-x" target="_blank">Tap here</a> to link to our FIE YouTube series</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 63,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg65.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.jiangfencing.com" target="_blank">
            <div class="contentLinkNone" style="top:1000px;left:816px;width:223px; height:25px;"></div>
          </a>

          <a href="mailto:jason@jiangfencing.com">
            <div class="contentLinkNone" style="top:1025px;left:828px;width:239px; height:25px;"></div>
          </a>
          `,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "",
            "mobileHtml": `
      
      <a href="http://www.jiangfencing.com" target="_blank">
        <img src="/114/es/static/_mobile/pg65.jpg">
      </a>

      `
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 64,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg66.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 66-title" style="top:145px;left:83px" src="/114/es/static/_content/66-title.png">
   <img class="halfScale 66-sub" style="top:412px;left:119px" src="/114/es/static/_content/66-sub.png">
   <img class="halfScale 66-line" style="top:414px;left:83px" src="/114/es/static/_content/66-line.png">
   <img class="halfScale pointer green-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/green-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg66Anim = new TimelineMax()
        pg66Anim.fromTo(cOf("66-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("66-line"), 0.6, {y:26, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("66-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("green-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg66Anim.stop()
      }
      `,
            "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  LA ESGRIMA CRECE EN LAS ESCUELAS DE GHANA CON EL FESTIVAL Y LOS SEMINARIOS GHANA, ÁFRICA 31 DE ENERO DE 2020",
            "mobileHtml": `
      <h2>LA ESGRIMA CRECE EN LAS ESCUELAS DE GHANA CON EL FESTIVAL Y LOS SEMINARIOS</h2>
      <img src="/114/es/static/_mobile/ghana.jpg" >
      <p><strong>GHANA, ÁFRICA <br>
      31 DE ENERO DE 2020</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 65,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg67.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/green-twitter.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/green-facebook.png">
      </a>
      <img class="halfScale pointer s-green-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/s-green-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg67Anim = new TimelineMax()
        pg67Anim.fromTo(cOf("s-green-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg67Anim.stop()
      }
      `,
            "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/3  La esgrima está avanzando en Ghana. Actualmente, forma parte de la educación física general en las escuelas, y varios seminarios y un festival han contribuido a su expansión y crecimiento en el país. Como consecuencia de ello, el interés y la participación en la esgrima, tanto de los maestros como de los estudiantes, han aumentado rápidamente. Hace dos años, el Servicio de Educación de Ghana, una autoridad educativa gubernamental queforma parte de la Administración Pública de Ghana, reconoció la esgrima como una actividad extracurricular en las instituciones de enseñanza  básica, secundaria y universitaria. El GES también incluyó la esgrima en su Festival de Deportes de Escuelas y Universidades en la región nororiental del país, lo que despertó el interés por el deporte entre los educadores que se vieron obligados a aprender más sobre él.  Se organizaron varios seminarios para ayudar a formar a los maestros de deportes que ahora incluyen la esgrima en sus cursos de Educación física en todos los niveles de escolaridad; el primer programa atrajo a 50 entrenadores y el siguiente a 60. Gracias a ello, el interés por la esgrima está aumentando considerablemente y muchas escuelas están solicitando apoyo para el equipo, así como cursos técnicos y de entrenamiento adicionales que se impartirán en la Academia Nacional de Esgrima. Otras regiones, como el Servicio de Educación Regional de Brong-Ahafo, también están solicitando seminarios y eventos para fomentar el interés en la esgrima en sus regiones.  W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>La esgrima está avanzando en Ghana. Actualmente, forma parte de la educación física general en las escuelas, y varios seminarios y un festival han contribuido a su expansión y crecimiento en el país.</b></p>
      <p>Como consecuencia de ello, el interés y la participación en la esgrima, tanto de los maestros como de los estudiantes, han aumentado rápidamente.
      </p>
      <p>Hace dos años, el Servicio de Educación de Ghana, una autoridad educativa gubernamental queforma parte de la Administración Pública de Ghana, reconoció la esgrima como una actividad extracurricular en las instituciones de enseñanza básica, secundaria y universitaria. El GES también incluyó la esgrima en su Festival de Deportes de Escuelas y Universidades en la región nororiental del país, lo que despertó el interés por el deporte entre los educadores que se vieron obligados a aprender más sobre él.
      </p>
      <p>Se organizaron varios seminarios para ayudar a formar a los maestros de deportes que ahora incluyen la esgrima en sus cursos de Educación física en todos los niveles de escolaridad; el primer programa atrajo a 50 entrenadores y el siguiente a 60. Gracias a ello, el interés por la esgrima está aumentando considerablemente y muchas escuelas están solicitando apoyo para el equipo, así como cursos técnicos y de entrenamiento adicionales que se impartirán en la Academia Nacional de Esgrima. Otras regiones, como el Servicio de Educación Regional de Brong-Ahafo, también están solicitando seminarios y eventos para fomentar el interés en la esgrima en sus regiones.
      </p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 66,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg68.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale pointer xs-green-arrow" style="top:845px;left:1388px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/xs-green-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg68Anim = new TimelineMax()
        pg68Anim.fromTo(cOf("xs-green-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg68Anim.stop()
      }
      `,
            "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 3/3  «Me sentí muy honrado y dirigí los seminarios como parte de una retribución a la sociedad por los conocimientos que la FIE me proporcionó», dijo Mohammed Mahadi, vicepresidente de la Confederación Africana de Esgrima y presidente de la Asociación de Esgrima de Ghana. «Esto forma parte de mi contribución para hacer de la esgrima un deporte conocido en el país.» El Sr. Sas Hasaan, presidente de la Asociación de Esgrima de la Región de Ashanti, así como dos miembros del equipo nacional juvenil de  Ghana, Bertha Gakpetor y Awulatu Amadu, asistieron al Sr. Mahadi en la enseñanza de sus seminarios. «La esgrima se practica actualmente con regularidad en más de 110 escuelas de Ghana y esperamos que pronto se convierta en el deporte más popular del país», agregó el Sr. Mahadi. «Como vicepresidente de la Confederación Africana de Esgrima, trabajaré para asegurar que la esgrima forme parte de los Juegos de las Escuelas Secundarias de África». ■  W W W.FIE .ORG",
            "mobileHtml": `
      <p>«Me sentí muy honrado y dirigí los seminarios como parte de una retribución a la sociedad por los conocimientos que la FIE me proporcionó», dijo Mohammed Mahadi, vicepresidente de la Confederación Africana de Esgrima y presidente de la Asociación de Esgrima de Ghana. «Esto forma parte de mi contribución para hacer de la esgrima un deporte conocido en el país.»</p>
      <p>El Sr. Sas Hasaan, presidente de la Asociación de Esgrima de la Región de Ashanti, así como dos miembros del equipo nacional juvenil de Ghana, Bertha Gakpetor y Awulatu Amadu, asistieron al Sr. Mahadi en la enseñanza de sus seminarios.</p>
      <p>«La esgrima se practica actualmente con regularidad en más de 110 escuelas de Ghana y esperamos que pronto se convierta en el deporte más popular del país», agregó el Sr. Mahadi. «Como vicepresidente de la Confederación Africana de Esgrima, trabajaré para asegurar que la esgrima forme parte de los Juegos de las Escuelas Secundarias de África».</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 67,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg69.jpg",
            "zoom": null,
            "content": `
      <img class="halfScale 69-title" style="top:187px;left:83px" src="/114/es/static/_content/69-title.png">
      <img class="halfScale 69-sub" style="top:368px;left:121px" src="/114/es/static/_content/69-sub.png">
      <img class="halfScale 69-line" style="top:370px;left:83px" src="/114/es/static/_content/69-line.png">

      <img class="halfScale pointer red-arrow" style="top:845px;left:1408px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/green-arrow.png">
      `,
            "script": `
      function onPageEnter() {
        pg69Anim = new TimelineMax()
        pg69Anim.fromTo(cOf("69-title"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
          .fromTo(cOf("69-line"), 0.6, {y:26, opacity:0}, {y:0, opacity:1}, "-=0.2")
          .fromTo(cOf("69-sub"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
          .fromTo(cOf("red-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, "-=0.2")
      }

      function onPageLeave() {
        pg69Anim.stop()
      }
      `,
            "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIÓNES NACIONALES  BANGLADESH EN LOS JUEGOS DE ASIA MERIDIONAL KATHMANDÚ, NEPAL DE 1 AL 9 DE DICIEMBRE DE 2019",
            "mobileHtml": `
      <h2>BANGLADESH EN LOS JUEGOS DE ASIA MERIDIONAL</h2>
      <img src="/114/es/static/_mobile/bangladesh.jpg" >
      <p><strong>KATHMANDÚ, NEPAL<br>
      DE 1 AL 9 DE DICIEMBRE DE 2019</strong></p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 68,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg70.jpg",
            "zoom": null,
            "content": `
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:54px" src="/114/es/static/_content/green-twitter.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pointer halfpulse animatedpulse" style="top:422px;left:123px" src="/114/es/static/_content/green-facebook.png">
      </a>
      <img class="halfScale pointer green-arrow" style="top:845px;left:1387px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/xs-green-arrow.png">
      <a href="https://fie.org" target="_blank">
        <div class="contentLinkNone" style="top:1111px;left:1331px;width:131px; height:30px;"></div>
      </a>
      
      <a href="https://www.13sagnepal.com/sport/fencing/" target="_blank">
        <div class="contentLinkNone" style="top:1011px;left:979px;width:51px; height:30px;"></div>
      </a>
      `,
            "script": `
      function onPageEnter() {
        pg70Anim = new TimelineMax()
        pg70Anim.fromTo(cOf("green-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)
      }

      function onPageLeave() {
        pg70Anim.stop()
      }
      `,
            "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  La Asociación de Esgrima de Bangladesh está reportando resultados sólidos para su propio equipo y una exitosa serie de 12 pruebas de esgrima en los 13.º Juegos de Asia Meridional, celebrados en Katmandú en diciembre. Los Juegos incluyen 28 deportes diferentes que compiten durante diez días en siete naciones. Cinco países —Bangladesh, la India, Nepal, Pakistán y Sri Lanka— participaron en la competencia de esgrima en las tres armas, tanto masculina como femenina. La India casi arrasó en la esgrima a nivel general, ganando 11 de las 12 medallas de oro. Los encuentros de esgrima tuvieron lugar en el Kirtipur Covered Hall de Katmandú.  declaró la Asociación de Esgrima de Bangladesh en un comunicado. «Consideramos que nuestra esgrima ha mejorado mucho más que en los últimos años».  «Nos esforzamos al máximo para mejorar las técnicas de nuestros esgrimistas y los entrenamos contratando a expertos en esgrima de Irán y Camboya entre agosto y noviembre»,  Puede encontrar más información y un conjunto completo de tablas de competición y resultados aquí para los 13.º Juegos de Asia Meridional. ■  Bangladesh terminó en segundo lugar a nivel general en la competencia, incluyendo un oro en sable femenino individual para Fatema Mujib y 11 medallas en total.   W W W.FIE .ORG",
            "mobileHtml": `
      <p><b>La Asociación de Esgrima de Bangladesh está reportando resultados sólidos para su propio equipo y una exitosa serie de 12 pruebas de 
      esgrima en los 13.º Juegos de Asia Meridional, celebrados en Katmandú 
      en diciembre. </b></p>
      <p>Los Juegos incluyen 28 deportes diferentes que compiten durante diez días en siete naciones. Cinco países —Bangladesh, la India, Nepal, Pakistán y Sri Lanka— participaron en la competencia de esgrima en las tres armas, tanto masculina como femenina. La India casi arrasó en la esgrima a nivel general, ganando 11 de las 12 medallas de oro. Los encuentros de esgrima tuvieron lugar en el Kirtipur Covered Hall de Katmandú.
      </p>
      <p>«Nos esforzamos al máximo para mejorar las técnicas de nuestros esgrimistas y los entrenamos contratando a expertos en esgrima de Irán y Camboya entre agosto y noviembre», declaró la Asociación de Esgrima de Bangladesh en un comunicado. «Consideramos que nuestra esgrima ha mejorado mucho más que en los últimos años».
      </p>
      <p>Bangladesh terminó en segundo lugar a nivel general en la competencia, incluyendo un oro en sable femenino individual para Fatema Mujib y 11 medallas en total.</p>
      <p>Puede encontrar más información y un conjunto completo de tablas de competición y resultados <a href="https://www.13sagnepal.com/sport/fencing/" target="_blank">aquí</a> para los 13.º Juegos de Asia Meridional.
      </p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 69,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg72.jpg",
            "zoom": null,
            "content": `
              <img id="72-title" class="halfScale" style="top:132px;left:85px" src="/114/es/static/_content/72-title.png">

              <div class="addContentLink" onclick="showOverlay('72-pop')" style="top:603px;left:161px;width:241px;height:39px"></div>

              <div id="72-pop" class="standardTransition contentOverlay hidden noclick">
                <img id="" class="halfScale" style="top:0px;left:0px" src="/114/es/static/_content/72-pop.jpg">

                <div class="addContentLink" style="top: 53px; left: 1324px; width: 43px; height: 45px;opacity:0" onclick="hideOverlay('72-pop');"></div>
              </div>

              <a href="https://stageescrime.wixsite.com/temple-sur-lot" target="_blank">
                <div class="contentLinkNone" style="bottom:657px;right:283px;width:59px; height:28px;"></div>
              </a>

              <img id="72-arrow" class="halfScale pointer" style="top:938px;left:1174px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/72-arrow.png">
            `,
            "script": `
              function onPageEnter() {
                pg72Anim = new TimelineMax();
                  pg72Anim.fromTo(idOf("72-title"), 0.3,{y:100,opacity:0}, {y:0,opacity:1}, 0.5)
                  .fromTo(idOf("72-arrow"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks}, 0.75)
              }

              function onPageLeave() {
                pg72Anim.stop()
                  hideOverlay('72-pop');
                  removeContentLinks();
              }
            `,
            "searchText": "NOTICIAS  NOTICIAS DE LA FIE 2  1  Esgrimista olímpico crea una escultura  WWW.FIE.ORG  Campamento de espada, Base de plein air – Le temple-Sur-Lot Haga clic aquí para registrarse online en el campamento  Ver más aquí.  W W W.FIE .ORG",
            "mobileHtml": `
              <h4>Esgrimista olímpico crea una escultura</h4>
              <img src="/114/es/static/_mobile/news-1.jpg">
              <pEl escultor, profesor universitario de artes y esgrimista de espada olímpica Peter Schifrin (EE. UU.) ha recibido el encargo de crear una escultura de un lanzador de disco olímpico para EE. UU . Está previsto que el Museo Olímpico y Paralímpico,  abra a finales de este año. Schifrin ha llamado a su obra «Olympus Within».
              </p>
              <p>Schifrin, que compitió para EE. UU. en los Juegos Olímpicos de verano de Los Ángeles en 1984 y ha sido entrenador de esgrima, cree que aunque la escultura es una representación de un atleta de disco, el proyecto, sin embargo, representa a la esgrima: «Da lo mejor de ti, la práctica y la perseverancia para lograr tu objetivo, forman parte de este proyecto», dijo. «Estoy encantado de mostrar lo que sé del mundo del arte, del atletismo y de la esgrima para unirlo en un solo símbolo.»
              </p>
              <p>La esgrima y los esgrimistas han tenido un impacto significativo en el mundo y aparecen virtualmente en todas partes, señaló Schifrin según su propia experiencia. «Esto se debe en parte a la forma en que el deporte se extiende a muchos aspectos de la vida, del deporte y de la la cultura; un principio que aprendí en la esgrima enriqueció mi práctica artística», dijo. «...en la esgrima y el arte tenemos que practicar, practicar, practicar, pero luego damos el salto, nos arriesgamos y luchamos tenazmente para lograr nuestros objetivos». Ve la esgrima como un arte de combate y como una práctica espiritual que tiene en cuenta tanto el enfoque como la disciplina. Esta filosofía, junto con las habilidades desarrolladas para mantenerse centrado y en equilibrio bajo presión, puede aplicarse al disco, a la esgrima o al arte con el mismo beneficio, añadió Schifrin.
              </p>
              <p>Campamento de espada, Base de plein air – Le temple-Sur-Lot
              Haga <a href="https://stageescrime.wixsite.com/temple-sur-lot" target="_blank">clic aquí</a> para registrarse online en el campamento</p>
            `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 70,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg73.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.fencingsets.com" target="_blank">
          <div class="contentLinkNone" style="top:864px;left:283px;width:228px; height:30px;"></div>
        </a>

        <a href="mailto:755037302@qq.com">
          <div class="contentLinkNone" style="top:894px;left:283px;width:215px; height:30px;"></div>
        </a>

        <a href="mailto:1135864400@qq.com">
          <div class="contentLinkNone" style="top:894px;left:500px;width:173px; height:30px;"></div>
        </a>
      `,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "",
            "mobileHtml": `
        <a href="https://www.fencingsets.com" target="_blank">
          <img src="/114/es/static/_mobile/pg73.jpg">
        </a>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 71,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg74.jpg",
            "zoom": null,
            "content": `
        <a href="http://www.fie.org" target="_blank">
            <div class="contentLinkNone" style="bottom:5px;right:70px;width:130px; height:30px;"></div>
        </a>

        <img id="74-text-1" class="halfScale 74-text-1 74-text" style="top:387px;left:84px" src="/114/es/static/_content/74-text-1.png">
        <img id="74-text-2" class="halfScale 74-text-2 74-text" style="top:393px;left:82px; opacity:0;" src="/114/es/static/_content/74-text-2.png">
        <img id="74-text-3" class="halfScale 74-text-3 74-text" style="top:393px;left:82px; opacity:0;" src="/114/es/static/_content/74-text-3.png">

        <img id="74-cta-1" class="halfScale pointer 74-btn" style="top:454px;left:1135px" onclick="pg74Toggle('74-text-1', '74-cta-1');" src="/114/es/static/_content/74-cta-1.png">
        <img id="74-cta-2" class="halfScale pointer 74-btn" style="top:585px;left:1135px;opacity:0" onclick="pg74Toggle('74-text-2', '74-cta-2');" src="/114/es/static/_content/74-cta-2.png">
        <img id="74-cta-3" class="halfScale pointer 74-btn" style="top:717px;left:1136px;opacity:0" onclick="pg74Toggle('74-text-3', '74-cta-3');" src="/114/es/static/_content/74-cta-3.png">

        <img id="74-next" class="halfScale pointer" style="top:938px;left:1249px" onclick="Publish.goToNextPage()" src="/114/es/static/_content/74-arrow.png">
      `,
            "script": `
        function onPageEnter(){
          pg74Anim = new TimelineMax();
          pg74Anim.fromTo(idOf("74-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},"+=0.3")
        }

        function pg74Toggle(id, btn) {
          var ele = idOf(id)
          var but = idOf(btn)
          TweenMax.to(cOf("74-text"), 0.1, {opacity: 0});
          TweenMax.to(cOf("74-btn"), 0.1, {opacity: 0});
          TweenMax.to(ele, 0.1, {opacity: 1});
          TweenMax.to(but, 0.1, {opacity: 1});
        }

        function onPageLeave(){
          pg74Toggle('74-text-1', '74-cta-1');
          pg74Anim.stop();
          removeContentLinks()
        }
      `,
            "searchText": "RECUERDO  NECROLÓGICAS MARCELLO BAIOCCO (MH, ITA) Con gran tristeza, la FIE informa del fallecimiento de Marcello Baiocco el pasado 17 de febrero. Tenía 95 años.  PÁGINA 1  PÁGINA 2  Marcello Baiocco nació el 21 de marzo de 1924 en Roma. Se graduó como ingeniero electrotécnico en la Universidad de Roma. Practicó la esgrima de 1935 a 1945, luego, después de un largo descanso, volvió al deporte en 1965 junto al Club de Esgrima de Roma. Su distinguida carrera lo llevó a ser Presidente de la Comisión SEMI de 2000 a 2004 y Miembro de Honor de la Federación Italiana de Esgrima, así como miembro de la Comisión  W W W.FIE .ORG",
            "mobileHtml": `
      <h4>Marcello Baiocco (MH, ITA) </h4>
      <img src="/114/es/static/_mobile/obits.png">
      <p><b>
      Con gran tristeza, la FIE informa del fallecimiento de Marcello Baiocco el pasado 17 de febrero. Tenía 95 años.
      </b></p>
      <p>Marcello Baiocco nació el 21 de marzo de 1924 en Roma. Se graduó como ingeniero electrotécnico en la Universidad de Roma. 
      </p>
      <p>Practicó la esgrima de 1935 a 1945, luego, después de un largo descanso, volvió al deporte en 1965 junto al Club de Esgrima de Roma. Su distinguida carrera lo llevó a ser Presidente de la Comisión SEMI de 2000 a 2004 y Miembro de Honor de la Federación Italiana de Esgrima, así como miembro de la Comisión Técnica del Comité Olímpico Nacional Italiano, que le otorgó las Estrellas de plata y oro al Mérito Deportivo. 
      </p>
      <p>Puso en marcha el primer laboratorio técnico de esgrima, el «Laboratorio Scherma Marcello Baiocco», que sigue siendo el centro de certificación de la FIE para la inspección, la investigación y las pruebas técnicas de los aparatos y el equipo de esgrima, garantizando, así, su seguridad y homologación.</p>
      <p>Marcello Baiocco fue elegido Miembro de Honor de la FIE por el Congreso de 2009, y el Comité Ejecutivo de la FIE lo eligió como Miembro del Salón de la Fama de la FIE en 2014.</p>
      <p>Experto dotado y talentoso, contribuyó a proteger la seguridad de la esgrima y de los esgrimistas con total desinterés y dedicación incansable. La FIE y la familia de la esgrima han perdido a uno de sus miembros a quien todos apreciaban y respetaban.</p>
      <p>Ofrecemos nuestras más sinceras condolencias a sus amigos y familiares, y a la Federación de Esgrima de Italia, y expresamos nuestras más profundas condolencias en este difícil momento.</p>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 72,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg75.jpg",
            "zoom": null,
            "content": `
        <a href="https://www.blaise-freres.fr" target="_blank">
          <div class="contentLinkNone" style="bottom:331px;right:1053px;width:256px; height:30px;"></div>
        </a>
      `,
            "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
            "searchText": "Foils, epees, sabers  BF… the Best for Fencing SAS BLAISE FRERES ZI du Bec - Rue Antoine Lavoisier 42500 - LE CHAMBON-FEUGEROLLES – FRANCE https://www.blaise-freres.fr",
            "mobileHtml": `
        <a href="https://www.blaise-freres.fr" target="_blank">
          <img src="/114/es/static/_mobile/pg75.jpg">
        </a>
      `,
        }],
        [{
            "guid": "00000000-0000-0000-0000-000000000000",
            "title": "",
            "index": 73,
            "subIndex": 0,
            "startIndex": 0,
            "original": "pg76.jpg",
            "zoom": null,
            "content": `
          <a href="https://absolutefencinggear.com" target="_blank">
              <div class="contentLinkNone" style="top:1022px;left:372px;width:484px; height:47px;"></div>
            </a>
            `,
            "script": `
          function onPageEnter() {
          }
  
          function onPageLeave() {
          }
        `,
            "searchText": "",
            "mobileHtml": `
          <a href="https://absolutefencinggear.com" target="_blank">
            <img src="/114/es/static/_mobile/pg76.jpg">
          </a>
        `
        }]
    ],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
    "mobilePages": [{
            title: "Escrime XXI No. 114",
            cssClass: "cover mobile-p1",
            hideInMenu: false,
            pageLinks: [{
                index: 0,
                subIndex: 0
            }]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 2,
                subIndex: 0
            }]
        },

        {
            title: "Comex",
            cssClass: "aqua",
            hideInMenu: false,
            pageLinks: [{
                index: 4,
                subIndex: 0
            }]
        },

        {
            title: "PRÓLOGO",
            cssClass: "aqua",
            hideInMenu: false,
            pageLinks: [{
                index: 5,
                subIndex: 0
            }]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 6,
                subIndex: 0
            }]
        },
        {
            title: "FIE",
            cssClass: "purple",
            hideInMenu: false,
            pageLinks: [{
                index: 7,
                subIndex: 0
            }]
        },
        {
            title: "ESGRIMISTAS",
            cssClass: "purple",
            hideInMenu: false,
            pageLinks: [{
                    index: 8,
                    subIndex: 0
                },
                {
                    index: 9,
                    subIndex: 0
                },
                {
                    index: 10,
                    subIndex: 0
                },
                {
                    index: 11,
                    subIndex: 0
                },
                {
                    index: 12,
                    subIndex: 0
                },
                {
                    index: 13,
                    subIndex: 0
                },
                {
                    index: 15,
                    subIndex: 0
                },
                {
                    index: 16,
                    subIndex: 0
                },
                {
                    index: 17,
                    subIndex: 0
                },
                {
                    index: 18,
                    subIndex: 0
                },
                {
                    index: 19,
                    subIndex: 0
                },
                {
                    index: 20,
                    subIndex: 0
                },
                {
                    index: 21,
                    subIndex: 0
                },
                {
                    index: 22,
                    subIndex: 0
                },
                {
                    index: 23,
                    subIndex: 0
                },
            ]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 14,
                subIndex: 0
            }]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 24,
                subIndex: 0
            }]
        },
        {
            title: "COPA DEL MUNDO DE ESPADA MASCULINA HEIDENHEIM",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 25,
                    subIndex: 0
                },
                {
                    index: 26,
                    subIndex: 0
                }
            ]
        },
        {
            title: "COPA DEL MUNDO DE FLORETE FEMENINO DE KATOWICE",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 27,
                    subIndex: 0
                },
                {
                    index: 28,
                    subIndex: 0
                }
            ]
        },
        {
            title: "COPA DEL MUNDO DE ESPADA FEMENINA DE LA HABANA",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 29,
                    subIndex: 0
                },
                {
                    index: 30,
                    subIndex: 0
                }
            ]
        },
        {
            title: "COPA DEL MUNDO DE FLORETE MASCULINO PARÍS",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 31,
                    subIndex: 0
                },
                {
                    index: 32,
                    subIndex: 0
                }
            ]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 33,
                subIndex: 0
            }]
        },
        {
            title: "EL GRAN PREMIO DE SABLE DE MONTREAL",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 34,
                    subIndex: 0
                },
                {
                    index: 35,
                    subIndex: 0
                },
                {
                    index: 36,
                    subIndex: 0
                }
            ]
        },
        {
            title: "EL GRAN PREMIO DE ESPADA DE DOHA",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 37,
                    subIndex: 0
                },
                {
                    index: 38,
                    subIndex: 0
                },
                {
                    index: 39,
                    subIndex: 0
                }
            ]
        },
        {
            title: "COPA DEL MUNDO DE ESGRIMA FEMENINA DE BARCELONA",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 40,
                    subIndex: 0
                },
                {
                    index: 41,
                    subIndex: 0
                }
            ]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 42,
                subIndex: 0
            }]
        },
        {
            title: "COPA DEL MUNDO DE ESGRIMA DE ESPADA MASCULINA VANCOUVER",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 43,
                    subIndex: 0
                },
                {
                    index: 44,
                    subIndex: 0
                }
            ]
        },
        {
            title: "GRAN PREMIO DE ESGRIMA DE TURÍN",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 45,
                    subIndex: 0
                },
                {
                    index: 46,
                    subIndex: 0
                },
                {
                    index: 47,
                    subIndex: 0
                }
            ]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 48,
                subIndex: 0
            }]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 49,
                subIndex: 0
            }]
        },
        {
            title: "COPA DEL MUNDO DE SABLE MASCULINO DE VARSOVIA",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 50,
                    subIndex: 0
                },
                {
                    index: 51,
                    subIndex: 0
                }
            ]
        },
        {
            title: "COPA DEL MUNDO DE FLORETE MASCULINO DE EL CAIRO",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 52,
                    subIndex: 0
                },
                {
                    index: 53,
                    subIndex: 0
                }
            ]
        },
        {
            title: "COPA DEL MUNDO DE FLORETE FEMENINO DE KAZÁN",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 54,
                    subIndex: 0
                },
                {
                    index: 55,
                    subIndex: 0
                }
            ]
        },
        {
            title: "COPA DEL MUNDO DE SABLE FEMENINO DE ATENAS",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 56,
                    subIndex: 0
                },
                {
                    index: 57,
                    subIndex: 0
                }
            ]
        },
        {
            title: "COPA DEL MUNDO DE SABLE MASCULINO DE LUXEMBURGO",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 58,
                    subIndex: 0
                },
                {
                    index: 59,
                    subIndex: 0
                }
            ]
        },
        {
            title: "EL GRAN PREMIO DE ESPADA MASCULINA Y FEMENINA DE BUDAPEST",
            cssClass: "red",
            hideInMenu: false,
            pageLinks: [{
                    index: 60,
                    subIndex: 0
                },
                {
                    index: 61,
                    subIndex: 0
                },
                {
                    index: 62,
                    subIndex: 0
                }
            ]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 63,
                subIndex: 0
            }]
        },
        {
            title: "NOTICIAS DE LA FIE Y DE LAS FEDERACIÓNES NACIONALES",
            cssClass: "green",
            hideInMenu: false,
            pageLinks: [{
                    index: 64,
                    subIndex: 0
                },
                {
                    index: 65,
                    subIndex: 0
                },
                {
                    index: 66,
                    subIndex: 0
                },
                {
                    index: 67,
                    subIndex: 0
                },
                {
                    index: 68,
                    subIndex: 0
                }
            ]
        },
        {
            title: "NOTICIAS DE LA FIE",
            cssClass: "yellow",
            hideInMenu: false,
            pageLinks: [{
                index: 69,
                subIndex: 0
            }]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 70,
                subIndex: 0
            }]
        },
        {
            title: "NECROLÓGICAS",
            cssClass: "grey",
            hideInMenu: false,
            pageLinks: [{
                index: 71,
                subIndex: 0
            }]
        },
        {
            title: "Advert",
            cssClass: "advert",
            hideInMenu: true,
            pageLinks: [{
                index: 72,
                subIndex: 0
            }]
        }
    ],
    "mobileTemplate": null,
}


// WEBPACK FOOTER //
// ./src/document.js